/*
@license
  Impulse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/impulse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/ 

window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

theme.config = {
  bpSmall: false,
  hasSessionStorage: true,
  hasLocalStorage: true,
  mediaQuerySmall: 'screen and (max-width: '+ 769 +'px)',
  youTubeReady: false,
  vimeoReady: false,
  vimeoLoading: false,
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
  stickyHeader: false,
  rtl: document.documentElement.getAttribute('dir') == 'rtl' ? true : false
};

if (theme.config.isTouch) {
  document.documentElement.className += ' supports-touch';
}

if (console && console.log) {
  console.log('Theme successfully loaded');
}

theme.recentlyViewed = {
  recent: {}, // will store handle+url of recent products
  productInfo: {} // will store product data to reduce API calls
};

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.expFactor = 4;

(function(){
  'use strict';

  theme.delegate = {
    on: function(event, callback, options){
      if( !this.namespaces ) // save the namespaces on the DOM element itself
        this.namespaces = {};
  
      this.namespaces[event] = callback;
      options = options || false;
  
      this.addEventListener(event.split('.')[0], callback, options);
      return this;
    },
    off: function(event) {
      if (!this.namespaces) { return }
      this.removeEventListener(event.split('.')[0], this.namespaces[event]);
      delete this.namespaces[event];
      return this;
    }
  };
  
  // Extend the DOM with these above custom methods
  window.on = Element.prototype.on = theme.delegate.on;
  window.off = Element.prototype.off = theme.delegate.off;
  
  theme.utils = {
    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    },
  
    wrap: function(el, wrapper) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    },
  
    debounce: function(wait, callback, immediate) {
      var timeout;
      return function() {
        var context = this, args = arguments;
        var later = function() {
          timeout = null;
          if (!immediate) callback.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) callback.apply(context, args);
      }
    },
  
    throttle: function(limit, callback) {
      var waiting = false;
      return function () {
        if (!waiting) {
          callback.apply(this, arguments);
          waiting = true;
          setTimeout(function () {
            waiting = false;
          }, limit);
        }
      }
    },
  
    prepareTransition: function(el, callback) {
      el.addEventListener('transitionend', removeClass);
  
      function removeClass(evt) {
        el.classList.remove('is-transitioning');
        el.removeEventListener('transitionend', removeClass);
      }
  
      el.classList.add('is-transitioning');
      el.offsetWidth; // check offsetWidth to force the style rendering
  
      if (typeof callback === 'function') {
        callback();
      }
    },
  
    // _.compact from lodash
    // Creates an array with all falsey values removed. The values `false`, `null`,
    // `0`, `""`, `undefined`, and `NaN` are falsey.
    // _.compact([0, 1, false, 2, '', 3]);
    // => [1, 2, 3]
    compact: function(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];
  
      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },
  
    serialize: function(form) {
      var arr = [];
      Array.prototype.slice.call(form.elements).forEach(function(field) {
        if (
          !field.name ||
          field.disabled ||
          ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
        )
          return;
        if (field.type === 'select-multiple') {
          Array.prototype.slice.call(field.options).forEach(function(option) {
            if (!option.selected) return;
            arr.push(
              encodeURIComponent(field.name) +
                '=' +
                encodeURIComponent(option.value)
            );
          });
          return;
        }
        if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
          return;
        arr.push(
          encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
        );
      });
      return arr.join('&');
    }
  };
  
  theme.a11y = {
    trapFocus: function(options) {
      var eventsName = {
        focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
        focusout: options.namespace
          ? 'focusout.' + options.namespace
          : 'focusout',
        keydown: options.namespace
          ? 'keydown.' + options.namespace
          : 'keydown.handleFocus'
      };
  
      // Get every possible visible focusable element
      var focusableEls = options.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])');
      var elArray = [].slice.call(focusableEls);
      var focusableElements = elArray.filter(el => el.offsetParent !== null);
  
      var firstFocusable = focusableElements[0];
      var lastFocusable = focusableElements[focusableElements.length - 1];
  
      if (!options.elementToFocus) {
        options.elementToFocus = options.container;
      }
  
      options.container.setAttribute('tabindex', '-1');
      options.elementToFocus.focus();
  
      document.documentElement.off('focusin');
      document.documentElement.on(eventsName.focusout, function() {
        document.documentElement.off(eventsName.keydown);
      });
  
      document.documentElement.on(eventsName.focusin, function(evt) {
        if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;
  
        document.documentElement.on(eventsName.keydown, function(evt) {
          _manageFocus(evt);
        });
      });
  
      function _manageFocus(evt) {
        if (evt.keyCode !== 9) return;
        /**
         * On the first focusable element and tab backward,
         * focus the last element
         */
        if (evt.target === firstFocusable && evt.shiftKey) {
          evt.preventDefault();
          lastFocusable.focus();
        }
      }
    },
    removeTrapFocus: function(options) {
      var eventName = options.namespace
        ? 'focusin.' + options.namespace
        : 'focusin';
  
      if (options.container) {
        options.container.removeAttribute('tabindex');
      }
  
      document.documentElement.off(eventName);
    },
  
    lockMobileScrolling: function(namespace, element) {
      var el = element ? element : document.documentElement;
      document.documentElement.classList.add('lock-scroll');
      el.on('touchmove' + namespace, function() {
        return true;
      });
    },
  
    unlockMobileScrolling: function(namespace, element) {
      document.documentElement.classList.remove('lock-scroll');
      var el = element ? element : document.documentElement;
      el.off('touchmove' + namespace);
    }
  };
  
  // Add class when tab key starts being used to show outlines
  document.documentElement.on('keyup.tab', function(evt) {
    if (evt.keyCode === 9) {
      document.documentElement.classList.add('tab-outline');
      document.documentElement.off('keyup.tab');
    }
  });
  
  /**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
   *   - When theme.settings.superScriptPrice is enabled, format cents in <sup> tag
   * - getBaseUnit - Splits unit price apart to get value + unit
   *
   */
  
  theme.Currency = (function() {
    var moneyFormat = '${{amount}}';
    var superScript = theme && theme.settings && theme.settings.superScriptPrice;
  
    function formatMoney(cents, format) {
      if (!format) {
        format = theme.settings.moneyFormat;
      }
  
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);
  
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ',');
        decimal = theme.utils.defaultTo(decimal, '.');
  
        if (isNaN(number) || number == null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';
  
        return dollarsAmount + centsAmount;
      }
  
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
  
          if (superScript && value && value.includes('.')) {
            value = value.replace('.', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
  
          if (superScript && value && value.includes('.')) {
            value = value.replace(',', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }
  
      return formatString.replace(placeholderRegex, value);
    }
  
    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }
  
      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }
  
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }
  
    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    }
  })();
  
  theme.Images = (function() {
  
    /**
     * Find the Shopify image attribute size
     */
    function imageSize(src) {
      if (!src) {
        return '620x'; // default based on theme
      }
  
      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
  
      if (match !== null) {
        return match[1];
      } else {
        return null;
      }
    }
  
    /**
     * Adds a Shopify size attribute to a URL
     */
    function getSizedImageUrl(src, size) {
      if (!src) {
        return src;
      }
  
      if (size == null) {
        return src;
      }
  
      if (size === 'master') {
        return this.removeProtocol(src);
      }
  
      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
  
      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];
  
        return this.removeProtocol(prefix[0] + '_' + size + suffix);
      }
  
      return null;
    }
  
    function removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    }
  
    function lazyloadImagePath(string) {
      var image;
  
      if (string !== null) {
        image = string.replace(/(\.[^.]*)$/, "_{width}x$1");
      }
  
      return image;
    }
  
    return {
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol,
      lazyloadImagePath: lazyloadImagePath
    };
  })();
  
  theme.loadImageSection = function(container) {
    // Wait until images inside container have lazyloaded class
    function setAsLoaded() {
      container.classList.remove('loading', 'loading--delayed');
      container.classList.add('loaded');
    }
  
    function checkForLazyloadedImage() {
      return container.querySelector('.lazyloaded');
    }
  
    // If it has SVGs it's in the onboarding state so set as loaded
    if (container.querySelector('svg')) {
      setAsLoaded();
      return;
    };
  
    if (checkForLazyloadedImage()) {
      setAsLoaded();
      return;
    }
  
    var interval = setInterval(function() {
      if (checkForLazyloadedImage()) {
        clearInterval(interval);
        setAsLoaded();
      }
    }, 80);
  };
  
  // Init section function when it's visible, then disable observer
  theme.initWhenVisible = function(options) {
    var threshold = options.threshold ? options.threshold : 0;
  
    var observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (typeof options.callback === 'function') {
            options.callback();
            observer.unobserve(entry.target);
          }
        }
      });
    }, {rootMargin: '0px 0px '+ threshold +'px 0px'});
  
    observer.observe(options.element);
  };
  
  theme.LibraryLoader = (function() {
    var types = {
      link: 'link',
      script: 'script'
    };
  
    var status = {
      requested: 'requested',
      loaded: 'loaded'
    };
  
    var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';
  
    var libraries = {
      youtubeSdk: {
        tagId: 'youtube-sdk',
        src: 'https://www.youtube.com/iframe_api',
        type: types.script
      },
      vimeo: {
        tagId: 'vimeo-api',
        src: 'https://player.vimeo.com/api/player.js',
        type: types.script
      },
      shopifyXr: {
        tagId: 'shopify-model-viewer-xr',
        src: cloudCdn + 'shopify-xr-js/assets/v1.0/shopify-xr.en.js',
        type: types.script
      },
      modelViewerUi: {
        tagId: 'shopify-model-viewer-ui',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.en.js',
        type: types.script
      },
      modelViewerUiStyles: {
        tagId: 'shopify-model-viewer-ui-styles',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
        type: types.link
      }
    };
  
    function load(libraryName, callback) {
      var library = libraries[libraryName];
  
      if (!library) return;
      if (library.status === status.requested) return;
  
      callback = callback || function() {};
      if (library.status === status.loaded) {
        callback();
        return;
      }
  
      library.status = status.requested;
  
      var tag;
  
      switch (library.type) {
        case types.script:
          tag = createScriptTag(library, callback);
          break;
        case types.link:
          tag = createLinkTag(library, callback);
          break;
      }
  
      tag.id = library.tagId;
      library.element = tag;
  
      var firstScriptTag = document.getElementsByTagName(library.type)[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  
    function createScriptTag(library, callback) {
      var tag = document.createElement('script');
      tag.src = library.src;
      tag.addEventListener('load', function() {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }
  
    function createLinkTag(library, callback) {
      var tag = document.createElement('link');
      tag.href = library.src;
      tag.rel = 'stylesheet';
      tag.type = 'text/css';
      tag.addEventListener('load', function() {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }
  
    return {
      load: load
    };
  })();
  
  theme.rteInit = function() {
    // Wrap tables so they become scrollable on small screens
    document.querySelectorAll('.rte table').forEach(table => {
      var wrapWith = document.createElement('div');
      wrapWith.classList.add('table-wrapper');
      theme.utils.wrap(table, wrapWith);
    });
  
    // Wrap video iframe embeds so they are responsive
    document.querySelectorAll('.rte iframe[src*="youtube.com/embed"]').forEach(iframe => {
      wrapVideo(iframe);
    });
    document.querySelectorAll('.rte iframe[src*="player.vimeo"]').forEach(iframe => {
      wrapVideo(iframe);
    });
  
    function wrapVideo(iframe) {
      // Reset the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      iframe.src = iframe.src;
      var wrapWith = document.createElement('div');
      wrapWith.classList.add('video-wrapper');
      theme.utils.wrap(iframe, wrapWith);
    }
  
    // Remove CSS that adds animated underline under image links
    document.querySelectorAll('.rte a img').forEach(img => {
      img.parentNode.classList.add('rte__image');
    });
  }
  
  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
  
    document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
    document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
    document.addEventListener('shopify:section:select', this._onSelect.bind(this));
    document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
    document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
    document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };
  
  theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function(container, constructor, scope) {
      var id = container.getAttribute('data-section-id');
      var type = container.getAttribute('data-section-type');
  
      constructor = constructor || this.constructors[type];
  
      if (typeof constructor === 'undefined') {
        return;
      }
  
      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (scope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          this._removeInstance(id);
        }
      }
  
      var instance = Object.assign(new constructor(container), {
        id: id,
        type: type,
        container: container
      });
  
      this.instances.push(instance);
    },
  
    _findInstance: function(id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },
  
    _removeInstance: function(id) {
      var i = this.instances.length;
      var instance;
  
      while(i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }
  
      return instance;
    },
  
    _onSectionLoad: function(evt, subSection, subSectionId) {
      if (window.AOS) { AOS.refreshHard() }
      if (theme && theme.initGlobals) {
        theme.initGlobals();
      }
  
      var container = subSection ? subSection : evt.target;
      var section = subSection ? subSection : evt.target.querySelector('[data-section-id]');
  
      if (!section) {
        return;
      }
  
      this._createInstance(section);
  
      var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);
  
      // Check if we have subsections to load
      var haveSubSections = container.querySelectorAll('[data-subsection]');
      if (haveSubSections.length) {
        this.loadSubSections(container);
      }
  
      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === 'function') {
        instance.onLoad(evt);
      }
  
      // Force editor to trigger scroll event when loading a section
      setTimeout(function() {
        window.dispatchEvent(new Event('scroll'));
      }, 200);
    },
  
    _onSectionUnload: function(evt) {
      this.instances = this.instances.filter(function(instance) {
        var isEventInstance = instance.id === evt.detail.sectionId;
  
        if (isEventInstance) {
          if (typeof instance.onUnload === 'function') {
            instance.onUnload(evt);
          }
        }
  
        return !isEventInstance;
      });
    },
  
    loadSubSections: function(scope) {
      var sections = scope
                     ? scope.querySelectorAll('[data-subsection]')
                     : document.querySelectorAll('[data-subsection]');
  
      sections.forEach(el => {
        this._onSectionLoad(null, el, el.dataset.sectionId);
      });
  
      if (window.AOS) { AOS.refreshHard() }
    },
  
    _onSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onSelect === 'function'
      ) {
        instance.onSelect(evt);
      }
    },
  
    _onDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onDeselect === 'function'
      ) {
        instance.onDeselect(evt);
      }
    },
  
    _onBlockSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockSelect === 'function'
      ) {
        instance.onBlockSelect(evt);
      }
    },
  
    _onBlockDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockDeselect === 'function'
      ) {
        instance.onBlockDeselect(evt);
      }
    },
  
    register: function(type, constructor, scope) {
      this.constructors[type] = constructor;
  
      var sections = document.querySelectorAll('[data-section-type="' + type + '"]');
  
      if (scope) {
        sections = scope.querySelectorAll('[data-section-type="' + type + '"]');
      }
  
      sections.forEach(
        function(container) {
          this._createInstance(container, constructor, scope);
        }.bind(this)
      );
    },
  
    reinit: function(section) {
      for (var i = 0; i < this.instances.length; i++) {
        var instance = this.instances[i];
        if (instance['type'] === section) {
          if (typeof instance.forceReload === 'function') {
            instance.forceReload();
          }
        }
      }
    }
  });
  
  theme.Variants = (function() {
  
    function Variants(options) {
      this.container = options.container;
      this.variants = options.variants;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.currentVariant = this._getVariantFromOptions();
  
      this.container.querySelectorAll(this.singleOptionSelector).forEach(el => {
        el.addEventListener('change', this._onSelectChange.bind(this));
      });
    }
  
    Variants.prototype = Object.assign({}, Variants.prototype, {
  
      _getCurrentOptions: function() {
        var result = [];
  
        this.container.querySelectorAll(this.singleOptionSelector).forEach(el => {
          var type = el.getAttribute('type');
  
          if (type === 'radio' || type === 'checkbox') {
            if (el.checked) {
              result.push({
                value: el.value,
                index: el.dataset.index
              });
            }
          } else {
            result.push({
              value: el.value,
              index: el.dataset.index
            });
          }
        });
  
        // remove any unchecked input values if using radio buttons or checkboxes
        result = theme.utils.compact(result);
  
        return result;
      },
  
      _getVariantFromOptions: function() {
        var selectedValues = this._getCurrentOptions();
        var variants = this.variants;
        var found = false;
  
        variants.forEach(function(variant) {
          var match = true;
          var options = variant.options;
  
          selectedValues.forEach(function(option) {
            if (match) {
              match = (variant[option.index] === option.value);
            }
          });
  
          if (match) {
            found = variant;
          }
        });
  
        return found || null;
      },
  
      _onSelectChange: function() {
        var variant = this._getVariantFromOptions();
  
        this.container.dispatchEvent(new CustomEvent('variantChange', {
          detail: {
            variant: variant
          }
        }));
  
        document.dispatchEvent(new CustomEvent('variant:change', {
          detail: {
            variant: variant
          }
        }));
  
        if (!variant) {
          return;
        }
  
        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateUnitPrice(variant);
        this._updateSKU(variant);
        this.currentVariant = variant;
  
        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
      },
  
      _updateImages: function(variant) {
        var variantImage = variant.featured_image || {};
        var currentVariantImage = this.currentVariant.featured_image || {};
  
        if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
          return;
        }
  
        this.container.dispatchEvent(new CustomEvent('variantImageChange', {
          detail: {
            variant: variant
          }
        }));
      },
  
      _updatePrice: function(variant) {
        if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
          return;
        }
  
        this.container.dispatchEvent(new CustomEvent('variantPriceChange', {
          detail: {
            variant: variant
          }
        }));
      },
  
      _updateUnitPrice: function(variant) {
        if (variant.unit_price === this.currentVariant.unit_price) {
          return;
        }
  
        this.container.dispatchEvent(new CustomEvent('variantUnitPriceChange', {
          detail: {
            variant: variant
          }
        }));
      },
  
      _updateSKU: function(variant) {
        if (variant.sku === this.currentVariant.sku) {
          return;
        }
  
        this.container.dispatchEvent(new CustomEvent('variantSKUChange', {
          detail: {
            variant: variant
          }
        }));
      },
  
      _updateHistoryState: function(variant) {
        if (!history.replaceState || !variant) {
          return;
        }
  
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({path: newurl}, '', newurl);
      },
  
      _updateMasterSelect: function(variant) {
        this.container.querySelector(this.originalSelectorId).value = variant.id;
      }
    });
  
    return Variants;
  })();
  
  window.vimeoApiReady = function() {
    theme.config.vimeoLoading = true;
  
    // Because there's no way to check for the Vimeo API being loaded
    // asynchronously, we use this terrible timeout to wait for it being ready
    checkIfVimeoIsReady()
      .then(function() {
        theme.config.vimeoReady = true;
        theme.config.vimeoLoading = false;
        document.dispatchEvent(new CustomEvent('vimeoReady'));
      });
  }
  
  function checkIfVimeoIsReady() {
    var wait;
    var timeout;
  
    var deferred = new Promise((resolve, reject) => {
      wait = setInterval(function() {
        if (!Vimeo) {
          return;
        }
  
        clearInterval(wait);
        clearTimeout(timeout);
        resolve();
      }, 500);
  
      timeout = setTimeout(function() {
        clearInterval(wait);
        reject();
      }, 4000); // subjective. test up to 8 times over 4 seconds
    });
  
    return deferred;
  }
  
  theme.VimeoPlayer = (function() {
    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    }
  
    var defaults = {
      background: true,
      byline: false,
      controls: false,
      loop: true,
      muted: true,
      playsinline: true,
      portrait: false,
      title: false
    };
  
    function VimeoPlayer(divId, videoId, options) {
      this.divId = divId;
      this.el = document.getElementById(divId);
      this.videoId = videoId;
      this.iframe = null;
      this.options = options;
  
      if (this.options && this.options.videoParent) {
        this.parent = this.el.closest(this.options.videoParent);
      }
  
      this.setAsLoading();
  
      if (theme.config.vimeoReady) {
        this.init();
      } else {
        theme.LibraryLoader.load('vimeo', window.vimeoApiReady);
        document.addEventListener('vimeoReady', this.init.bind(this));
      }
    }
  
    VimeoPlayer.prototype = Object.assign({}, VimeoPlayer.prototype, {
      init: function() {
        var args = defaults;
        args.id = this.videoId;
  
        this.videoPlayer = new Vimeo.Player(this.el, args);
  
        this.videoPlayer.ready().then(this.playerReady.bind(this));
      },
  
      playerReady: function() {
        this.iframe = this.el.querySelector('iframe');
        this.iframe.setAttribute('tabindex', '-1');
  
        this.videoPlayer.setMuted(true);
  
        this.setAsLoaded();
  
        // pause when out of view
        var observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.play();
            } else {
              this.pause();
            }
          });
        }, {rootMargin: '0px 0px 50px 0px'});
  
        observer.observe(this.iframe);
      },
  
      setAsLoading: function() {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },
  
      setAsLoaded: function() {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded);
        if (Shopify && Shopify.designMode) {
          if (window.AOS) {AOS.refreshHard()}
        }
      },
  
      enableInteraction: function() {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },
  
      play: function() {
        if (this.videoPlayer && typeof this.videoPlayer.play === 'function') {
          this.videoPlayer.play();
        }
      },
  
      pause: function() {
        if (this.videoPlayer && typeof this.videoPlayer.pause === 'function') {
          this.videoPlayer.pause();
        }
      },
  
      destroy: function() {
        if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
          this.videoPlayer.destroy();
        }
      }
    });
  
    return VimeoPlayer;
  })();
  
  window.onYouTubeIframeAPIReady = function() {
    theme.config.youTubeReady = true;
    document.dispatchEvent(new CustomEvent('youTubeReady'));
  }
  
  /*============================================================================
    YouTube SDK method
    Parameters:
      - player div id (required)
      - arguments
        - videoId (required)
        - videoParent (selector, optional for section loading state)
        - events (object, optional)
  ==============================================================================*/
  theme.YouTube = (function() {
    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    }
  
    var defaults = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        autoplay: 1,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        rel: 0
      }
    };
  
    function YouTube(divId, options) {
      this.divId = divId;
      this.iframe = null;
  
      this.attemptedToPlay = false;
  
      // API callback events
      defaults.events = {
        onReady: this.onVideoPlayerReady.bind(this),
        onStateChange: this.onVideoStateChange.bind(this)
      };
  
      this.options = Object.assign({}, defaults, options);
  
      if (this.options) {
        if (this.options.videoParent) {
          this.parent = document.getElementById(this.divId).closest(this.options.videoParent);
        }
  
        // Most YT videos will autoplay. If in product media,
        // will handle in theme.Product instead
        if (!this.options.autoplay) {
          this.options.playerVars.autoplay = this.options.autoplay;
        }
  
        if (this.options.style === 'sound') {
          this.options.playerVars.controls = 1;
          this.options.playerVars.autoplay = 0;
        }
  
      }
  
      this.setAsLoading();
  
      if (theme.config.youTubeReady) {
        this.init();
      } else {
        theme.LibraryLoader.load('youtubeSdk');
        document.addEventListener('youTubeReady', this.init.bind(this));
      }
    }
  
    YouTube.prototype = Object.assign({}, YouTube.prototype, {
      init: function() {
        this.videoPlayer = new YT.Player(this.divId, this.options);
      },
  
      onVideoPlayerReady: function(evt) {
        this.iframe = document.getElementById(this.divId); // iframe once YT loads
        this.iframe.setAttribute('tabindex', '-1');
  
        if (this.options.style !== 'sound') {
          evt.target.mute();
        }
  
        // pause when out of view
        var observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.play();
            } else {
              this.pause();
            }
          });
        }, {rootMargin: '0px 0px 50px 0px'});
  
        observer.observe(this.iframe);
      },
  
      onVideoStateChange: function(evt) {
        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (this.attemptedToPlay) {
              this.setAsLoaded();
              this.enableInteraction();
            }
            break;
          case 0: // ended, loop it
            this.play(evt);
            break;
          case 1: // playing
            this.setAsLoaded();
            break;
          case 3: // buffering
            this.attemptedToPlay = true;
            break;
        }
      },
  
      setAsLoading: function() {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },
  
      setAsLoaded: function() {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded);
        if (Shopify && Shopify.designMode) {
          if (window.AOS) {AOS.refreshHard()}
        }
      },
  
      enableInteraction: function() {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },
  
      play: function() {
        if (this.videoPlayer && typeof this.videoPlayer.playVideo === 'function') {
          this.videoPlayer.playVideo();
        }
      },
  
      pause: function() {
        if (this.videoPlayer && typeof this.videoPlayer.pauseVideo === 'function') {
          this.videoPlayer.pauseVideo();
        }
      },
  
      destroy: function() {
        if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
          this.videoPlayer.destroy();
        }
      }
    });
  
    return YouTube;
  })();
  

  theme.cart = {
    getCart: function() {
      var url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
      return fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      }).then(response => response.json());
    },
  
    getCartProductMarkup: function() {
      var url = ''.concat(theme.routes.cartPage, '?t=').concat(Date.now());
  
      url = url.indexOf('?') === -1 ? (url + '?view=ajax') : (url + '&view=ajax');
  
      return fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      })
      .then(function(response) {return response.text()});
    },
  
    changeItem: function(key, qty) {
      return this._updateCart({
        url: ''.concat(theme.routes.cartChange, '?t=').concat(Date.now()),
        data: JSON.stringify({
          id: key,
          quantity: qty
        })
      })
    },
    
    removeByProp: async function(prop) {
      const cart_data = await fetch('/cart.js');
      const cart = await cart_data.json();
      const cart_items = cart.items;
    
      const items_to_keep = [];
      for (const item of cart_items) {
        if (item.properties && (item.properties['_parent-saved-configuration-id'] === prop || item.properties['_saved-configuration-id'] === prop)) {
          continue;
        } else {
          items_to_keep.unshift({
            "quantity": item.quantity,
            "id": item.variant_id,
            "properties": item.properties
          })
        }
      }
    
      await fetch('/cart/clear.js');

      if (items_to_keep.length < 1) {
        window.top.location.reload();
        return;
      }
    
      const cart_add = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({"items": items_to_keep})
      });
      
      const cart_add_response = await cart_add.json();
      if (cart_add_response.items) {
        window.top.location.reload();
        return;
      } else {
        console.error(cart_add_response)
      }
    },
  
    _updateCart: function(params) {
      return fetch(params.url, {
        method: 'POST',
        body: params.data,
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.json())
      .then(function(cart) {
        return cart;
      });
    },
  
    updateAttribute: function(key, value) {
      return this._updateCart({
        url: '/cart/update.js',
        data: JSON.stringify({
          attributes: {
            [key]: theme.cart.attributeToString(value)
          }
        })
      });
    },
  
    updateNote: function(note) {
      return this._updateCart({
        url: '/cart/update.js',
        data: JSON.stringify({
          note: theme.cart.attributeToString(note)
        })
      });
    },
  
    attributeToString: function(attribute) {
      if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
          attribute = '';
        }
      }
      return attribute.trim();
    }
  }
  
  /*============================================================================
    CartForm
    - Prevent checkout when terms checkbox exists
    - Listen to quantity changes, rebuild cart (both widget and page)
  ==============================================================================*/
  theme.CartForm = (function() {
    var selectors = {
      products: '[data-products]',
      qtySelector: '.js-qty__wrapper',
      discounts: '[data-discounts]',
      savings: '[data-savings]',
      subTotal: '[data-subtotal]',
  
      cartBubble: '#CartBubble',
      cartNote: '[name="note"]',
      termsCheckbox: '.cart__terms-checkbox',
      checkoutBtn: '.cart__checkout',

      customRemoveBtn: '.custom-remove',
      showDetailsBtn: '.cart__item--simple-products-title'
    };
  
    var classes = {
      btnLoading: 'btn--loading'
    };
  
    var config = {
      requiresTerms: false
    };
  
    function CartForm(form) {
      if (!form) {
        return;
      }
  
      this.form = form;
      this.wrapper = form.parentNode;
      this.location = form.dataset.location;
      this.namespace = '.cart-' + this.location;
      this.products = form.querySelector(selectors.products)
      this.submitBtn = form.querySelector(selectors.checkoutBtn);
  
      this.discounts = form.querySelector(selectors.discounts);
      this.savings = form.querySelector(selectors.savings);
      this.subtotal = form.querySelector(selectors.subTotal);
      this.termsCheckbox = form.querySelector(selectors.termsCheckbox);
      this.noteInput = form.querySelector(selectors.cartNote);

      this.customRemoveBtns = form.querySelectorAll(selectors.customRemoveBtn);
      this.showDetailsBtns = form.querySelectorAll(selectors.showDetailsBtn);
  
      if (this.termsCheckbox) {
        config.requiresTerms = true;
      }
  
      this.init();
    }
  
    CartForm.prototype = Object.assign({}, CartForm.prototype, {
      init: function() {
        this.initQtySelectors();
  
        document.addEventListener('cart:quantity' + this.namespace, this.quantityChanged.bind(this));
        
        this.form.on('submit' + this.namespace, this.onSubmit.bind(this));
        
        this.customRemoveBtns.forEach(btn => {
          btn.on('click', function() {
            var partsToRemove = this.dataset.savedConfigurationId;
            theme.cart.removeByProp(partsToRemove);
          });
        });
  
        if (this.noteInput) {
          this.noteInput.addEventListener('change', function() {
            var newNote = this.value;
            theme.cart.updateNote(newNote);
          });
        }
  
        // Dev-friendly way to build the cart
        document.addEventListener('cart:build', function() {
          this.buildCart();
        }.bind(this));
      },
  
      reInit: function() {
        this.initQtySelectors();
      },
  
      onSubmit: function(evt) {
        this.submitBtn.classList.add(classes.btnLoading);
  
        if (config.requiresTerms) {
          if (this.termsCheckbox.checked) {
            // continue to checkout
          } else {
            this.submitBtn.classList.remove(classes.btnLoading)
            evt.preventDefault();
            return false;
          }
        }
      },
  
      /*============================================================================
        Query cart page to get markup
      ==============================================================================*/
      _parseProductHTML: function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        return {
          items: doc.querySelector('.cart__items'),
          discounts: doc.querySelector('.cart__discounts')
        }
      },
  
      buildCart: function() {
        theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this));
      },
  
      cartMarkup: function(html) {
        var markup = this._parseProductHTML(html);
        var items = markup.items;
        var count = parseInt(items.dataset.count);
        var subtotal = items.dataset.cartSubtotal;
        var savings = items.dataset.cartSavings;
  
        this.updateCartDiscounts(markup.discounts);
        this.updateSavings(savings);
  
        if (count > 0) {
          this.wrapper.classList.remove('is-empty');
        } else {
          this.wrapper.classList.add('is-empty');
        }
  
        this.updateCount(count);
  
        // Append item markup
        this.products.innerHTML = '';
        this.products.append(items);
  
        // Update subtotal
        this.subtotal.innerHTML = subtotal;
  
        this.reInit();
  
        if (window.AOS) { AOS.refreshHard() }
  
        if (Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }
      },
  
      updateCartDiscounts: function(markup) {
        this.discounts.innerHTML = '';
        this.discounts.append(markup);
      },
  
      /*============================================================================
        Quantity handling
      ==============================================================================*/
      initQtySelectors: function() {
        this.form.querySelectorAll(selectors.qtySelector).forEach(el => {
          var selector = new theme.QtySelector(el, {
            namespace: this.namespace
          });
        });
      },
  
      quantityChanged: function(evt) {
        var key = evt.detail[0];
        var qty = evt.detail[1];
  
        if (!key || !qty) {
          return;
        }
  
        theme.cart.changeItem(key, qty)
          .then(function(cart) {
            if (cart.item_count > 0) {
              this.wrapper.classList.remove('is-empty');
            } else {
              this.wrapper.classList.add('is-empty');
            }
  
            this.updateSuccess(cart, key);
  
            // Hide row now that it has no quantity
            if (qty == 0) {
              var row = this.form.querySelector('.cart__item[data-key="'+ key +'"]');
              row.classList.add('hide');
            }
          }.bind(this))
          .catch(function(XMLHttpRequest){});
      },
  
      /*============================================================================
        Update elements of the cart
      ==============================================================================*/
      updateSuccess: function(cart, key) {
        this.updateSubtotal(cart.total_price);
        this.updateCount(cart.item_count);
        this.updateSavings(cart.total_discount);
  
        // Reprint row
        this.updateRow(key);
  
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart: cart
          }
        }));
      },
  
      updateSubtotal: function(subtotal) {
        this.form.querySelector(selectors.subTotal).innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
      },
  
      updateSavings: function(savings) {
        if (!this.savings) {
          return;
        }
  
        if (savings > 0) {
          var amount = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
          this.savings.classList.remove('hide');
          this.savings.innerHTML = theme.strings.cartSavings.replace('[savings]', amount);
        } else {
          this.savings.classList.add('hide');
        }
      },
  
      updateCount: function(count) {
        var countEl = document.querySelector('.cart-link__bubble-num');
  
        if (countEl) {
          countEl.innerText = count;
        }
  
        // show/hide bubble
        if (count > 0) {
          document.querySelector(selectors.cartBubble).classList.add('cart-link__bubble--visible');
        } else {
          document.querySelector(selectors.cartBubble).classList.remove('cart-link__bubble--visible');
        }
      },
  
      // Reprint the updated row's price column
      // in case discounts have now been applied.
      // Also need to update the cart-wide discounts
      updateRow: function(key) {
        var row = this.form.querySelector('.cart__item[data-key="'+ key +'"]')
        if (!row) {
          return
        }
  
        var priceCol = row.querySelector('.cart__item-total-price-col');
  
        theme.cart.getCartProductMarkup().then(function(html) {
          var markup = this._parseProductHTML(html);
          var items = markup.items;
          var matchingPrice = items.querySelector('.cart__item[data-key="'+key+'"] .cart__item-total-price-col');
          if (matchingPrice) {
            priceCol.replaceWith(matchingPrice);
          }
  
          this.updateCartDiscounts(markup.discounts);
        }.bind(this));
      }
  
    });
  
    return CartForm;
  })();

  theme.sampleToggle = (function() {
    var selectors = {
      sampleToggleBtn: '[data-toggle-sample]'
    }

    var classes = {
      inCart: 'in-cart',
      loading: 'loading'
    }

    function init() {
      
      document.querySelectorAll(selectors.sampleToggleBtn).forEach(sampleToggleBtn => {
        
        sampleToggleBtn.on('click', function(){
          var sampleInCart = sampleToggleBtn.classList.contains(classes.inCart);
          var variant_id =  parseInt(this.dataset.toggleSample, 10);
          var urlencoded = new URLSearchParams();
          urlencoded.append('id', variant_id);

          if (sampleInCart) {
            urlencoded.append('quantity', 0);
                
            fetch(theme.routes.cartChange, {
              method: 'POST',
              body: urlencoded,
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
              }
            })
            .then(response => response.json())
            .then(function(data) {
              if (data.status === 422) {
                console.log('ERROR');
              } else {
                console.log('SUCCESS - Remove');
                this.classList.toggle(classes.inCart, false)
              }
            }.bind(this));
          } else {
            urlencoded.append('quantity', 1);
            fetch(theme.routes.cartAdd, {
              method: 'POST',
              body: urlencoded,
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
              }
            })
            .then(response => response.json())
            .then(function(data) {
              if (data.status === 422) {
                console.log('ERROR');
              } else {
                console.log('SUCCESS - Add');
                this.classList.toggle(classes.inCart, true)
              }
            }.bind(this));
          }
        });
      });
    }

    function markSamples() { 
      fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        var cartData = data;

        if (!cartData && !cartData.items && cartData.item_count === 0) return; // no items

        const products = cartData.items;
	      const variantIds = products.map(p => p = p.variant_id);

        document.querySelectorAll(selectors.sampleToggleBtn).forEach(sampleToggleBtn => {
          var variant_id =  parseInt(sampleToggleBtn.dataset.toggleSample, 10);
          sampleToggleBtn.classList.remove(classes.loading)
          if (variantIds.includes(variant_id)) {
            sampleToggleBtn.classList.toggle(classes.inCart, true)
          }
        });
      });

    }

    return {
      init: init,
      markSamples: markSamples
    };
  })();

  theme.drilldowns = (function() {

    var selectors = {
      drilldownRoot: '.drilldown-root',
      triggerDown: '.drilldown-trigger',
      triggerUp: '.drillup-trigger',
      module: '.drilldown-content'
    };
  
    var classes = {
      open: 'is-open',
      firstLevel: 'level-one-open'
    };

    var level = 0;
    var namespace = '.drilldown';

    function init(scope) {
      var el = scope ? scope : document;
      el.querySelectorAll(selectors.triggerDown).forEach(triggerDown => {
        var state = triggerDown.classList.contains(classes.open);
        triggerDown.setAttribute('aria-expanded', state);
  
        triggerDown.off('click' + namespace);
        triggerDown.on('click' + namespace, drillDown);
      });

      el.querySelectorAll(selectors.triggerUp).forEach(triggerUp => {
        triggerUp.off('click' + namespace);
        triggerUp.on('click' + namespace, drillUp);
      });
    }

    function drillDown(evt) {
      var el = evt.currentTarget;
      var moduleId = el.getAttribute('aria-controls');
      var container = document.getElementById(moduleId);
      var drilldownRootEl = container.closest(selectors.drilldownRoot);

      container.classList.add(classes.open);
      drilldownRootEl.classList.add(classes.firstLevel);

      var height = container.offsetHeight;
      drilldownRootEl.style.height = height+'px';
    }

    function drillUp(evt) {
      var el = evt.currentTarget;
      var container = el.closest(selectors.module);
      var drilldownRootEl = el.closest(selectors.drilldownRoot);
      
      container.classList.remove(classes.open);
      drilldownRootEl.classList.remove(classes.firstLevel);
      drilldownRootEl.style.height = 'auto';
    }

    return {
      init: init
    };

  })();
  
  theme.collapsibles = (function() {
    var selectors = {
      trigger: '.collapsible-trigger',
      module: '.collapsible-content',
      moduleInner: '.collapsible-content__inner'
    };
  
    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height'
    };
  
    var namespace = '.collapsible';
  
    var isTransitioning = false;
  
    function init(scope) {
      var el = scope ? scope : document;
      el.querySelectorAll(selectors.trigger).forEach(trigger => {
        var state = trigger.classList.contains(classes.open);
        trigger.setAttribute('aria-expanded', state);
  
        trigger.off('click' + namespace);
        trigger.on('click' + namespace, toggle);
      });
    }
  
    function toggle(evt) {
      if (isTransitioning) {
        return;
      }
  
      isTransitioning = true;
  
      var el = evt.currentTarget;
      var isOpen = el.classList.contains(classes.open);
      var moduleId = el.getAttribute('aria-controls');
      var container = document.getElementById(moduleId);

      if (el.hasAttribute('data-single-open')) {
        var close_in_id = el.dataset.singleOpen;
        document.querySelectorAll(`#${close_in_id} ${selectors.module}:not(#${moduleId})`).forEach(module => {
          setTransitionHeight(module, 0, false, false);
        });
        document.querySelectorAll(`#${close_in_id} ${selectors.trigger}:not(#${moduleId})`).forEach(trigger => {
          trigger.setAttribute('aria-expanded', false);
          trigger.classList.remove(classes.open);
        });
      }
  
      // If container=null, there isn't a matching ID.
      // Check if data-id is set instead. Could be multiple.
      // Select based on being in the same parent div.
      if (!container) {
        var multipleMatches = document.querySelectorAll('[data-id="' + moduleId + '"]');
        if (multipleMatches.length > 0) {
          container = el.parentNode.querySelector('[data-id="' + moduleId + '"]');
        }
      }
  
      if (!container) {
        isTransitioning = false;
        return;
      }
  
      var height = container.querySelector(selectors.moduleInner).offsetHeight;
      var isAutoHeight = container.classList.contains(classes.autoHeight);
      var parentCollapsibleEl = container.parentNode.closest(selectors.module);
      var childHeight = height;
  
      // If isAutoHeight, set the height to 0 just after setting the actual height
      // so the closing animation works nicely
      if (isOpen && isAutoHeight) {
        setTimeout(function() {
          height = 0;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        }, 0);
      }
  
      if (isOpen && !isAutoHeight) {
        height = 0;
      }
  
      el.setAttribute('aria-expanded', !isOpen);
      if (isOpen) {
        el.classList.remove(classes.open);
      } else {
        el.classList.add(classes.open);
      }
  
      setTransitionHeight(container, height, isOpen, isAutoHeight);
  
      // If we are in a nested collapsible element like the mobile nav,
      // also set the parent element's height
      if (parentCollapsibleEl) {
        var totalHeight = isOpen
                          ? parentCollapsibleEl.offsetHeight - childHeight
                          : height + parentCollapsibleEl.offsetHeight;
  
        setTransitionHeight(parentCollapsibleEl, totalHeight, false, false);
      }
  
      // If Shopify Product Reviews app installed,
      // resize container on 'Write review' click
      // that shows form
      if (window.SPR) {
        var btn = container.querySelector('.spr-summary-actions-newreview');
        if (!btn) { return }
        btn.off('click' + namespace);
        btn.on('click' + namespace, function() {
          height = container.querySelector(selectors.moduleInner).offsetHeight;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        });
      }
    }
  
    function setTransitionHeight(container, height, isOpen, isAutoHeight) {
      container.classList.remove(classes.hide);
      theme.utils.prepareTransition(container, function() {
        container.style.height = height+'px';
        if (isOpen) {
          container.classList.remove(classes.open);
        } else {
          container.classList.add(classes.open);
        }
      });
  
      if (!isOpen && isAutoHeight) {
        var o = container;
        window.setTimeout(function() {
          o.css('height','auto');
          isTransitioning = false;
        }, 500);
      } else {
        isTransitioning = false;
      }
    }
  
    return {
      init: init
    };
  })();
  
  // Shopify-built select-like popovers for currency and language selection
  theme.Disclosure = (function() {
    var selectors = {
      disclosureForm: '[data-disclosure-form]',
      disclosureList: '[data-disclosure-list]',
      disclosureToggle: '[data-disclosure-toggle]',
      disclosureInput: '[data-disclosure-input]',
      disclosureOptions: '[data-disclosure-option]'
    };
  
    var classes = {
      listVisible: 'disclosure-list--visible'
    };
  
    function Disclosure(disclosure) {
      this.container = disclosure;
      this._cacheSelectors();
      this._setupListeners();
    }
  
    Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
      _cacheSelectors: function() {
        this.cache = {
          disclosureForm: this.container.closest(selectors.disclosureForm),
          disclosureList: this.container.querySelector(selectors.disclosureList),
          disclosureToggle: this.container.querySelector(
            selectors.disclosureToggle
          ),
          disclosureInput: this.container.querySelector(
            selectors.disclosureInput
          ),
          disclosureOptions: this.container.querySelectorAll(
            selectors.disclosureOptions
          )
        };
      },
  
      _setupListeners: function() {
        this.eventHandlers = this._setupEventHandlers();
  
        this.cache.disclosureToggle.addEventListener(
          'click',
          this.eventHandlers.toggleList
        );
  
        this.cache.disclosureOptions.forEach(function(disclosureOption) {
          disclosureOption.addEventListener(
            'click',
            this.eventHandlers.connectOptions
          );
        }, this);
  
        this.container.addEventListener(
          'keyup',
          this.eventHandlers.onDisclosureKeyUp
        );
  
        this.cache.disclosureList.addEventListener(
          'focusout',
          this.eventHandlers.onDisclosureListFocusOut
        );
  
        this.cache.disclosureToggle.addEventListener(
          'focusout',
          this.eventHandlers.onDisclosureToggleFocusOut
        );
  
        document.body.addEventListener('click', this.eventHandlers.onBodyClick);
      },
  
      _setupEventHandlers: function() {
        return {
          connectOptions: this._connectOptions.bind(this),
          toggleList: this._toggleList.bind(this),
          onBodyClick: this._onBodyClick.bind(this),
          onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
          onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
          onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this)
        };
      },
  
      _connectOptions: function(event) {
        event.preventDefault();
  
        this._submitForm(event.currentTarget.dataset.value);
      },
  
      _onDisclosureToggleFocusOut: function(event) {
        var disclosureLostFocus =
          this.container.contains(event.relatedTarget) === false;
  
        if (disclosureLostFocus) {
          this._hideList();
        }
      },
  
      _onDisclosureListFocusOut: function(event) {
        var childInFocus = event.currentTarget.contains(event.relatedTarget);
  
        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );
  
        if (isVisible && !childInFocus) {
          this._hideList();
        }
      },
  
      _onDisclosureKeyUp: function(event) {
        if (event.which !== slate.utils.keyboardKeys.ESCAPE) return;
        this._hideList();
        this.cache.disclosureToggle.focus();
      },
  
      _onBodyClick: function(event) {
        var isOption = this.container.contains(event.target);
        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );
  
        if (isVisible && !isOption) {
          this._hideList();
        }
      },
  
      _submitForm: function(value) {
        this.cache.disclosureInput.value = value;
        this.cache.disclosureForm.submit();
      },
  
      _hideList: function() {
        this.cache.disclosureList.classList.remove(classes.listVisible);
        this.cache.disclosureToggle.setAttribute('aria-expanded', false);
      },
  
      _toggleList: function() {
        var ariaExpanded =
          this.cache.disclosureToggle.getAttribute('aria-expanded') === 'true';
        this.cache.disclosureList.classList.toggle(classes.listVisible);
        this.cache.disclosureToggle.setAttribute('aria-expanded', !ariaExpanded);
      },
  
      destroy: function() {
        this.cache.disclosureToggle.removeEventListener(
          'click',
          this.eventHandlers.toggleList
        );
  
        this.cache.disclosureOptions.forEach(function(disclosureOption) {
          disclosureOption.removeEventListener(
            'click',
            this.eventHandlers.connectOptions
          );
        }, this);
  
        this.container.removeEventListener(
          'keyup',
          this.eventHandlers.onDisclosureKeyUp
        );
  
        this.cache.disclosureList.removeEventListener(
          'focusout',
          this.eventHandlers.onDisclosureListFocusOut
        );
  
        this.cache.disclosureToggle.removeEventListener(
          'focusout',
          this.eventHandlers.onDisclosureToggleFocusOut
        );
  
        document.body.removeEventListener(
          'click',
          this.eventHandlers.onBodyClick
        );
      }
    });
  
    return Disclosure;
  })();
  
  theme.Drawers = (function() {
    function Drawers(id, name) {
      this.config = {
        id: id,
        close: '.js-drawer-close',
        open: '.js-drawer-open-' + name,
        openClass: 'js-drawer-open',
        closingClass: 'js-drawer-closing',
        activeDrawer: 'drawer--is-open',
        namespace: '.drawer-' + name
      };
  
      this.nodes = {
        page: document.querySelector('#MainContent')
      };
  
      this.drawer = document.querySelector('#' + id);
      this.isOpen = false;
  
      if (!this.drawer) {
        return;
      }
  
      this.init();
    }
  
    Drawers.prototype = Object.assign({}, Drawers.prototype, {
      init: function() {
        // Setup open button(s)
        document.querySelectorAll(this.config.open).forEach(openBtn => {
          openBtn.setAttribute('aria-expanded', 'false');
          openBtn.addEventListener('click', this.open.bind(this));
        });
  
        this.drawer.querySelector(this.config.close).addEventListener('click', this.close.bind(this));
  
        // Close modal if a drawer is opened
        document.addEventListener('modalOpen', function() {
          this.close();
        }.bind(this));
      },
  
      open: function(evt, returnFocusEl) {
        if (evt) {
          evt.preventDefault();
        }
  
        if (this.isOpen) {
          return;
        }
  
        // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
        if (evt && evt.stopPropagation) {
          evt.stopPropagation();
          // save the source of the click, we'll focus to this on close
          evt.currentTarget.setAttribute('aria-expanded', 'true');
          this.activeSource = evt.currentTarget;
        } else if (returnFocusEl) {
          returnFocusEl.setAttribute('aria-expanded', 'true');
          this.activeSource = returnFocusEl;
        }
  
        theme.utils.prepareTransition(this.drawer, function() {
          this.drawer.classList.add(this.config.activeDrawer);
        }.bind(this));
  
        document.documentElement.classList.add(this.config.openClass);
        this.isOpen = true;
  
        theme.a11y.trapFocus({
          container: this.drawer,
          namespace: 'drawer_focus'
        });
  
        document.dispatchEvent(new CustomEvent('drawerOpen'));
        document.dispatchEvent(new CustomEvent('drawerOpen.' + this.config.id));
  
        this.bindEvents();
      },
  
      close: function(evt) {
        if (!this.isOpen) {
          return;
        }
  
        // Do not close if click event came from inside drawer
        if (evt) {
          if (evt.target.closest('.js-drawer-close')) {
            // Do not close if using the drawer close button
          } else if (evt.target.closest('.drawer')) {
            return;
          }
        }
  
        // deselect any focused form elements
        document.activeElement.blur();
  
        theme.utils.prepareTransition(this.drawer, function() {
          this.drawer.classList.remove(this.config.activeDrawer);
        }.bind(this));
  
        document.documentElement.classList.remove(this.config.openClass);
        document.documentElement.classList.add(this.config.closingClass);
  
        window.setTimeout(function() {
          document.documentElement.classList.remove(this.config.closingClass);
          if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
            this.activeSource.setAttribute('aria-expanded', 'false');
            this.activeSource.focus();
          }
        }.bind(this), 500);
  
        this.isOpen = false;
  
        theme.a11y.removeTrapFocus({
          container: this.drawer,
          namespace: 'drawer_focus'
        });
  
        this.unbindEvents();
      },
  
      bindEvents: function() {
        // Clicking out of drawer closes it
        window.on('click' + this.config.namespace, function(evt) {
          this.close(evt)
          return;
        }.bind(this));
  
        // Pressing escape closes drawer
        window.on('keyup' + this.config.namespace, function(evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this));
  
        theme.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);
      },
  
      unbindEvents: function() {
        window.off('click' + this.config.namespace);
        window.off('keyup' + this.config.namespace);
  
        theme.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page);
      }
    });
  
    return Drawers;
  })();
  
  theme.Modals = (function() {
    function Modal(id, name, options) {
      var defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-' + name,
        openClass: 'modal--is-active',
        closingClass: 'modal--is-closing',
        bodyOpenClass: 'modal-open',
        bodyOpenSolidClass: 'modal-open--solid',
        bodyClosingClass: 'modal-closing',
        closeOffContentClick: true
      };
  
      this.id = id;
      this.modal = document.getElementById(id);
  
      if (!this.modal) {
        return false;
      }
  
      this.modalContent = this.modal.querySelector('.modal__inner');
  
      this.config = Object.assign(defaults, options);
      this.modalIsOpen = false;
      this.focusOnOpen = this.config.focusIdOnOpen ? document.getElementById(this.config.focusIdOnOpen) : this.modal;
      this.isSolid = this.config.solid;
  
      this.init();
    }
  
    Modal.prototype.init = function() {
      document.querySelectorAll(this.config.open).forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', this.open.bind(this));
      });
  
      this.modal.querySelectorAll(this.config.close).forEach(btn => {
        btn.addEventListener('click', this.close.bind(this));
      });
  
      // Close modal if a drawer is opened
      document.addEventListener('drawerOpen', function() {
        this.close();
      }.bind(this));
    };
  
    Modal.prototype.open = function(evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;
  
      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }
  
      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }
  
      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.activeSource = evt.currentTarget.setAttribute('aria-expanded', 'true');
      }
  
      if (this.modalIsOpen && !externalCall) {
        this.close();
      }
  
      this.modal.classList.add(this.config.openClass);
  
      document.documentElement.classList.add(this.config.bodyOpenClass);
  
      if (this.isSolid) {
        document.documentElement.classList.add(this.config.bodyOpenSolidClass);
      }
  
      this.modalIsOpen = true;
  
      theme.a11y.trapFocus({
        container: this.modal,
        elementToFocus: this.focusOnOpen,
        namespace: 'modal_focus'
      });
  
      document.dispatchEvent(new CustomEvent('modalOpen'));
      document.dispatchEvent(new CustomEvent('modalOpen.' + this.id));
  
      this.bindEvents();
    };
  
    Modal.prototype.close = function(evt) {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }
  
      // Do not close modal if click happens inside modal content
      if (evt) {
        if (evt.target.closest('.js-modal-close')) {
          // Do not close if using the modal close button
        } else if (evt.target.closest('.modal__inner')) {
          return;
        }
      }
  
      // deselect any focused form elements
      document.activeElement.blur();
  
      this.modal.classList.remove(this.config.openClass);
      this.modal.classList.add(this.config.closingClass);
  
      document.documentElement.classList.remove(this.config.bodyOpenClass);
      document.documentElement.classList.add(this.config.bodyClosingClass);
  
      window.setTimeout(function() {
        document.documentElement.classList.remove(this.config.bodyClosingClass);
        this.modal.classList.remove(this.config.closingClass);
        if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
          this.activeSource.setAttribute('aria-expanded', 'false').focus();
        }
      }.bind(this), 500); // modal close css transition
  
      if (this.isSolid) {
        document.documentElement.classList.remove(this.config.bodyOpenSolidClass);
      }
  
      this.modalIsOpen = false;
  
      theme.a11y.removeTrapFocus({
        container: this.modal,
        namespace: 'modal_focus'
      });
  
      document.dispatchEvent(new CustomEvent('modalClose.' + this.id));
  
      this.unbindEvents();
    };
  
    Modal.prototype.bindEvents = function() {
      window.on('keyup.modal', function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));
  
      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.modal.on('click.modal', this.close.bind(this));
      }
    };
  
    Modal.prototype.unbindEvents = function() {
      document.documentElement.off('.modal');
  
      if (this.config.closeOffContentClick) {
        this.modal.off('.modal');
      }
    };
  
    return Modal;
  })();
  
  theme.parallaxSections = {};
  
  theme.Parallax = (function() {
    var speed = 0.85;
    var reset = false;
  
    function parallax(container, args) {
      this.isInit = false;
      this.isVisible = false;
      this.container = container;
      this.image = container.querySelector('.parallax-image');
      this.namespace = args.namespace;
      this.desktopOnly = args.desktopOnly;
  
      if (!this.container || !this.image) {
        return;
      }
  
      // If set for desktop only, setup listeners for disabling
      // on mobile and re-enabling on desktop
      if (this.desktopOnly) {
        document.addEventListener('matchSmall', function() {
          this.destroy();
        }.bind(this));
  
        document.addEventListener('unmatchSmall', function() {
          this.init(true);
        }.bind(this));
      }
  
      this.init(this.desktopOnly);
    }
  
    parallax.prototype = Object.assign({}, parallax.prototype, {
      init: function(desktopOnly) {
        // Reset in case initialized again
        if (this.isInit) {
          this.destroy();
        }
  
        this.isInit = true;
  
        // Do not setup scroll event if on mobile
        if (desktopOnly && theme.config.bpSmall) {
          return;
        }
  
        // Set position on page load
        this.setSizes();
        this.scrollHandler();
  
        var observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            this.isVisible = entry.isIntersecting;
            if (this.isVisible) {
              window.on('scroll' + this.namespace, this.onScroll.bind(this));
            } else {
              window.off('scroll' + this.namespace);
            }
          });
        }, {rootMargin: '200px 0px 200px 0px'});
  
        observer.observe(this.container);
  
        window.on('resize' + this.namespace, theme.utils.debounce(250, this.setSizes.bind(this)));
  
        document.addEventListener('shopify:section:reorder', theme.utils.debounce(250, this.onReorder.bind(this)));
      },
  
      onScroll: function() {
        if (!this.isVisible) {
          return;
        }
  
        // If a scroll event finds Shopify's review app,
        // update parallax scroll positions because of page reflows
        if (window.SPR && !reset) {
          this.setSizes();
          reset = true;
        }
  
        requestAnimationFrame(this.scrollHandler.bind(this));
      },
  
      scrollHandler: function() {
        var shiftDistance = (window.scrollY - this.elTop) * speed;
        this.image.style.transform = 'translate3d(0, ' + shiftDistance + 'px, 0)';
      },
  
      setSizes: function() {
        var rect = this.container.getBoundingClientRect();
        this.elTop = rect.top + window.scrollY;
      },
  
      onReorder: function() {
        this.setSizes();
        this.onScroll();
      },
  
      destroy: function() {
        this.image.style.transform = 'none';
        window.off('scroll' + this.namespace);
        window.off('resize' + this.namespace);
      }
    });
  
    return parallax;
  })();
  
  theme.AjaxProduct = (function() {
    var status = {
      loading: false
    };
  
    function ProductForm(form, submit) {
      this.form = form;
  
      var submitSelector = submit ? submit : '.add-to-cart';
  
      if (this.form) {
        this.addToCart = form.querySelector(submitSelector);
        this.form.addEventListener('submit', this.addItemFromForm.bind(this));
      }
    };
  
    ProductForm.prototype = Object.assign({}, ProductForm.prototype, {
      addItemFromForm: function(evt, callback){
        evt.preventDefault();
  
        if (status.loading) {
          return;
        }
  
        // Loading indicator on add to cart button
        this.addToCart.classList.add('btn--loading');
  
        status.loading = true;
  
        var data = theme.utils.serialize(this.form);
  
        fetch(theme.routes.cartAdd, {
          method: 'POST',
          body: data,
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => response.json())
        .then(function(data) {
          if (data.status === 422) {
            this.error(data);
          } else {
            var product = data;
            this.success(product);
          }
  
          status.loading = false;
          this.addToCart.classList.remove('btn--loading');
        }.bind(this));
      },
  
      success: function(product) {
        var errors = this.form.querySelector('.errors');
        if (errors) {
          errors.remove();
        }
  
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: product,
            addToCartBtn: this.addToCart
          }
        }));
      },
  
      error: function(error) {
        if (!error.description) {
          console.warn(error);
          return;
        }
  
        var errors = this.form.querySelector('.errors');
        if (errors) {
          errors.remove();
        }
  
        var errorDiv = document.createElement('div');
        errorDiv.classList.add('errors', 'text-center');
        errorDiv.textContent = error.description;
        this.form.append(errorDiv);
  
        document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
          detail: {
            errorMessage: error.description
          }
        }));
      }
    });
  
    return ProductForm;
  })();
  
  theme.ProductMedia = (function() {
    var modelJsonSections = {};
    var models = {};
    var xrButtons = {};
  
    var selectors = {
      mediaGroup: '[data-product-single-media-group]',
      xrButton: '[data-shopify-xr]'
    };
  
    function init(modelViewerContainers, sectionId) {
      modelJsonSections[sectionId] = {
        loaded: false
      };
  
      modelViewerContainers.forEach(function(container, index) {
        var mediaId = container.dataset.mediaId;
        var modelViewerElement = container.querySelector('model-viewer');
        var modelId = modelViewerElement.dataset.modelId;
  
        if (index === 0) {
          var mediaGroup = container.closest(selectors.mediaGroup);
          var xrButton = mediaGroup.querySelector(selectors.xrButton);
          xrButtons[sectionId] = {
            element: xrButton,
            defaultId: modelId
          };
        }
  
        models[mediaId] = {
          modelId: modelId,
          sectionId: sectionId,
          container: container,
          element: modelViewerElement
        };
  
      });
  
      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: setupShopifyXr
        },
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: setupModelViewerUi
        }
      ]);
  
      theme.LibraryLoader.load('modelViewerUiStyles');
    }
  
    function setupShopifyXr(errors) {
      if (errors) return;
  
      if (!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', function() {
          setupShopifyXr();
        });
        return;
      }
  
      for (var sectionId in modelJsonSections) {
        if (modelJsonSections.hasOwnProperty(sectionId)) {
          var modelSection = modelJsonSections[sectionId];
  
          if (modelSection.loaded) continue;
  
          var modelJson = document.querySelector('#ModelJson-' + sectionId);
  
          window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
          modelSection.loaded = true;
        }
      }
      window.ShopifyXR.setupXRElements();
    }
  
    function setupModelViewerUi(errors) {
      if (errors) return;
  
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (!model.modelViewerUi && Shopify) {
            model.modelViewerUi = new Shopify.ModelViewerUI(model.element);
          }
          setupModelViewerListeners(model);
        }
      }
    }
  
    function setupModelViewerListeners(model) {
      var xrButton = xrButtons[model.sectionId];
  
      model.container.addEventListener('mediaVisible', function() {
        xrButton.element.setAttribute('data-shopify-model3d-id', model.modelId);
        if (theme.config.isTouch) return;
        model.modelViewerUi.play();
      });
  
      model.container.addEventListener('mediaHidden', function() {
        xrButton.element.setAttribute('data-shopify-model3d-id', xrButton.defaultId);
        model.modelViewerUi.pause();
      });
  
      model.container.addEventListener('xrLaunch', function() {
        model.modelViewerUi.pause();
      });
    }
  
    function removeSectionModels(sectionId) {
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (model.sectionId === sectionId) {
            delete models[key];
          }
        }
      }
      delete modelJsonSections[sectionId];
    }
  
    return {
      init: init,
      removeSectionModels: removeSectionModels
    };
  })();
  
  theme.QtySelector = (function() {
    var selectors = {
      input: '.js-qty__num',
      plus: '.js-qty__adjust--plus',
      minus: '.js-qty__adjust--minus'
    };
  
    function QtySelector(el, options) {
      this.wrapper = el;
      this.plus = el.querySelector(selectors.plus);
      this.minus = el.querySelector(selectors.minus);
      this.input = el.querySelector(selectors.input);
      this.minValue = this.input.getAttribute('min') || 1;
  
      var defaults = {
        namespace: null,
        key: this.input.dataset.id
      };
  
      this.options = Object.assign({}, defaults, options);
  
      this.init();
    }
  
    QtySelector.prototype = Object.assign({}, QtySelector.prototype, {
      init: function() {
        this.plus.addEventListener('click', function() {
          var qty = this._getQty();
          this._change(qty + 1);
        }.bind(this));
  
        this.minus.addEventListener('click', function() {
          var qty = this._getQty();
          this._change(qty - 1);
        }.bind(this));
  
        this.input.addEventListener('change', function(evt) {
          this._change(this._getQty());
        }.bind(this));
      },
  
      _getQty: function() {
        var qty = this.input.value;
        if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
          // We have a valid number!
        } else {
          // Not a number. Default to 1.
          qty = 1;
        }
        return parseInt(qty);
      },
  
      _change: function(qty) {
        if (qty <= this.minValue) {
          qty = this.minValue;
        }
  
        this.input.value = qty;
  
        document.dispatchEvent(new CustomEvent('cart:quantity' + this.options.namespace, {
          detail: [this.options.key, qty]
        }));
      }
    });
  
    return QtySelector;
  })();
  
  theme.initQuickShop = function() {
    var ids = [];
    var products = document.querySelectorAll('.grid-product');
  
    if (!products.length || !theme.settings.quickView) {
      return;
    }
  
    products.forEach(product => {
      product.addEventListener('mouseover', productMouseover);
    });
  
    function productMouseover(evt) {
      var el = evt.currentTarget;
      // No quick view on mobile breakpoint
      if (!theme.config.bpSmall) {
        el.removeEventListener('mouseover', productMouseover);
        if (!el || !el.dataset.productId) {
          // Onboarding product, no real data
          return;
        }
        var productId = el.dataset.productId;
        var handle = el.dataset.productHandle;
        var btn = el.querySelector('.quick-product__btn');
        theme.preloadProductModal(handle, productId, btn);
      }
    }
  };
  
  theme.preloadProductModal = function(handle, productId, btn) {
    var holder = document.getElementById('QuickShopHolder-' + handle);
    var url = theme.routes.home + '/products/' + handle + '?view=modal';
  
    // remove double `/` in case shop might have /en or language in URL
    url = url.replace('//', '/');
  
    fetch(url).then(function(response) {
      return response.text();
    }).then(function(html) {
      // Convert the HTML string into a document object
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var div = doc.querySelector('.product-section[data-product-handle="'+handle+'"]');
  
      if (!holder) {
        return;
      }
  
      holder.append(div);
  
      // Setup quick view modal
      var modalId = 'QuickShopModal-' + productId;
      var name = 'quick-modal-' + productId;
      new theme.Modals(modalId, name);
  
      // Register product template inside quick view
      theme.sections.register('product', theme.Product, holder);
  
      // Register collapsible elements
      theme.collapsibles.init();
  
      // Register potential video modal links (when video has sound)
      theme.videoModal();
  
      if (btn) {
        btn.classList.remove('quick-product__btn--not-ready');
      }
    });
  }
  
  
  // theme.Slideshow handles all flickity based sliders
  // Child navigation is only setup to work on product images
  theme.Slideshow = (function() {
    var classes = {
      animateOut: 'animate-out',
      isPaused: 'is-paused',
      isActive: 'is-active'
    };
  
    var selectors = {
      allSlides: '.slideshow__slide',
      currentSlide: '.is-selected',
      wrapper: '.slideshow-wrapper',
      pauseButton: '.slideshow__pause'
    };
  
    var productSelectors = {
      thumb: '.product__thumb-item:not(.hide)',
      links: '.product__thumb-item:not(.hide) a',
      arrow: '.product__thumb-arrow'
    };
  
    var defaults = {
      adaptiveHeight: false,
      autoPlay: false,
      avoidReflow: false, // custom by Archetype
      childNav: null, // element. Custom by Archetype instead of asNavFor
      childNavScroller: null, // element
      childVertical: false,
      fade: false,
      initialIndex: 0,
      pageDots: false,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      rightToLeft: theme.config.rtl,
      setGallerySize: true,
      wrapAround: true
    };
  
    function slideshow(el, args) {
      this.el = el;
      this.args = Object.assign({}, defaults, args);
  
      // Setup listeners as part of arguments
      this.args.on = {
        ready: this.init.bind(this),
        change: this.slideChange.bind(this),
        settle: this.afterChange.bind(this)
      };
  
      if (this.args.childNav) {
        this.childNavEls = this.args.childNav.querySelectorAll(productSelectors.thumb);
        this.childNavLinks = this.args.childNav.querySelectorAll(productSelectors.links);
        this.arrows = this.args.childNav.querySelectorAll(productSelectors.arrow);
        if (this.childNavLinks.length) {
          this.initChildNav();
        }
      }
  
      if (this.args.avoidReflow) {
        avoidReflow(el);
      }
  
      this.slideshow = new Flickity(el, this.args);
  
      if (this.args.autoPlay) {
        var wrapper = el.closest(selectors.wrapper);
        this.pauseBtn = wrapper.querySelector(selectors.pauseButton);
        if (this.pauseBtn) {
          this.pauseBtn.addEventListener('click', this._togglePause.bind(this));
        }
      }
  
      // Reset dimensions on resize
      window.on('resize', theme.utils.debounce(300, function() {
        this.resize();
      }.bind(this)));
  
      // Set flickity-viewport height to first element to
      // avoid awkward page reflows while initializing.
      // Must be added in a `style` tag because element does not exist yet.
      // Slideshow element must have an ID
      function avoidReflow(el) {
        if (!el.id) return;
        var firstChild = el.firstChild;
        while(firstChild != null && firstChild.nodeType == 3){ // skip TextNodes
          firstChild = firstChild.nextSibling;
        }
        var style = document.createElement('style');
        style.innerHTML = `#${el.id} .flickity-viewport{height:${firstChild.offsetHeight}px}`;
        document.head.appendChild(style);
      }
    }
  
    slideshow.prototype = Object.assign({}, slideshow.prototype, {
      init: function(el) {
        this.currentSlide = this.el.querySelector(selectors.currentSlide);
  
        // Optional onInit callback
        if (this.args.callbacks && this.args.callbacks.onInit) {
          if (typeof this.args.callbacks.onInit === 'function') {
            this.args.callbacks.onInit();
          }
        }
  
        if (window.AOS) { AOS.refresh() }
      },
  
      slideChange: function(index) {
        // Outgoing fade styles
        if (this.args.fade) {
          this.currentSlide.classList.add(classes.animateOut);
          this.currentSlide.addEventListener('transitionend', function() {
            this.currentSlide.classList.remove(classes.animateOut);
          }.bind(this));
        }
  
        // Match index with child nav
        if (this.args.childNav) {
          this.childNavGoTo(index);
        }
  
        // Optional onChange callback
        if (this.args.callbacks && this.args.callbacks.onChange) {
          if (typeof this.args.callbacks.onChange === 'function') {
            this.args.callbacks.onChange(index);
          }
        }
  
        // Show/hide arrows depending on selected index
        if (this.arrows && this.arrows.length) {
          this.arrows[0].classList.toggle('hide', index === 0);
          this.arrows[1].classList.toggle('hide', index === (this.childNavLinks.length - 1));
        }
      },
      afterChange: function(index) {
        // Remove all fade animation classes after slide is done
        if (this.args.fade) {
          this.el.querySelectorAll(selectors.allSlides).forEach(slide => {
            slide.classList.remove(classes.animateOut);
          });
        }
  
        this.currentSlide = this.el.querySelector(selectors.currentSlide);
  
        // Match index with child nav (in case slider height changed first)
        if (this.args.childNav) {
          this.childNavGoTo(this.slideshow.selectedIndex);
        }
      },
      destroy: function() {
        this.slideshow.destroy();
      },
      _togglePause: function() {
        if (this.pauseBtn.classList.contains(classes.isPaused)) {
          this.pauseBtn.classList.remove(classes.isPaused);
          this.slideshow.playPlayer();
        } else {
          this.pauseBtn.classList.add(classes.isPaused);
          this.slideshow.pausePlayer();
        }
      },
      resize: function() {
        this.slideshow.resize();
      },
      play: function() {
        this.slideshow.playPlayer();
      },
      pause: function() {
        this.slideshow.pausePlayer();
      },
      goToSlide: function(i) {
        this.slideshow.select(i);
      },
      setDraggable: function(enable) {
        this.slideshow.options.draggable = enable;
        this.slideshow.updateDraggable();
      },
  
      initChildNav: function() {
        this.childNavLinks[this.args.initialIndex].classList.add('is-active');
  
        // Setup events
        this.childNavLinks.forEach((link, i) => {
          // update data-index because image-set feature may be enabled
          link.setAttribute('data-index', i);
  
          link.addEventListener('click', function(evt) {
            evt.preventDefault();
            this.goToSlide(this.getChildIndex(evt.currentTarget))
          }.bind(this));
          link.addEventListener('focus', function(evt) {
            this.goToSlide(this.getChildIndex(evt.currentTarget))
          }.bind(this));
          link.addEventListener('keydown', function(evt) {
            if (evt.keyCode === 13) {
              this.goToSlide(this.getChildIndex(evt.currentTarget))
            }
          }.bind(this));
        });
  
        // Setup optional arrows
        if (this.arrows.length) {
          this.arrows.forEach(arrow => {
            arrow.addEventListener('click', this.arrowClick.bind(this));
          });;
        }
      },
  
      getChildIndex: function(target) {
        return parseInt(target.dataset.index);
      },
  
      childNavGoTo: function(index) {
        this.childNavLinks.forEach(a => {
          a.classList.remove(classes.isActive);
        });
  
        var el = this.childNavLinks[index];
        el.classList.add(classes.isActive);
  
        if (this.args.childVertical) {
          var elTop = el.offsetTop;
          this.args.childNavScroller.scrollTop = elTop - 100;
        } else {
          var elLeft = el.offsetLeft;
          this.args.childNavScroller.scrollLeft = elLeft - 100;
        }
      },
  
      arrowClick: function(evt) {
        if (evt.currentTarget.classList.contains('product__thumb-arrow--prev')) {
          this.slideshow.previous();
        } else {
          this.slideshow.next();
        }
      }
    });
  
    return slideshow;
  })();
  
  /*============================================================================
    VariantAvailability
    - Cross out sold out variants and disable unavailable
    - To disable, set dynamicVariantsEnable to false in theme.liquid
    - Required markup:
      - class=variant-input-wrap to wrap select or button group
      - class=variant-input to wrap button/label
  ==============================================================================*/
  
  theme.VariantAvailability = (function() {
    var classes = {
      disabled: 'disabled',
      hidden: 'hide'
    };
  
    function availability(args) {
      this.type = args.type;
      this.variantSelectors = args.variantSelectors;
      this.variantsObject = args.variantsObject;
      this.currentVariantObject = args.currentVariantObject;
      this.form = args.form;
  
      this.init();
    }
  
    availability.prototype = Object.assign({}, availability.prototype, {
      init: function() {
        this.variantSelectors.forEach(el => {
          el.on('change', this.setAvailability.bind(this))
        });
  
        // Set default state based on current selected variant
        this.setAvailability(null, this.currentVariantObject);
      },
  
      setAvailability: function(evt, variant) {
        // Object to hold all options by value.
        // This will be what sets a button/dropdown as
        // sold out or unavailable (not a combo set as purchasable)
        var valuesToManage = {
          option1: [],
          option2: [],
          option3: []
        };
  
        var ignoreIndex = null;
        var variants;
        // If working with an event, get variants to loop through
        // based on the group index of recently selected option.
        // If variant object passed explicitly (on load), get variants
        // that overlap with all potential combinations
        if (evt) {
          var el = evt.currentTarget;
          var val = el.value;
          var index = el.dataset.index;
          variants = this.variantsObject.filter(function(el) {
            return el[index] === val;
          });
        } else {
          var availableVariants = this.variantsObject.filter(function(el) {
            if (variant.id === el.id) {
              return false;
            }
  
            if (variant.option2 === el.option2 && variant.option3 === el.option3) {
              return true;
            }
  
            if (variant.option1 === el.option1 && variant.option3 === el.option3) {
              return true;
            }
  
            if (variant.option1 === el.option1 && variant.option2 === el.option2) {
              return true;
            }
          });
  
          // IE11 can't handle shortform of {variant} so extra step is needed
          var variantObject = {
            variant: variant
          };
  
          variants = Object.assign({}, variantObject, availableVariants);
        }
  
        // Disable all options to start.
        // If coming from a variant change event, do not disable
        // options inside current index group
        this.form.querySelectorAll('.variant-input-wrap').forEach(group => {
          var groupIndex = group.dataset.index;
          if (evt && groupIndex === index) {
            ignoreIndex = index;
            return;
          }
  
          this.disableVariantGroup(group);
        });
  
        // Loop through each available variant to gather variant values
        for (var property in variants) {
          if (variants.hasOwnProperty(property)) {
            var item = variants[property];
            var value1 = item.option1;
            var value2 = item.option2;
            var value3 = item.option3;
            var soldOut = item.available === false;
  
            if (value1 && ignoreIndex !== 'option1') {
              valuesToManage.option1.push({
                value: value1,
                soldOut: soldOut
              });
            }
            if (value2 && ignoreIndex !== 'option2') {
              valuesToManage.option2.push({
                value: value2,
                soldOut: soldOut
              });
            }
            if (value3 && ignoreIndex !== 'option3') {
              valuesToManage.option3.push({
                value: value3,
                soldOut: soldOut
              });
            }
          }
        }
  
        // Loop through all option levels and send each
        // value w/ args to function that determines to show/hide/enable/disable
        for (var [option, values] of Object.entries(valuesToManage)) {
          this.manageOptionState(option, values);
        }
      },
  
      manageOptionState: function(option, values) {
        var group = this.form.querySelector('.variant-input-wrap[data-index="'+ option +'"]');
  
        // Loop through each option value
        values.forEach(obj => {
          this.enableVariantOption(group, obj);
        });
      },
  
      enableVariantOptionByValue: function(array, index) {
        var group = this.form.querySelector('.variant-input-wrap[data-index="'+ index +'"]');
  
        for (var i = 0; i < array.length; i++) {
          this.enableVariantOption(group, array[i]);
        }
      },
  
      enableVariantOption: function(group, obj) {
        // Selecting by value so escape it
        var value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,'\\$1');
  
        if (this.type === 'dropdown') {
          group.querySelector('option[value="'+ value +'"]').disabled = false;
        } else {
          var buttonGroup = group.querySelector('.variant-input[data-value="'+ value +'"]');
          var input = buttonGroup.querySelector('input');
          var label = buttonGroup.querySelector('label');
  
          // Variant exists - enable & show variant
          input.disabled = false;
          input.classList.remove(classes.hidden, classes.disabled);
          label.classList.remove(classes.hidden, classes.disabled);
  
          // Variant sold out - cross out option (remains selectable)
          if (obj.soldOut) {
            input.classList.add(classes.disabled);
            label.classList.add(classes.disabled);
          }
        }
      },
  
      disableVariantGroup: function(group) {
        if (this.type === 'dropdown') {
          group.querySelectorAll('option').forEach(option => {
            option.disabled = true;
          });
        } else {
          group.querySelectorAll('input').forEach(input => {
            input.disabled = true;
            input.classList.add(classes.hidden);
            input.classList.remove(classes.disabled);
          });
          group.querySelectorAll('label').forEach(label => {
            label.classList.add(classes.hidden);
            label.classList.remove(classes.disabled);
          });
        }
      }
  
    });
  
    return availability;
  })();
  
  // Video modal will auto-initialize for any anchor link that points to YouTube
  // MP4 videos must manually be enabled with:
  //   - .product-video-trigger--mp4 (trigger button)
  //   - .product-video-mp4-sound video player element (cloned into modal)
  //     - see media.liquid for example of this
  theme.videoModal = function() {
    var youtubePlayer;
  
    var videoHolderId = 'VideoHolder';
    var selectors = {
      youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
      mp4Trigger: '.product-video-trigger--mp4',
      mp4Player: '.product-video-mp4-sound'
    };
  
    var youtubeTriggers = document.querySelectorAll(selectors.youtube);
    var mp4Triggers = document.querySelectorAll(selectors.mp4Trigger);
  
    if (!youtubeTriggers.length && !mp4Triggers.length) {
      return;
    }
  
    var videoHolderDiv = document.getElementById(videoHolderId);
  
    if (youtubeTriggers.length) {
      theme.LibraryLoader.load('youtubeSdk');
    }
  
    var modal = new theme.Modals('VideoModal', 'video-modal', {
      closeOffContentClick: true,
      solid: true
    });
  
    youtubeTriggers.forEach(btn => {
      btn.addEventListener('click', triggerYouTubeModal);
    });
  
    mp4Triggers.forEach(btn => {
      btn.addEventListener('click', triggerMp4Modal);
    });
  
    document.addEventListener('modalClose.VideoModal', closeVideoModal);
  
    function triggerYouTubeModal(evt) {
      // If not already loaded, treat as normal link
      if (!theme.config.youTubeReady) {
        return;
      }
  
      evt.preventDefault();
      emptyVideoHolder();
  
      modal.open(evt);
  
      var videoId = getYoutubeVideoId(evt.currentTarget.getAttribute('href'));
      youtubePlayer = new theme.YouTube(
        videoHolderId,
        {
          videoId: videoId,
          style: 'sound',
          events: {
            onReady: onYoutubeReady
          }
        }
      );
    }
  
    function triggerMp4Modal(evt) {
      emptyVideoHolder();
  
      var el = evt.currentTarget;
      var player = el.parentNode.querySelector(selectors.mp4Player);
  
      // Clone video element and place it in the modal
      var playerClone = player.cloneNode(true);
      playerClone.classList.remove('hide');
  
      videoHolderDiv.append(playerClone);
      modal.open(evt);
  
      // Play new video element
      videoHolderDiv.querySelector('video').play();
    }
  
    function onYoutubeReady(evt) {
      evt.target.unMute();
      evt.target.playVideo();
    }
  
    function getYoutubeVideoId(url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      var match = url.match(regExp);
      return (match&&match[7].length==11)? match[7] : false;
    }
  
    function emptyVideoHolder() {
      videoHolderDiv.innerHTML = '';
    }
  
    function closeVideoModal() {
      if (youtubePlayer && typeof youtubePlayer.destroy === 'function') {
        youtubePlayer.destroy();
      } else {
        emptyVideoHolder();
      }
    }
  };
  
  

  theme.announcementBar = (function() {
    var args = {
      autoPlay: 5000,
      avoidReflow: true,
      cellAlign: theme.config.rtl ? 'right' : 'left'
    };
    var bar;
    var flickity;
  
    function init() {
      bar = document.getElementById('AnnouncementSlider');
      if (!bar) {
        return;
      }
  
      unload();
  
      if (bar.dataset.blockCount === 1) {
        return;
      }
  
      if (theme.config.bpSmall || bar.dataset.compact === 'true') {
        initSlider();
      }
  
      document.addEventListener('matchSmall', function() {
        unload();
        initSlider();
      });
  
      document.addEventListener('unmatchSmall', function() {
        unload();
        if (bar.dataset.compact === 'true') {
          initSlider();
        }
      });
    }
  
    function initSlider() {
      flickity = new theme.Slideshow(bar, args);
    }
  
    // Go to slide if selected in the editor
    function onBlockSelect(id) {
      var slide = bar.querySelector('#AnnouncementSlide-' + id);
      var index = parseInt(slide.dataset.index);
  
      if (flickity && typeof flickity.pause === 'function') {
        flickity.goToSlide(index);
        flickity.pause();
      }
    }
  
    function onBlockDeselect() {
      if (flickity && typeof flickity.play === 'function') {
        flickity.play();
      }
    }
  
    function unload() {
      if (flickity && typeof flickity.destroy === 'function') {
        flickity.destroy();
      }
    }
  
    return {
      init: init,
      onBlockSelect: onBlockSelect,
      onBlockDeselect: onBlockDeselect,
      unload: unload
    };
  })();
  
  theme.customerTemplates = function() {
    checkUrlHash();
    initEventListeners();
    resetPasswordSuccess();
    customerAddressForm();
  
    function checkUrlHash() {
      var hash = window.location.hash;
  
      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }
  
    function toggleRecoverPasswordForm() {
      var passwordForm = document.getElementById('RecoverPasswordForm').classList.toggle('hide');
      var loginForm = document.getElementById('CustomerLoginForm').classList.toggle('hide');
    }
  
    function initEventListeners() {
      // Show reset password form
      var recoverForm = document.getElementById('RecoverPassword');
      if (recoverForm) {
        recoverForm.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
  
      // Hide reset password form
      var hideRecoverPassword = document.getElementById('HideRecoverPasswordLink');
      if (hideRecoverPassword) {
        hideRecoverPassword.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
    }
  
    function resetPasswordSuccess() {
      var formState = document.querySelector('.reset-password-success');
  
      // check if reset password form was successfully submitted
      if (!formState) {
        return;
      }
  
      // show success message
      document.getElementById('ResetSuccess').classList.remove('hide');
    }
  
    function customerAddressForm() {
      var newAddressForm = document.getElementById('AddressNewForm');
      var addressForms = document.querySelectorAll('.js-address-form');
  
      if (!newAddressForm || !addressForms.length) {
        return;
      }
  
      // Country/province selector can take a short time to load
      setTimeout(function() {
        document.querySelectorAll('.js-address-country').forEach(el => {
          var countryId = el.dataset.countryId;
          var provinceId = el.dataset.provinceId;
          var provinceContainerId = el.dataset.provinceContainerId;
  
          new Shopify.CountryProvinceSelector(
            countryId,
            provinceId,
            {
              hideElement: provinceContainerId
            }
          );
        });
      }, 1000);
  
      // Toggle new/edit address forms
      document.querySelectorAll('.address-new-toggle').forEach(el => {
        el.addEventListener('click', function(evt) {
          newAddressForm.classList.toggle('hide');
        });
      });
  
      document.querySelectorAll('.address-edit-toggle').forEach(el => {
        el.addEventListener('click', function(evt) {
          var formId = evt.currentTarget.dataset.formId;
          document.getElementById('EditAddress_' + formId).classList.toggle('hide');
        });
      });
  
      document.querySelectorAll('.address-delete').forEach(el => {
        el.addEventListener('click', function(evt) {
          var formId = evt.currentTarget.dataset.formId;
          var confirmMessage = evt.currentTarget.dataset.confirmMessage;
  
          if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            if (Shopify) {
              Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
            }
          }
        })
      });
    }
  };
  
  theme.CartDrawer = (function() {
    var selectors = {
      drawer: '#CartDrawer',
      form: '#CartDrawerForm'
    };
  
    function CartDrawer() {
      this.form = document.querySelector(selectors.form);
      this.drawer = new theme.Drawers('CartDrawer', 'cart');
  
      this.init();
    }
  
    CartDrawer.prototype = Object.assign({}, CartDrawer.prototype, {
      init: function() {
        this.cartForm = new theme.CartForm(this.form);
        this.cartForm.buildCart();
  
        document.addEventListener('ajaxProduct:added', function(evt) {
          this.cartForm.buildCart();
          this.open();
        }.bind(this));
  
        // Dev-friendly way to open cart
        document.addEventListener('cart:open', this.open.bind(this));
        document.addEventListener('cart:close', this.close.bind(this));
      },
  
      open: function() {
        this.drawer.open();
      },
  
      close: function() {
        this.drawer.close();
      }
    });
  
    return CartDrawer;
  })();
  
  theme.headerNav = (function() {
    var selectors = {
      wrapper: '#HeaderWrapper',
      siteHeader: '#SiteHeader',
      searchBtn: '.js-search-header',
      closeSearch: '#SearchClose',
      searchContainer: '.site-header__search-container',
      logo: '#LogoContainer img',
      megamenu: '.megamenu',
      navItems: '.site-nav__item',
      navLinks: '#Site Nav .site-nav__link',
      navLinksWithDropdown: '.site-nav__link--has-dropdown',
      navDropdownLinks: '.site-nav__dropdown-link--second-level'
    };
  
    var classes = {
      hasDropdownClass: 'site-nav--has-dropdown',
      hasSubDropdownClass: 'site-nav__deep-dropdown-trigger',
      dropdownActive: 'is-focused'
    };
  
    var config = {
      namespace: '.siteNav',
      wrapperOverlayed: false,
      overlayedClass: 'is-light',
      overlayEnabledClass: 'header-wrapper--sticky',
      stickyEnabled: false,
      stickyActive: false,
      stickyClass: 'site-header--stuck',
      stickyHeaderWrapper: 'StickyHeaderWrap',
      openTransitionClass: 'site-header--opening',
      lastScroll: 0,
      scrollDirection: 'down'
    };
  
    // Elements used in resize functions, defined in init
    var wrapper;
    var siteHeader;
  
    function init() {
      wrapper = document.querySelector(selectors.wrapper);
      siteHeader = document.querySelector(selectors.siteHeader);
  
      config.stickyEnabled = (siteHeader.dataset.sticky === 'true');
      if (config.stickyEnabled) {
        config.wrapperOverlayed = wrapper.classList.contains(config.overlayedClass);
        stickyHeaderCheck();
      }
  
      theme.settings.overlayHeader = (siteHeader.dataset.overlay === 'true');
      // Disable overlay header if on collection template with no collection image
      if (theme.settings.overlayHeader && Shopify && Shopify.designMode) {
        if (document.body.classList.contains('template-collection') && !document.querySelector('.collection-hero')) {
          this.disableOverlayHeader();
        }
      }
  
      accessibleDropdowns();
      searchDrawer();
  
      window.on('load' + config.namespace, resizeLogo);
      window.on('resize' + config.namespace, theme.utils.debounce(150, resizeLogo));

      // Menu region link
      var close_nav_open_region_btn = document.getElementById('CloseNavOpenRegion');
      if (close_nav_open_region_btn !== null) {
        close_nav_open_region_btn.onclick = function() {
          theme.NavDrawer.close();
          setTimeout(function(){ theme.RegionDrawer.open()}, 500);
        }
      }
      
      // menu class toggle for megamenu
      if (!theme.config.isTouch) {
        var full_megamenu_navigation = document.getElementById('SiteNav');
        var full_megamenu = document.getElementById('SiteHeader');

        full_megamenu.addEventListener('mouseenter', e => {
          document.getElementById('SiteHeader').classList.add('megamenu-hover');
        });
                
        full_megamenu.addEventListener('mouseleave', e => {
          document.getElementById('SiteHeader').classList.remove('megamenu-hover'); 
          document.getElementById('MainContent').classList.remove('main-content-dimmer-open');
          document.getElementById('MainContent').classList.add('main-content-dimmer-closing');
          
          setTimeout(function(){
            document.getElementById('MainContent').classList.remove('main-content-dimmer-closing');
          }, 300);
        });

        full_megamenu_navigation.addEventListener('mouseover', e => {
          document.getElementById('MainContent').classList.add('main-content-dimmer-open');
        });

        full_megamenu_navigation.addEventListener('mouseleave', e => {
          document.getElementById('MainContent').classList.remove('main-content-dimmer-open');
          document.getElementById('MainContent').classList.add('main-content-dimmer-closing');
          
          setTimeout(function(){
            document.getElementById('MainContent').classList.remove('main-content-dimmer-closing');
          }, 300);
        });
      } else {
        document.addEventListener('click', function(e) {
          if (e.target.id !== 'SiteHeader' && e.target.id !== 'SiteNav' && e.target.closest('#SiteNav') == null) {
            document.getElementById('SiteHeader').classList.remove('megamenu-hover');

            document.querySelectorAll(selectors.navItems).forEach(el => {
              el.classList.remove(classes.dropdownActive)
            });
          }
        }.bind(this));
      }
    }
  
    // If the header setting to overlay the menu on the collection image
    // is enabled but the collection setting is disabled, we need to undo
    // the init of the sticky nav
    function disableOverlayHeader() {
      wrapper.classList.remove(config.overlayEnabledClass, config.overlayedClass);
      config.wrapperOverlayed = false;
      theme.settings.overlayHeader = false;
    }
  
    function stickyHeaderCheck() {
      // Disable sticky header if any mega menu is taller than window
      theme.config.stickyHeader = doesMegaMenuFit();
  
      if (theme.config.stickyHeader) {
        config.forceStopSticky = false;
        stickyHeader();
      } else {
        config.forceStopSticky = true;
      }
    }
  
    function doesMegaMenuFit() {
      var largestMegaNav = 0;
      siteHeader.querySelectorAll(selectors.megamenu).forEach(nav => {
        var h = nav.offsetHeight;
        if (h > largestMegaNav) {
          largestMegaNav = h;
        }
      });
  
      // 120 ~ space of visible header when megamenu open
      if (window.innerHeight < (largestMegaNav + 120)) {
        return false;
      }
  
      return true;
    }
  
    function stickyHeader() {
      config.lastScroll = 0;
  
      var wrapWith = document.createElement('div');
      wrapWith.id = config.stickyHeaderWrapper;
      theme.utils.wrap(siteHeader, wrapWith);
  
      stickyHeaderHeight();
  
      window.on('resize' + config.namespace, theme.utils.debounce(50, stickyHeaderHeight));

      if (theme.config.isTouch) {
        window.on('scroll' + config.namespace, theme.utils.throttle(200, stickyHeaderScroll));
      } else {
        window.on('scroll' + config.namespace, theme.utils.throttle(10, stickyHeaderScroll));
      }
  
      // This gets messed up in the editor, so here's a fix
      if (Shopify && Shopify.designMode) {
        setTimeout(function() {
          stickyHeaderHeight();
        }, 250);
      }
    }
  
    function stickyHeaderHeight() {
      if (!config.stickyEnabled) {
        return;
      }
      var h = siteHeader.offsetHeight;
      var stickyHeader = document.querySelector('#' + config.stickyHeaderWrapper);
      stickyHeader.style.height = h + 'px';
    }
  
    function stickyHeaderScroll() {
      if (!config.stickyEnabled) {
        return;
      }
  
      if (config.forceStopSticky) {
        return;
      }

      requestAnimationFrame(scrollHandler);
  
      setTimeout(function() {
        config.lastScroll = window.scrollY;
      }, 100);
    }
  
    function scrollHandler() {
      // detection for scroll direction
      if(config.lastScroll > window.scrollY) {
        config.scrollDirection = "up"
      } else {
        config.scrollDirection = "down"
      }

      if (window.scrollY > 250) {

         if (config.scrollDirection == "down") {
           config.stickyActive = false;
           siteHeader.classList.remove(config.stickyClass);
          return;
        }

        config.stickyActive = true;
        siteHeader.classList.add(config.stickyClass);
        if (config.wrapperOverlayed) {
          wrapper.classList.remove(config.overlayedClass);
        }

        // Add open transition class after element is set to fixed
        // so CSS animation is applied correctly
        setTimeout(function() {
          siteHeader.classList.add(config.openTransitionClass);
        }, 100);
      } else {
        if (!config.stickyActive) {
          return;
        }
  
        config.stickyActive = false;
  
        siteHeader.classList.remove(config.openTransitionClass);
        siteHeader.classList.remove(config.stickyClass);
        if (config.wrapperOverlayed) {
          wrapper.classList.add(config.overlayedClass);
        }
      }
    }
  
    function accessibleDropdowns() {
      var hasActiveDropdown = false;
      var hasActiveSubDropdown = false;
      var closeOnClickActive = false;
  
      // Touch devices open dropdown on first click, navigate to link on second
      if (theme.config.isTouch) {
        document.querySelectorAll(selectors.navLinksWithDropdown).forEach(el => {
          el.on('touchend' + config.namespace, function(evt) {
            var parent = evt.currentTarget.parentNode;
            if (!parent.classList.contains(classes.dropdownActive)) {
              evt.preventDefault();
              closeDropdowns();
              openFirstLevelDropdown(evt.currentTarget);
            } else {
              window.location.replace(evt.currentTarget.getAttribute('href'));
            }
          });
        });
      }
  
      // Open/hide top level dropdowns
      document.querySelectorAll(selectors.navLinks).forEach(el => {
        el.on('focusin' + config.namespace, accessibleMouseEvent);
        el.on('mouseover' + config.namespace, accessibleMouseEvent);
        el.on('mouseleave' + config.namespace, closeDropdowns);
      });
  
      document.querySelectorAll(selectors.navDropdownLinks).forEach(el => {
        if (theme.config.isTouch) {
          el.on('touchend' + config.namespace, function(evt) {
            var parent = evt.currentTarget.parentNode;
  
            // Open third level menu or go to link based on active state
            if (parent.classList.contains(classes.hasSubDropdownClass)) {
              if (!parent.classList.contains(classes.dropdownActive)) {
                evt.preventDefault();
                closeThirdLevelDropdown();
                openSecondLevelDropdown(evt.currentTarget);
              } else {
                window.location.replace(evt.currentTarget.getAttribute('href'));
              }
            } else {
              // No third level nav, go to link
              window.location.replace(evt.currentTarget.getAttribute('href'));
            }
          });
        }
  
        // Open/hide sub level dropdowns
        el.on('focusin' + config.namespace, function(evt) {
          closeThirdLevelDropdown();
          openSecondLevelDropdown(evt.currentTarget, true);
        })
      });
  
      function accessibleMouseEvent(evt) {
        if (hasActiveDropdown) {
          closeSecondLevelDropdown();
        }
  
        if (hasActiveSubDropdown) {
          closeThirdLevelDropdown();
        }
  
        openFirstLevelDropdown(evt.currentTarget);
      }
  
      // Private dropdown functions
      function openFirstLevelDropdown(el) {
        var parent = el.parentNode;
        if (parent.classList.contains(classes.hasDropdownClass)) {
          parent.classList.add(classes.dropdownActive);
          hasActiveDropdown = true;
        }
  
        if (!theme.config.isTouch) {
          if (!closeOnClickActive) {
            var eventType = theme.config.isTouch ? 'touchend' : 'click';
            closeOnClickActive = true;
            document.documentElement.on(eventType + config.namespace, function() {
              closeDropdowns();
              document.documentElement.off(eventType + config.namespace);
              closeOnClickActive = false;
              
            }.bind(this));
          }
        } else if (!parent.classList.contains(classes.searchBtn)) {
          document.getElementById('SiteHeader').classList.add('megamenu-hover');
          closeDropdowns();
        }
      }
  
      function openSecondLevelDropdown(el, skipCheck) {
        var parent = el.parentNode;
        if (parent.classList.contains(classes.hasSubDropdownClass) || skipCheck) {
          parent.classList.add(classes.dropdownActive);
          hasActiveSubDropdown = true;
        }
      }
  
      function closeDropdowns() {
        closeSecondLevelDropdown();
        closeThirdLevelDropdown();
      }
  
      function closeSecondLevelDropdown() {
        document.querySelectorAll(selectors.navItems).forEach(el => {
          el.classList.remove(classes.dropdownActive)
        });
      }
  
      function closeThirdLevelDropdown() {
        document.querySelectorAll(selectors.navDropdownLinks).forEach(el => {
          el.parentNode.classList.remove(classes.dropdownActive);
        });
      }
    }
  
    function searchDrawer() {
      document.querySelectorAll(selectors.searchBtn).forEach(btn => {
        btn.addEventListener('click', openSearchDrawer);
      });
  
      document.querySelector(selectors.closeSearch).addEventListener('click', closeSearchDrawer);
    }
  
    function openSearchDrawer(evt) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      var container = document.querySelector(selectors.searchContainer);
      theme.utils.prepareTransition(container, function() {
        container.classList.add('is-active');
      }.bind(this));
  
      document.documentElement.classList.add('js-drawer-open', 'js-drawer-open--search');
  
      setTimeout(function() {
        theme.a11y.trapFocus({
          container: container,
          namespace: 'header_search',
          elementToFocus: container.querySelector('.site-header__search-input')
        });
      }, 100);
  
      // If sticky is enabled, scroll to top on mobile when close to it
      // so you don't get an invisible search box
      if (theme.config.bpSmall && config.stickyEnabled && config.lastScroll < 300) {
        window.scrollTo(0,0);
      }
  
      // Bind events
      theme.a11y.lockMobileScrolling(config.namespace);
  
      bindSearchEvents();
    }
  
    function closeSearchDrawer(evt) {
      // Do not close if click event came from inside drawer
      if (evt) {
        // evt.path is non-standard, so have fallback
        var path = evt.path || (evt.composedPath && evt.composedPath());
        for (var i = 0; i < path.length; i++) {
          if (path[i].classList) {
            if (path[i].classList.contains('site-header__search-btn')) {
              break;
            }
  
            if (path[i].classList.contains('site-header__search-container')) {
              return;
            }
          }
        }
      }
  
      // deselect any focused form elements
      document.activeElement.blur();
  
      document.documentElement.classList.add('js-drawer-closing');
      document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open--search');
  
      window.setTimeout(function() {
        document.documentElement.classList.remove('js-drawer-closing');
      }.bind(this), 500);
  
      var container = document.querySelector(selectors.searchContainer);
      theme.utils.prepareTransition(container, function() {
        container.classList.remove('is-active');
      }.bind(this));
  
      theme.a11y.removeTrapFocus({
        container: container,
        namespace: 'header_search'
      });
  
      theme.a11y.unlockMobileScrolling(config.namespace);
  
      unbindSearchEvents();
    }
  
    function bindSearchEvents() {
      window.on('keyup' + config.namespace, function(evt) {
        if (evt.keyCode === 27) {
          closeSearchDrawer();
        }
      }.bind(this));
  
      // Clicking out of container closes it
      document.documentElement.on('click' + config.namespace, function(evt) {
        closeSearchDrawer(evt);
      }.bind(this));
    }
  
    function unbindSearchEvents() {
      window.off('keyup' + config.namespace);
      document.documentElement.off('click' + config.namespace);
    }
  
    function resizeLogo(evt) {
      document.querySelectorAll(selectors.logo).forEach(logo => {
        var logoWidthOnScreen = logo.clientWidth;
        var containerWidth = logo.closest('.header-item').clientWidth;
  
        // If image exceeds container, let's make it smaller
        if (logoWidthOnScreen > containerWidth) {
          logo.style.maxWidth = containerWidth;
        }
        else {
          logo.removeAttribute('style')
        }
      });
    }
    return {
      init: init,
      disableOverlayHeader: disableOverlayHeader
    };
  })();
  
  window.onpageshow = function(evt) {
    // Removes unload class when returning to page via history
    if (evt.persisted) {
      document.body.classList.remove('unloading');
      document.querySelectorAll('.cart__checkout').forEach(el => {
        el.classList.remove('btn--loading');
      });
    }
  };
  
  theme.predictiveSearch = (function() {
    var currentString = '';
    var isLoading = false;
    var searchTimeout;
    var namespace = '.predictive';
  
    var selectors = {
      form: '#HeaderSearchForm',
      input: 'input[type="search"]',
      wrapper: '#PredictiveWrapper',
      resultDiv: '#PredictiveResults',
  
      searchButton: '[data-predictive-search-button]'
    };
  
    var cache = {};
    var config = {
      imageSize: 'square'
    }
  
    var classes = {
      isActive: 'predicitive-active'
    };
  
    var keys = {
      up_arrow: 38,
      down_arrow: 40,
      tab: 9
    };
  
    function init() {
      // Only some languages support predictive search
      if (document.getElementById('shopify-features')) {
        var supportedShopifyFeatures = JSON.parse(document.getElementById('shopify-features').innerHTML);
        if (!supportedShopifyFeatures.predictiveSearch) {
          return;
        }
      }
  
      cache.wrapper = document.querySelector(selectors.wrapper);
  
      if (!cache.wrapper) {
        return;
      }
  
      config.imageSize = cache.wrapper.dataset.imageSize;
  
      cache.form = document.querySelector(selectors.form);
      cache.form.setAttribute('autocomplete', 'off');
      cache.form.on('submit' + namespace, submitSearch);
  
      cache.input = cache.form.querySelector(selectors.input);
      cache.input.on('keyup' + namespace, handleKeyup);
  
      cache.submit = cache.wrapper.querySelector(selectors.searchButton);
      cache.submit.on('click' + namespace, triggerSearch);
  
      cache.results = document.querySelector(selectors.resultDiv);
    }
  
    function reset() {
      cache.wrapper.classList.add('hide');
      cache.results.innerHTML = '';
      clearTimeout(searchTimeout);
    }
  
    function triggerSearch() {
      cache.form.submit();
    }
  
    // Append * wildcard to search
    function submitSearch(evt) {
      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;
  
      var obj = {};
      var formData = new FormData(evt.target);
      for (var key of formData.keys()) {
        obj[key] = formData.get(key);
      }
  
      if (obj.q) {
        obj.q += '*';
      }
  
      var params = paramUrl(obj);
  
      window.location.href = '/search?' + params;
      return false;
    }
  
    function handleKeyup(evt) {
      if (evt.keyCode === keys.up_arrow) {
        return;
      }
  
      if (evt.keyCode === keys.down_arrow) {
        return;
      }
  
      if (evt.keyCode === keys.tab) {
        return;
      }
  
      search();
    }
  
    function search() {
      var keyword = cache.input.value;
  
      if (keyword === '') {
        reset();
        return;
      }
  
      var q = _normalizeQuery(keyword);
  
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(
        function () {
          predictQuery(q);
        }.bind(this),
        500
      );
    }
  
    function predictQuery(q) {
      if (isLoading) {
        return;
      }
  
      // Do not re-search the same thing
      if (currentString === q) {
        return;
      }
  
      currentString = q;
      isLoading = true;
  
      var searchObj = {
        'q': q,
        'resources[type]': theme.settings.predictiveSearchType,
        'resources[limit]': 4,
        'resources[options][unavailable_products]': 'last',
        'resources[options][fields]': 'title,product_type,variants.title,vendor'
      };
  
      var params = paramUrl(searchObj);
  
      fetch('/search/suggest.json?' + params)
      .then(response => response.json())
      .then(suggestions => {
        isLoading = false;
        var data = {};
        var resultCount = 0;
  
        cache.wrapper.classList.remove('hide');
        var resultTypes = Object.entries(suggestions.resources.results);
  
        Object.keys(resultTypes).forEach(function (i) {
          var obj = resultTypes[i];
          var type = obj[0];
          var results = obj[1];
          resultCount += results.length;
  
          switch(type) {
            case 'products':
              data[type] = buildProducts(results);
              break;
            case 'collections':
              data[type] = buildCollections(results);
              break;
            case 'pages':
              data[type] = buildPages(results);
              break;
            case 'articles':
              data[type] = buildArticles(results);
              break;
          }
        });
  
        if (resultCount === 0) {
          reset();
          return;
        }
  
        // Build and append result markup
        var output = buildOutput(data);
        cache.results.innerHTML = '';
        cache.results.innerHTML = output;
      });
    }
  
    function buildProducts(results) {
      var output = '';
      var products = [];
  
      results.forEach(product => {
        var new_product = {
          title: product.title,
          url: product.url,
          image_responsive_url: theme.Images.lazyloadImagePath(product.image),
          image_aspect_ratio: product.featured_image.aspect_ratio
        };
  
        products.push(new_product);
      });
  
      if (products.length) {
        var markup = theme.buildProductGridItem(products, 'small--one-half medium-up--one-quarter', 4, config.imageSize);
  
        output = `
          <div data-type-products>
            <div class="grid grid--uniform">
              ${markup}
            </div>
          </div>
        `;
      }
  
      return output;
    }
  
    function buildCollections(collections) {
      var output = '';
  
      if (collections.length) {
        var markup = theme.buildCollectionItem(collections);
  
        output = `
          <div data-type-collections>
            <p class="h6 predictive__label">${theme.strings.searchCollections}</p>
            <ul class="no-bullets">
              ${markup}
            </ul>
          </div>
        `;
      }
  
      return output;
    }
  
    function buildPages(pages) {
      var output = '';
  
      if (pages.length) {
        var markup = theme.buildPageItem(pages);
  
        output = `
          <div data-type-pages>
            <p class="h6 predictive__label">${theme.strings.searchPages}</p>
            <ul class="no-bullets">
              ${markup}
            </ul>
          </div>
        `;
      }
  
      return output;
    }
  
    // Overwrite full sized image returned form API
    // with lazyloading-friendly path
    function buildArticles(articles) {
      var output = '';
  
      articles.forEach(article => {
        if (article.image) {
          article.image = theme.Images.getSizedImageUrl(article.image, '200x200_crop_center');
        }
      });
  
      if (articles.length) {
        var markup = theme.buildArticleItem(articles, config.imageSize);
  
        output = `
          <div data-type-articles>
            <p class="h6 predictive__label">${theme.strings.searchArticles}</p>
            <div class="grid grid--uniform">
              ${markup}
            </div>
          </div>
        `;
      }
  
      return output;
    }
  
    // Combine all search result markup and print to page
    function buildOutput(data) {
      var output = '';
  
      if (data.products && data.products !== '') {
        output += data.products;
      }
  
      if (data.collections && data.collections !== '') {
        output += data.collections;
      }
  
      if (data.pages && data.pages !== '') {
        output += data.pages;
      }
  
      if (data.articles && data.articles !== '') {
        output += data.articles;
      }
  
      return output;
    }
  
    function _normalizeQuery(string) {
      if (typeof string !== 'string') {
        return null;
      }
  
      return string
        .trim()
        .replace(/\ /g, '-')
        .toLowerCase();
    }
  
    function paramUrl(obj) {
      return Object.keys(obj).map(function(key) {
        return key + '=' + encodeURIComponent(obj[key]);
      }).join('&')
    }
  
    return {
      init: init
    };
  })();
  
  theme.buildProductGridItem = function(items, gridWidth, rowOf, imageSize) {
    var output = '';
  
    items.forEach(product => {
      var image = theme.buildProductImage(product, imageSize);
      var markup = `
        <div class="grid__item grid-product ${gridWidth} aos-animate" data-aos="row-of-${rowOf}">
          <div class="grid-product__content">
            <a href="${product.url}" class="grid-product__link">
              <div class="grid-product__image-mask">
                ${image}
              </div>
              <div class="grid-product__meta">
                <div class="grid-product__title">${product.title}</div>
              </div>
            </a>
          </div>
        </div>
      `;
  
      output += markup;
    });
  
    return output;
  }
  
  theme.buildProductImage = function(product, imageSize) {
    var size = imageSize ? imageSize : theme.settings.productImageSize;
    var output = '';
  
    if (size === 'natural') {
      output = `
        <div class="image-wrap" style="height: 0; padding-bottom: ${product.image_aspect_ratio}%;">
          <img class="grid-product__image lazyload"
            data-src="${product.image_responsive_url}"
            data-widths="[180, 360, 540, 720, 900]"
            data-aspectratio="${product.image_aspect_ratio}"
            data-sizes="auto"
            alt="${product.title}">
        </div>`;
    } else {
      var classes = 'lazyload';
      if (!theme.settings.productImageCover) {
        classes += ' grid__image-contain';
      }
      output = `
        <div class="grid__image-ratio grid__image-ratio--${size}">
          <img class="${classes}"
              data-src="${product.image_responsive_url}"
              data-widths="[360, 540, 720, 900, 1080]"
              data-aspectratio="${product.aspect_ratio}"
              data-sizes="auto"
              alt="${product.title}">
        </div>
      `;
    }
  
    return output;
  }
  
  theme.buildCollectionItem = function(items) {
    var output = '';
  
    items.forEach(collection => {
      var markup = `
        <li>
          <a href="${collection.url}">
            ${collection.title}
          </a>
        </li>
      `;
  
      output += markup;
    });
  
    return output;
  }
  
  theme.buildPageItem = function(items) {
    var output = '';
  
    items.forEach(page => {
      var markup = `
        <li>
          <a href="${page.url}">
            ${page.title}
          </a>
        </li>
      `;
  
      output += markup;
    });
  
    return output;
  }
  
  theme.buildArticleItem = function(items, imageSize) {
    var output = '';
  
    items.forEach(article => {
      var image = theme.buildPredictiveImage(article);
      var markup = `
        <div class="grid__item grid-product small--one-half medium-up--one-quarter" data-aos="row-of-4">
          <a href="${article.url}" class="grid-product__link grid-product__link--inline">
            <div class="grid-product__image-mask">
              <div
                class="grid__image-ratio grid__image-ratio--object grid__image-ratio--${imageSize}">
                <div class="predictive__image-wrap">
                  ${image}
                </div>
              </div>
            </div>
            <div class="grid-product__meta">
              ${article.title}
            </div>
          </a>
        </div>
      `;
  
      output += markup;
    });
  
    return output;
  }
  
  theme.buildPredictiveImage = function(obj) {
    var imageMarkup = '';
    if (obj.image) {
      imageMarkup = `<img class="lazyload"
            data-src="${obj.image}"
            data-widths="[360, 540, 720]"
            data-sizes="auto">`;
    }
    return imageMarkup;
  }
  

  theme.Maps = (function() {
    var config = {
      zoom: 14
    };
    var apiStatus = null;
    var mapsToLoad = [];
  
    var errors = {};
  
    var selectors = {
      section: '[data-section-type="map"]',
      map: '[data-map]',
      mapOverlay: '.map-section__overlay'
    };
  
    // Global function called by Google on auth errors.
    // Show an auto error message on all map instances.
    window.gm_authFailure = function() {
      if (!Shopify.designMode) {
        return;
      }
  
      document.querySelectorAll(selectors.section).forEach(section => {
        section.classList.add('map-section--load-error');
      });
  
      document.querySelectorAll(selectors.map).forEach(map => {
        map.parentNode.removeChild(map);
      });
  
      window.mapError(theme.strings.authError);
    };
  
    window.mapError = function(error) {
      var message = document.createElement('div');
      message.classList.add('map-section__error', 'errors', 'text-center');
      message.innerHTML = error;
      document.querySelectorAll(selectors.mapOverlay).forEach(overlay => {
        overlay.parentNode.prepend(message);
      });
      document.querySelectorAll('.map-section__link').forEach(link => {
        link.classList.add('hide');
      });
    };
  
    function Map(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.namespace = '.map-' + this.sectionId;
      this.map = container.querySelector(selectors.map);
      this.key = this.map.dataset.apiKey;
  
      errors = {
        addressNoResults: theme.strings.addressNoResults,
        addressQueryLimit: theme.strings.addressQueryLimit,
        addressError: theme.strings.addressError,
        authError: theme.strings.authError
      };
  
      if (!this.key) {
        return;
      }
  
      theme.initWhenVisible({
        element: this.container,
        callback: this.prepMapApi.bind(this),
        threshold: 20
      });
    }
  
    // API has loaded, load all Map instances in queue
    function initAllMaps() {
      mapsToLoad.forEach(instance => {
        instance.createMap();
      });
    }
  
    function geolocate(map) {
      var geocoder = new google.maps.Geocoder();
  
      if (!map) {
        return;
      }
  
      var address = map.dataset.addressSetting;
  
      var deferred = new Promise((resolve, reject) => {
        geocoder.geocode({ address: address }, function(results, status) {
          if (status !== google.maps.GeocoderStatus.OK) {
            reject(status);
          }
          resolve(results);
        });
      });
  
      return deferred;
    }
  
    Map.prototype = Object.assign({}, Map.prototype, {
      prepMapApi: function() {
        if (apiStatus === 'loaded') {
          this.createMap();
        } else {
          mapsToLoad.push(this);
  
          if (apiStatus !== 'loading') {
            apiStatus = 'loading';
            if (typeof window.google === 'undefined' || typeof window.google.maps === 'undefined' ) {
  
              var script = document.createElement('script');
              script.onload = function () {
                apiStatus = 'loaded';
                initAllMaps();
              };
              script.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.key;
              document.head.appendChild(script);
            }
          }
        }
      },
  
      createMap: function() {
        var mapDiv = this.map;
  
        return geolocate(mapDiv)
          .then(
            function(results) {
              var mapOptions = {
                zoom: config.zoom,
                backgroundColor: 'none',
                center: results[0].geometry.location,
                draggable: false,
                clickableIcons: false,
                scrollwheel: false,
                disableDoubleClickZoom: true,
                disableDefaultUI: true
              };
  
              var map = (this.map = new google.maps.Map(mapDiv, mapOptions));
              var center = (this.center = map.getCenter());
  
              var marker = new google.maps.Marker({
                map: map,
                position: map.getCenter()
              });
  
              google.maps.event.addDomListener(
                window,
                'resize',
                theme.utils.debounce(250, function() {
                  google.maps.event.trigger(map, 'resize');
                  map.setCenter(center);
                  mapDiv.removeAttribute('style');
                })
              );
  
              if (Shopify.designMode) {
                if (window.AOS) { AOS.refreshHard() }
              }
            }.bind(this)
          )
          .catch(function(status) {
            var errorMessage;
  
            switch (status) {
              case 'ZERO_RESULTS':
                errorMessage = errors.addressNoResults;
                break;
              case 'OVER_QUERY_LIMIT':
                errorMessage = errors.addressQueryLimit;
                break;
              case 'REQUEST_DENIED':
                errorMessage = errors.authError;
                break;
              default:
                errorMessage = errors.addressError;
                break;
            }
  
            // Show errors only to merchant in the editor.
            if (Shopify.designMode) {
              window.mapError(errorMessage);
            }
          });
      },
  
      onUnload: function() {
        if (this.map.length === 0) {
          return;
        }
        // Causes a harmless JS error when a section without an active map is reloaded
        if (google && google.maps && google.maps.event) {
          google.maps.event.clearListeners(this.map, 'resize');
        }
      }
    });
  
    return Map;
  })();
  
  theme.NewsletterPopup = (function() {
    function NewsletterPopup(container) {
      this.container = container;
      var sectionId = this.container.getAttribute('data-section-id');
      this.cookieName = 'newsletter-' + sectionId;
  
      if (!container) {
        return;
      }
  
      // Prevent popup on Shopify robot challenge page
      if (window.location.pathname === '/challenge') {
        return;
      }
  
      this.data = {
        secondsBeforeShow: container.dataset.delaySeconds,
        daysBeforeReappear: container.dataset.delayDays,
        cookie: Cookies.get(this.cookieName),
        testMode: container.dataset.testMode
      };
  
      this.modal = new theme.Modals('NewsletterPopup-' + sectionId, 'newsletter-popup-modal');
  
      // Open modal if errors or success message exist
      if (container.querySelector('.errors') || container.querySelector('.note--success')) {
        this.modal.open();
      }
  
      // Set cookie as opened if success message
      if (container.querySelector('.note--success')) {
        this.closePopup(true);
        return;
      }
  
      document.addEventListener('modalClose.' + container.id, this.closePopup.bind(this));
  
      if (!this.data.cookie || this.data.testMode === 'true') {
        this.initPopupDelay();
      }
    }
  
    NewsletterPopup.prototype = Object.assign({}, NewsletterPopup.prototype, {
      initPopupDelay: function() {
        if (Shopify && Shopify.designMode) {
          return;
        }
        setTimeout(function() {
          this.modal.open();
        }.bind(this), this.data.secondsBeforeShow * 1000);
      },
  
      closePopup: function(success) {
        // Remove a cookie in case it was set in test mode
        if (this.data.testMode === 'true') {
          Cookies.remove(this.cookieName, { path: '/' });
          return;
        }
  
        var expiry = success ? 200 : this.data.daysBeforeReappear;
        Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });
      },
  
      onLoad: function() {
        this.modal.open();
      },
  
      onSelect: function() {
        this.modal.open();
      },
  
      onDeselect: function() {
        this.modal.close();
      }
    });
  
    return NewsletterPopup;
  })();
  
  theme.PasswordHeader = (function() {
    function PasswordHeader() {
      this.init();
    }
  
    PasswordHeader.prototype = Object.assign({}, PasswordHeader.prototype, {
      init: function() {
        if (!document.querySelector('#LoginModal')) {
          return;
        }
  
        var passwordModal = new theme.Modals('LoginModal', 'login-modal', {
          focusIdOnOpen: 'password',
          solid: true
        });
  
        // Open modal if errors exist
        if (document.querySelectorAll('.errors').length) {
          passwordModal.open();
        }
      }
    });
  
    return PasswordHeader;
  })();
  
  theme.Photoswipe = (function() {
    var selectors = {
      trigger: '.js-photoswipe__zoom',
      images: '.photoswipe__image',
      slideshowTrack: '.flickity-viewport ',
      activeImage: '.is-selected'
    };
  
    function Photoswipe(container, sectionId) {
      this.container = container;
      this.sectionId = sectionId;
      this.namespace = '.photoswipe-' + this.sectionId;
      this.gallery;
      this.images;
      this.items;
      this.inSlideshow = false;
  
      if (!container || container.dataset.zoom === 'false') {
        return;
      }
  
      if (container.dataset.hasSlideshow === 'true') {
        this.inSlideshow = true;
      }
  
      this.init();
    }
  
    Photoswipe.prototype = Object.assign({}, Photoswipe.prototype, {
      init: function() {
        this.container.querySelectorAll(selectors.trigger).forEach(trigger => {
          trigger.on('click' + this.namespace, this.triggerClick.bind(this));
        });
      },
  
      triggerClick: function(evt) {
        this.items = this.getImageData();
  
        var image = this.inSlideshow ? this.container.querySelector(selectors.activeImage) : evt.currentTarget;
  
        var index = this.inSlideshow ? this.getChildIndex(image) : image.dataset.index;
  
        this.initGallery(this.items, index);
      },
  
      // Because of image set feature, need to get index based on location in parent
      getChildIndex: function(el) {
        var i = 0;
        while( (el = el.previousSibling) != null ) {
          i++;
        }
  
        // 1-based index required
        return i + 1;
      },
  
      getImageData: function() {
        let self = this;

        this.images = this.inSlideshow
                        ? this.container.querySelectorAll(selectors.slideshowTrack + selectors.images)
                        : this.container.querySelectorAll(selectors.images);
  
        var items = [];
        var options = {};
  
        this.images.forEach(function(element, index) {
          let el = {};
          let dataIndex = element.dataset.index;
          let sameIndexImages = self.container.querySelectorAll('img[data-index="' + dataIndex + '"');

          if (sameIndexImages.length && items.findIndex(item => item.index == dataIndex) == -1) { 
            if (sameIndexImages.length == 1) {
              el = element; // if we have just an item, it is the default one
            } else if (theme.config.bpSmall) {
              el = sameIndexImages[0]; // if we have just more images (mobile and desktop) we show the correct image accoring to the device width and first one is the mobile one
            } else {
              el = sameIndexImages[1]; // The second one is the desktop one
            }

            var item = {
              msrc: el.currentSrc || el.src,
              src: el.getAttribute('data-photoswipe-src'),
              w: el.getAttribute('data-photoswipe-width'),
              h: el.getAttribute('data-photoswipe-height'),
              el: el,
              initialZoomLevel: 0.5
            }
    
            items.push({
              index: dataIndex,
              item: item
            });
          }
        });
  
        return items.map(item => item.item);
      },
  
      initGallery: function(items, index) {
        var pswpElement = document.querySelectorAll('.pswp')[0];
  
        var options = {
          allowPanToNext: false,
          captionEl: false,
          closeOnScroll: false,
          counterEl: false,
          history: false,
          index: index - 1,
          pinchToClose: false,
          preloaderEl: false,
          scaleMode: 'zoom',
          shareEl: false,
		  bgOpacity: 0.75,
		  timeToIdle: 2000,
		  scaleMode: 'fit',
          tapToToggleControls: false,
          getThumbBoundsFn: function(index) {
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            var thumbnail = items[index].el;
            var rect = thumbnail.getBoundingClientRect();
            return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
          }
        }
  
        this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        this.gallery.init();		  
        this.gallery.listen('afterChange', this.afterChange.bind(this));
      },
  
      afterChange: function() {
        var index = this.gallery.getCurrentIndex();
        this.container.dispatchEvent(new CustomEvent('photoswipe:afterChange', {
          detail: {
            index: index
          }
        }));
      }
    });
  
    return Photoswipe;
  })();
  
  
  theme.Recommendations = (function() {
    var selectors = {
      placeholder: '.product-recommendations-placeholder',
      sectionClass: ' .product-recommendations',
      productResults: '.grid-product'
    }
  
    function Recommendations(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.url = container.dataset.url;
  
      selectors.recommendations = 'Recommendations-' + this.sectionId;
  
      theme.initWhenVisible({
        element: container,
        callback: this.init.bind(this),
        threshold: 500
      });
    }
  
    Recommendations.prototype = Object.assign({}, Recommendations.prototype, {
      init: function() {
        var section = document.getElementById(selectors.recommendations);
  
        if (!section || section.dataset.enable === 'false') {
          return;
        }
  
        var id = section.dataset.productId;
        var limit = section.dataset.limit;
  
        var url = this.url + '?section_id=product-recommendations&limit='+ limit +'&product_id=' + id;
  
        fetch(url).then(function(response) {
          return response.text();
        }).then(function(html) {
          // Convert the HTML string into a document object
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var div = doc.querySelector(selectors.sectionClass);
          var placeholder = section.querySelector(selectors.placeholder);
          if (!placeholder) {
            return;
          }
  
          placeholder.innerHTML = '';
  
          if (!div) {
            this.container.classList.add('hide');
            return;
          }
  
          placeholder.appendChild(div);
  
          theme.reinitProductGridItem(section);
  
          document.dispatchEvent(new CustomEvent('recommendations:loaded', {
            detail: {
              section: section
            }
          }));
  
          // If no results, hide the entire section
          var results = div.querySelectorAll(selectors.productResults);
          if (results.length === 0) {
            this.container.classList.add('hide');
          }
        }.bind(this));
      }
    });
  
    return Recommendations;
  })();
  
  theme.SlideshowSection = (function() {
  
    var selectors = {
      parallaxContainer: '.parallax-container'
    };
  
    function SlideshowSection(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Slideshow-' + sectionId);
      this.namespace = '.' + sectionId;
  
      if (!this.slideshow) { return }
  
      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);
  
      if (sectionIndex === 0) {
        this.init();
      } else {
        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this)
        });
      }
  
    }
  
    SlideshowSection.prototype = Object.assign({}, SlideshowSection.prototype, {
      init: function() {
        var slides = this.slideshow.querySelectorAll('.slideshow__slide');
  
        theme.loadImageSection(this.slideshow);
  
        if (slides.length > 1) {
          var sliderArgs = {
            prevNextButtons: this.slideshow.hasAttribute('data-arrows'),
            pageDots: this.slideshow.hasAttribute('data-dots'),
            fade: this.slideshow.hasAttribute('data-fade'),
            setGallerySize: false,
            autoPlay: this.slideshow.dataset.autoplay === 'true'
              ? parseInt(this.slideshow.dataset.speed)
              : false,
            wrapAround: this.slideshow.hasAttribute('data-wraparound')
          };

          console.log(sliderArgs);
  
          this.flickity = new theme.Slideshow(this.slideshow, sliderArgs);
        } else {
          // Add loaded class to first slide
          slides[0].classList.add('is-selected');
        }
  
        if (this.container.hasAttribute('data-parallax')) {
          // Create new parallax for each slideshow image
          this.container.querySelectorAll(selectors.parallaxContainer).forEach(function(el, i) {
            new theme.Parallax(el, {
              namespace: this.namespace + '-parallax-' + i
            });
          }.bind(this));
        }
      },
  
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
      onUnload: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },
  
      onDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },
  
      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.slideshow__slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);
  
        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        }
      },
  
      onBlockDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      }
    });
  
    return SlideshowSection;
  })();
  
  theme.StoreAvailability = (function() {
    var selectors = {
      drawerOpenBtn: '.js-drawer-open-availability',
      productTitle: '[data-availability-product-title]'
    };
  
    function StoreAvailability(container) {
      this.container = container;
      this.baseUrl = container.dataset.baseUrl;
      this.productTitle = container.dataset.productName;
    }
  
    StoreAvailability.prototype = Object.assign({}, StoreAvailability.prototype, {
      updateContent: function(variantId) {
        var variantSectionUrl =
          this.baseUrl +
          '/variants/' +
          variantId +
          '/?section_id=store-availability';
  
        this.container.innerHTML = '';
  
        var self = this;
  
        fetch(variantSectionUrl)
          .then(function(response) {
            return response.text();
          })
          .then(function(storeAvailabilityHTML) {
            if (storeAvailabilityHTML.trim() === '') {
              return;
            }
  
            self.container.innerHTML = storeAvailabilityHTML;
            self.container.innerHTML = self.container.firstElementChild.innerHTML;
  
            // Only create drawer if have open button
            if (!self.container.querySelector(selectors.drawerOpenBtn)) {
              return;
            }
  
            self.drawer = new theme.Drawers('StoreAvailabilityDrawer', 'availability');
  
            self.container.querySelector(selectors.productTitle).textContent = self.productTitle;
          });
      }
    });
  
    return StoreAvailability;
  })();
  
  theme.VideoSection = (function() {
    var selectors = {
      videoParent: '.video-parent-section'
    };
  
    function videoSection(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.namespace = '.video-' + this.sectionId;
      this.videoObject;
  
      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 500
      });
    }
  
    videoSection.prototype = Object.assign({}, videoSection.prototype, {
      init: function() {
        var dataDiv = this.container.querySelector('.video-div');
        if (!dataDiv) {
          return;
        }
        var type = dataDiv.dataset.type;
  
        switch(type) {
          case 'youtube':
            var videoId = dataDiv.dataset.videoId;
            this.initYoutubeVideo(videoId);
            break;
          case 'vimeo':
            var videoId = dataDiv.dataset.videoId;
            this.initVimeoVideo(videoId);
            break;
          case 'mp4':
            this.initMp4Video();
            break;
        }
      },
  
      initYoutubeVideo: function(videoId) {
        this.videoObject = new theme.YouTube(
          'YouTubeVideo-' + this.sectionId,
          {
            videoId: videoId,
            videoParent: selectors.videoParent
          }
        );
      },
  
      initVimeoVideo: function(videoId) {
        this.videoObject = new theme.VimeoPlayer(
          'Vimeo-' + this.sectionId,
          videoId,
          {
            videoParent: selectors.videoParent
          }
        );
      },
  
      initMp4Video: function() {
        var mp4Video = 'Mp4Video-' + this.sectionId;
        var mp4Div = document.getElementById(mp4Video);
        var parent = mp4Div.closest(selectors.videoParent);
  
        if (mp4Div) {
          parent.classList.add('loaded');
  
          var playPromise = document.querySelector('#' + mp4Video).play();
  
          // Edge does not return a promise (video still plays)
          if (playPromise !== undefined) {
            playPromise.then(function() {
                // playback normal
              }).catch(function() {
                mp4Div.setAttribute('controls', '');
                parent.classList.add('video-interactable');
              });
          }
        }
      },
  
      onUnload: function(evt) {
        var sectionId = evt.target.id.replace('shopify-section-', '');
        if (this.videoObject && typeof this.videoObject.destroy === 'function') {
          this.videoObject.destroy();
        }
      }
    });
  
    return videoSection;
  })();
  

  theme.BackgroundImage = (function() {
  
    var selectors = {
      parallaxContainer: '.parallax-container'
    };
  
    function backgroundImage(container) {
      this.container = container;
      if (!container) {
        return;
      }
  
      var sectionId = container.getAttribute('data-section-id');
      this.namespace = '.' + sectionId;
  
      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this)
      });
    }
  
    backgroundImage.prototype = Object.assign({}, backgroundImage.prototype, {
      init: function() {
        if (this.container.dataset && this.container.dataset.parallax) {
          var parallaxContainer = this.container.querySelector(selectors.parallaxContainer);
          var args = {
            namespace: this.namespace + '-parallax',
            desktopOnly: true
          };
  
          theme.parallaxSections[this.namespace] = new theme.Parallax(parallaxContainer, args);
        }
      },
  
      onUnload: function(evt) {
        if (!this.container) { return }
        if (theme.parallaxSections[this.namespace] && typeof theme.parallaxSections[this.namespace].destroy === 'function') {
          theme.parallaxSections[this.namespace].destroy();
        }
        delete theme.parallaxSections[this.namespace];
      }
    });
  
    return backgroundImage;
  })();
  
  theme.Blog = (function() {
  
    function Blog(container) {
      this.tagFilters();
    }
  
    Blog.prototype = Object.assign({}, Blog.prototype, {
      tagFilters: function() {
        var filterBy = document.getElementById('BlogTagFilter');
  
        if (!filterBy) {
          return;
        }
  
        filterBy.addEventListener('change', function() {
          location.href = filterBy.value;
        });
      }
    });
  
    return Blog;
  })();
  
  theme.CollectionHeader = (function() {
    var hasLoadedBefore = false;
  
    function CollectionHeader(container) {
      this.namespace = '.collection-header';
  
      var heroImageContainer = container.querySelector('.collection-hero');
      if (heroImageContainer) {
        if (hasLoadedBefore) {
          this.checkIfNeedReload();
        }
        theme.loadImageSection(heroImageContainer);
  
        if (container.dataset && container.dataset.parallax) {
          var parallaxContainer = container.querySelector('.parallax-container');
          var args = {
            namespace: this.namespace + '-parallax'
          };
          theme.parallaxSections[this.namespace] = new theme.Parallax(parallaxContainer, args);
        }
      } else if (theme.settings.overlayHeader) {
        theme.headerNav.disableOverlayHeader();
      }
  
      hasLoadedBefore = true;
    }
  
    CollectionHeader.prototype = Object.assign({}, CollectionHeader.prototype, {
      // A liquid variable in the header needs a full page refresh
      // if the collection header hero image setting is enabled
      // and the header is set to sticky. Only necessary in the editor.
      checkIfNeedReload: function() {
        if (!Shopify.designMode) {
          return;
        }
  
        if (theme.settings.overlayHeader) {
          var header = document.querySelector('.header-wrapper');
          if (!header.classList.contains('header-wrapper--overlay')) {
            location.reload();
          }
        }
      },
  
      onUnload: function() {
        if (theme.parallaxSections[this.namespace]) {
          theme.parallaxSections[this.namespace].destroy();
          delete theme.parallaxSections[this.namespace];
        }
      }
    });
  
    return CollectionHeader;
  })();
  
  theme.CollectionSidebar = (function() {
    var drawerStyle = false;
  
    function CollectionSidebar(container) {
      this.container = container;
      this.init();
    }
  
    CollectionSidebar.prototype = Object.assign({}, CollectionSidebar.prototype, {
      init: function() {
        this.onUnload();
  
        drawerStyle = this.container.dataset.style === 'drawer';
        theme.FilterDrawer = new theme.Drawers('FilterDrawer', 'collection-filters', true);
      },
  
      forceReload: function() {
        this.init();
      },
  
      onSelect: function() {
        if (theme.FilterDrawer) {
          if (!drawerStyle) {
            theme.FilterDrawer.close();
            return;
          }
  
          if (drawerStyle || theme.config.bpSmall) {
            theme.FilterDrawer.open();
          }
        }
      },
  
      onDeselect: function() {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
      },
  
      onUnload: function() {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
      }
    });
  
    return CollectionSidebar;
  })();
  
  theme.Collection = (function() {
    var isAnimating = false;
  
    var selectors = {
      sortSelect: '#SortBy',
  
      colorSwatchImage: '.grid-product__color-image',
      colorSwatch: '.color-swatch--with-image',
  
      collectionGrid: '.collection-grid__wrapper',
      sidebar: '#CollectionSidebar',
      activeTagList: '.tag-list--active-tags',
      tags: '.tag-list a',
      filters: '.collection-filter'
    };
  
    var config = {
      combineTags: false
    };
  
    var classes = {
      activeTag: 'tag--active',
      removeTagParent: 'tag--remove'
    };
  
    function Collection(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.namespace = '.collection-' + this.sectionId;
  
      this.init();
    }
  
    Collection.prototype = Object.assign({}, Collection.prototype, {
      init: function() {
        this.initSort();
        this.colorSwatchHovering();
        this.initFilters();
        theme.sections.reinit('collection-sidebar');
      },
  
      initSort: function() {
        this.sortSelect = this.container.querySelector(selectors.sortSelect);
  
        if (this.sortSelect) {
          this.defaultSort = this.getDefaultSortValue();
          this.sortSelect.addEventListener('change', this.onSortChange.bind(this));
          this.initParams();
        }
      },
  
      initParams: function() {
        this.queryParams = {};
  
        if (location.search.length) {
          var aKeyValue;
          var aCouples = location.search.substr(1).split('&');
          for (var i = 0; i < aCouples.length; i++) {
            aKeyValue = aCouples[i].split('=');
            if (aKeyValue.length > 1) {
              this.queryParams[
                decodeURIComponent(aKeyValue[0])
              ] = decodeURIComponent(aKeyValue[1]);
            }
          }
        }
      },
  
      getSortValue: function() {
        return this.sortSelect.value || this.defaultSort;
      },
  
      getDefaultSortValue: function() {
        return this.sortSelect.getAttribute('data-default-sortby');
      },
  
      onSortChange: function() {
        this.queryParams.sort_by = this.getSortValue();
  
        if (this.queryParams.page) {
          delete this.queryParams.page;
        }
  
        window.location.search = new URLSearchParams(Object.entries(this.queryParams));
      },
  
      colorSwatchHovering: function() {
        var colorImages = this.container.querySelectorAll(selectors.colorSwatchImage);
        if (!colorImages.length) {
          return;
        }
  
        this.container.querySelectorAll(selectors.colorSwatch).forEach(swatch => {
          swatch.addEventListener('mouseenter', function() {
            var id = swatch.dataset.variantId;
            var image = swatch.dataset.variantImage;
            var el = document.querySelector('.grid-product__color-image--' + id);
            el.style.backgroundImage = 'url(' + image + ')';
            el.classList.add('is-active');
          });
          swatch.addEventListener('mouseleave', function() {
            var id = swatch.dataset.variantId;
            document.querySelector('.grid-product__color-image--' + id).classList.remove('is-active');
          });
        });
      },
  
      /*====================
        Collection filters
      ====================*/
      initFilters: function() {
        var tags = document.querySelectorAll(selectors.tags);
  
        if (!tags.length) {
          return;
        }
  
        // Ajax pagination
        window.addEventListener('popstate', function(state) {
          if (state) {
            this.getNewCollectionContent(location.href);
          }
        }.bind(this));
  
        // Set mobile top value for filters if sticky header enabled
        if (theme.config.stickyHeader) {
          this.setFilterStickyPosition();
  
          window.on('resize', theme.utils.debounce(500, this.setFilterStickyPosition));
        }
  
        config.combineTags = (document.querySelector(selectors.sidebar).getAttribute('data-combine-tags') == 'true');
  
        document.querySelectorAll(selectors.tags).forEach(tag => {
          tag.addEventListener('click', this.tagClick.bind(this));
        });
      },
  
      tagClick: function(evt) {
        var el = evt.currentTarget;
  
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
  
        // Do not ajax-load collection links
        if (el.classList.contains('no-ajax')) {
          return;
        }
  
        evt.preventDefault();
        if (isAnimating) {
          return;
        }
  
        isAnimating = true;
  
        var parent = el.parentNode;
        var newUrl = el.href;
  
        if (config.combineTags) {
          if (parent.classList.contains(classes.activeTag)) {
            parent.classList.remove(classes.activeTag);
          } else {
            parent.classList.add(classes.activeTag);
  
            // If adding a tag, show new tag right away.
            // Otherwise, remove it before ajax finishes
            if (el.closest('li').classList.contains(classes.removeTagParent)) {
              parent.remove();
            } else {
              var newTag = document.createElement('li');
              var newTagLink = document.createElement('a');
              newTag.classList.add('tag', 'tag--remove');
              newTagLink.classList.add('btn', 'btn--small');
              newTagLink.innerText = el.innerText;
              newTag.appendChild(newTagLink);
  
              // Append new tag in both drawer and sidebar
              document.querySelectorAll(selectors.activeTagList).forEach(list => {
                list.appendChild(newTag);
              });
            }
          }
        } else {
          // Remove active state on all tags, re-add to new one
          document.querySelectorAll(selectors.tags).forEach(tag => {
            tag.parentNode.classList.remove(classes.activeTag);
          });
          parent.classList.add(classes.activeTag);
        }
  
        this.updateScroll(true);
  
        history.pushState({}, '', newUrl);
        document.querySelector(selectors.collectionGrid).classList.add('unload');
        this.getNewCollectionContent(newUrl);
      },
  
      getNewCollectionContent: function(url) {
        url = url.indexOf('?') === -1 ? (url + '?view=ajax') : (url + '&view=ajax');
  
        var ajaxContainer = document.getElementById('CollectionAjaxResult');
  
        fetch(url).then(function(response) {
          return response.text();
        }).then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
  
          var newContent = doc.getElementById('CollectionAjaxContent');
  
          ajaxContainer.innerHTML = '';
          ajaxContainer.append(newContent);
  
          theme.sections.reinit('collection-template');
          this.updateScroll(false);
          theme.reinitProductGridItem();
  
          isAnimating = false;
  
          // trigger resize?
        }.bind(this));
      },
  
      updateScroll: function(animate) {
        var scrollTo;
        if (theme.config.bpSmall) {
          // 60 is ~ height of sticky filters
          scrollTo = document.querySelector('[data-scroll-to]').offsetTop - 60;
        } else {
          scrollTo = document.getElementById('CollectionAjaxResult').offsetTop + 1;
        }
  
        if (theme.config.stickyHeader) {
          var headerHeight = document.querySelector('.site-header').offsetHeight;
          scrollTo = scrollTo - headerHeight;
        }
  
        if (animate) {
          window.scrollTo({top: scrollTo, behavior: 'smooth'});
        } else {
          window.scrollTo({top: scrollTo});
        }
      },
  
      setFilterStickyPosition: function() {
        var headerHeight = document.querySelector('.site-header').offsetHeight;
        document.querySelector(selectors.filters).style.top = headerHeight + 10 + 'px';
  
        // Also update top position of sticky sidebar
        var stickySidebar = document.querySelector('.grid__item--sidebar');
        if (stickySidebar) {
          stickySidebar.style.top = headerHeight + 10 + 'px';
        }
      },
  
      forceReload: function() {
        this.init();
      }
    });
  
    return Collection;
  })();
  
  
  theme.FooterSection = (function() {
    var selectors = {
      locale: '[data-disclosure-locale]',
      currency: '[data-disclosure-currency]'
    };
  
    function FooterSection(container) {
      this.container = container;
  
      this.container = container;
      this.localeDisclosure = null;
      this.currencyDisclosure = null;
  
      this.init();
    }
  
    FooterSection.prototype = Object.assign({}, FooterSection.prototype, {
      init: function() {
        var localeEl = this.container.querySelector(selectors.locale);
        var currencyEl = this.container.querySelector(selectors.currency);
  
        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl);
        }
  
        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl);
        }
  
        // Change email icon to submit text
        var newsletterInput = document.querySelector('.footer__newsletter-input');
        if (newsletterInput) {
          newsletterInput.addEventListener('keyup', function() {
            newsletterInput.classList.add('footer__newsletter-input--active');
          });
        }
  
        // Re-hook up collapsible box triggers
        theme.collapsibles.init(this.container);
      },
  
      onUnload: function() {
        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }
  
        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      }
    });
  
    return FooterSection;
  })();
  
  theme.HeaderSection = (function() {
  
    var selectors = {
      locale: '[data-disclosure-locale]',
      currency: '[data-disclosure-currency]'
    };
  
    function HeaderSection(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
  
      this.init();
    }
  
    HeaderSection.prototype = Object.assign({}, HeaderSection.prototype, {
      init: function() {
        // Reload any slideshow if header is reloaded to make sure
        // sticky header works as expected
        // (can be anywhere in sections.instance array)
        if (Shopify && Shopify.designMode) {
          theme.sections.reinit('slideshow-section');
  
          // Set a timer to resize the header in case the logo changes size
          setTimeout(function() {
            window.dispatchEvent(new Event('resize'));
          }, 500);
        }
  
        this.initDrawers();
        this.initDisclosures();
        theme.headerNav.init();
        theme.announcementBar.init();
      },
  
      initDisclosures: function() {
        var localeEl = this.container.querySelector(selectors.locale);
        var currencyEl = this.container.querySelector(selectors.currency);
  
        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl);
        }
  
        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl);
        }
      },
  
      initDrawers: function() {
        theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');
        theme.RegionDrawer = new theme.Drawers('RegionDrawer', 'region');
        theme.PaintsDrawer = new theme.Drawers('PaintsDrawer', 'paints');
        
        if (theme.settings.cartType === 'drawer') {
          new theme.CartDrawer();
        }
  
        theme.collapsibles.init(document.getElementById('NavDrawer'));
      },
  
      onBlockSelect: function(evt) {
        theme.announcementBar.onBlockSelect(evt.detail.blockId);
      },
  
      onBlockDeselect: function() {
        theme.announcementBar.onBlockDeselect();
      },
  
      onUnload: function() {
        theme.NavDrawer.close();
        theme.announcementBar.unload();
  
        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }
  
        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      }
    });
  
    return HeaderSection;
  })();
  
  theme.Product = (function() {
    var videoObjects = {};
  
    var classes = {
      onSale: 'on-sale',
      disabled: 'disabled',
      isModal: 'is-modal',
      loading: 'loading',
      loaded: 'loaded',
      hidden: 'hide',
      interactable: 'video-interactable',
      visuallyHide: 'visually-invisible'
    };
  
    var selectors = {
      productVideo: '.product__video',
      videoParent: '.product__video-wrapper',
      slide: '.product-main-slide',
      currentSlide: '.is-selected',
      startingSlide: '.starting-slide'
    };
  
    function Product(container) {
      this.container = container;
      var sectionId = this.sectionId = container.getAttribute('data-section-id');
  
      this.inModal = (container.dataset.modal === 'true');
      this.modal;
  
      this.settings = {
        enableHistoryState: container.dataset.history || false,
        namespace: '.product-' + sectionId,
        inventory: container.dataset.inventory || false,
        incomingInventory: container.dataset.incomingInventory || false,
        modalInit: false,
        hasImages: true,
        imageSetName: null,
        imageSetIndex: null,
        currentImageSet: null,
        imageSize: '620x',
        currentSlideIndex: 0,
        videoLooping: container.dataset.videoLooping
      };
  
      // Overwrite some settings when loaded in modal
      if (this.inModal) {
        this.settings.enableHistoryState = false;
        this.settings.namespace = '.product-' + sectionId + '-modal';
        this.modal = document.getElementById('QuickShopModal-' + sectionId);
      }
  
      this.selectors = {
        variantsJson: 'VariantsJson-' + sectionId,
        currentVariantJson: 'CurrentVariantJson-' + sectionId,
        form: '#AddToCartForm-' + sectionId,
  
        media: '[data-product-media-type-model]',
        closeMedia: '.product-single__close-media',
        photoThumbs: '.product__thumb-' + sectionId,
        thumbSlider: '#ProductThumbs-' + sectionId,
        thumbScroller: '.product__thumbs--scroller',
        mainSlider: '#ProductPhotos-' + sectionId,
        imageContainer: '[data-product-images]',
        productImageMain: '.product-image-main--' + sectionId,
  
        priceWrapper: '.product__price-wrap-' + sectionId,
        price: '#ProductPrice-' + sectionId,
        comparePrice: '#ComparePrice-' + sectionId,
        savePrice: '#SavePrice-' + sectionId,
        priceA11y: '#PriceA11y-' + sectionId,
        comparePriceA11y: '#ComparePriceA11y-' + sectionId,

        priceWrapperMobile: '.product__price-wrap-' + sectionId + '-mobile',
        priceMobile: '#ProductPrice-' + sectionId + '-mobile',
        comparePriceMobile: '#ComparePrice-' + sectionId + '-mobile',
        savePriceMobile: '#SavePrice-' + sectionId + '-mobile',
        priceA11yMobile: '#PriceA11y-' + sectionId + '-mobile',
        comparePriceA11yMobile: '#ComparePriceA11y-' + sectionId + '-mobile',

        unitWrapper: '.product__unit-price-wrapper--' + sectionId,
        unitPrice: '.product__unit-price--' + sectionId,
        unitPriceBaseUnit: '.product__unit-base--' + sectionId,
        sku: 'Sku-' + sectionId,
        inventory: 'ProductInventory-' + sectionId,
        incomingInventory: 'ProductIncomingInventory-' + sectionId,
  
        addToCart: 'AddToCart-' + sectionId,
        addToCartText: 'AddToCartText-' + sectionId,
  
        originalSelectorId: '#ProductSelect-' + sectionId,
        singleOptionSelector: '.variant__input-' + sectionId,
        variantColorSwatch: '.variant__input--color-swatch-' + sectionId,
  
        modalFormHolder: '#ProductFormHolder-' + sectionId,
        availabilityContainer: '#StoreAvailabilityHolder-' + sectionId
      };
  
      this.cache = {
        form: container.querySelector(this.selectors.form),
        mainSlider: container.querySelector(this.selectors.mainSlider),
        thumbSlider: container.querySelector(this.selectors.thumbSlider),
        thumbScroller: container.querySelector(this.selectors.thumbScroller),
        productImageMain: container.querySelector(this.selectors.productImageMain),
  
        // Price-related
        priceWrapper: container.querySelector(this.selectors.priceWrapper),
        comparePriceA11y: container.querySelector(this.selectors.comparePriceA11y),
        comparePrice: container.querySelector(this.selectors.comparePrice),
        price: container.querySelector(this.selectors.price),
        savePrice: container.querySelector(this.selectors.savePrice),
        priceA11y: container.querySelector(this.selectors.priceA11y),

        priceWrapperMobile: container.querySelector(this.selectors.priceWrapperMobile),
        comparePriceA11yMobile: container.querySelector(this.selectors.comparePriceA11yMobile),
        comparePriceMobile: container.querySelector(this.selectors.comparePriceMobile),
        priceMobile: container.querySelector(this.selectors.priceMobile),
        savePriceMobile: container.querySelector(this.selectors.savePriceMobile),
        priceA11yMobile: container.querySelector(this.selectors.priceA11yMobile)
      };
  
      this.firstProductImage = this.cache.mainSlider.querySelector('img');
  
      if (!this.firstProductImage) {
        this.settings.hasImages = false;
      }
  
      var dataSetEl = this.cache.mainSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.settings.imageSetName = dataSetEl.dataset.setName;
      }
  
      this.init();
    }
  
    Product.prototype = Object.assign({}, Product.prototype, {
      init: function() {
        if (this.inModal) {
          this.container.classList.add(classes.isModal);
          document.addEventListener('modalOpen.QuickShopModal-' + this.sectionId, this.openModalProduct.bind(this));
          document.addEventListener('modalClose.QuickShopModal-' + this.sectionId, this.closeModalProduct.bind(this));
        }
  
        if (!this.inModal) {
          this.formSetup();
          this.productSetup();
          this.videoSetup();
          this.initProductSlider();
          this.customMediaListners();
          this.addIdToRecentlyViewed();
        }
      },
  
      formSetup: function() {
        this.initQtySelector();
        this.initAjaxProductForm();
        this.availabilitySetup();
        this.initVariants();
  
        // We know the current variant now so setup image sets
        if (this.settings.imageSetName) {
          this.updateImageSet();
        }
      },
  
      availabilitySetup: function() {
        var container = this.container.querySelector(this.selectors.availabilityContainer);
        if (container) {
          this.storeAvailability = new theme.StoreAvailability(container);
        }
      },
  
      productSetup: function() {
        this.setImageSizes();
        this.initImageZoom();
        this.initModelViewerLibraries();
        this.initShopifyXrLaunch();
      },
  
      setImageSizes: function() {
        if (!this.settings.hasImages) {
          return;
        }
  
        // Get srcset image src, works on most modern browsers
        // otherwise defaults to settings.imageSize
        var currentImage = this.firstProductImage.currentSrc;
  
        if (currentImage) {
          this.settings.imageSize = theme.Images.imageSize(currentImage);
        }
      },
  
      addIdToRecentlyViewed: function() {
        var handle = this.container.getAttribute('data-product-handle');
        var url = this.container.getAttribute('data-product-url');
        var aspectRatio = this.container.getAttribute('data-aspect-ratio');
        var featuredImage = this.container.getAttribute('data-img-url');
  
        // Remove current product if already in set of recent
        if (theme.recentlyViewed.recent.hasOwnProperty(handle)) {
          delete theme.recentlyViewed.recent[handle];
        }
  
        // Add it back to the end
        theme.recentlyViewed.recent[handle] = {
          url: url,
          aspectRatio: aspectRatio,
          featuredImage: featuredImage
        };
  
        if (theme.config.hasLocalStorage) {
          window.localStorage.setItem('theme-recent', JSON.stringify(theme.recentlyViewed.recent));
        }
      },
  
      initVariants: function() {
        var variantJson = document.getElementById(this.selectors.variantsJson);
  
        if (!variantJson) {
          return;
        }
  
        this.variantsObject = JSON.parse(variantJson.innerHTML);
  
        var options = {
          container: this.container,
          enableHistoryState: this.settings.enableHistoryState,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          variants: this.variantsObject
        };
  
        var swatches = this.container.querySelectorAll(this.selectors.variantColorSwatch);
        if (swatches.length) {
          swatches.forEach(swatch => {
            swatch.addEventListener('change', function(evt) {
              var color = swatch.dataset.colorName;
              var index = swatch.dataset.colorIndex;
              this.updateColorName(color, index);
            }.bind(this))
          });
        }
  
        this.variants = new theme.Variants(options);
  
        // Product availability on page load
        if (this.storeAvailability) {
          var variant_id = this.variants.currentVariant ? this.variants.currentVariant.id : this.variants.variants[0].id;
  
          this.storeAvailability.updateContent(variant_id);
          this.container.on('variantChange' + this.settings.namespace, this.updateAvailability.bind(this));
        }
  
        this.container.on('variantChange' + this.settings.namespace, this.updateCartButton.bind(this));
        this.container.on('variantImageChange' + this.settings.namespace, this.updateVariantImage.bind(this));
        this.container.on('variantPriceChange' + this.settings.namespace, this.updatePrice.bind(this));
        this.container.on('variantUnitPriceChange' + this.settings.namespace, this.updateUnitPrice.bind(this));
  
        if (document.getElementById(this.selectors.sku)) {
          this.container.on('variantSKUChange' + this.settings.namespace, this.updateSku.bind(this));
        }
  
        if (this.settings.inventory || this.settings.incomingInventory) {
          this.container.on('variantChange' + this.settings.namespace, this.updateInventory.bind(this));
        }
  
        // Update individual variant availability on each selection
        if (theme.settings.dynamicVariantsEnable) {
          var currentVariantJson = document.getElementById(this.selectors.currentVariantJson);
  
          if (currentVariantJson) {
            new theme.VariantAvailability({
              type: theme.settings.dynamicVariantType,
              variantSelectors: this.cache.form.querySelectorAll(this.selectors.singleOptionSelector),
              variantsObject: this.variantsObject,
              currentVariantObject: JSON.parse(currentVariantJson.innerHTML),
              form: this.cache.form
            });
          }
        }
  
        // image set names variant change listeners
        if (this.settings.imageSetName) {
          this.settings.imageSetIndex = this.cache.form.querySelector('.variant-input-wrap[data-handle="'+this.settings.imageSetName+'"]').dataset.index;
          this.container.on('variantChange' + this.settings.namespace, this.updateImageSet.bind(this))
        }
      },
  
      initQtySelector: function() {
        this.container.querySelectorAll('.js-qty__wrapper').forEach(el => {
          new theme.QtySelector(el, {
            namespace: '.product'
          });
        });
      },
  
      initAjaxProductForm: function() {
        if (theme.settings.cartType === 'drawer') {
          new theme.AjaxProduct(this.cache.form);
        }
      },
  
      /*============================================================================
        Variant change methods
      ==============================================================================*/
      updateColorName: function(color, index) {
        // Updates on radio button change, not variant.js
        this.container.querySelector('#VariantColorLabel-' + this.sectionId + '-' + index).textContent = color;
      },
  
      updateCartButton: function(evt) {
        var variant = evt.detail.variant;
        var cartBtn = document.getElementById(this.selectors.addToCart);
        var cartBtnText = document.getElementById(this.selectors.addToCartText);
  
        if (variant) {
          if (variant.available) {
            // Available, enable the submit button and change text
            cartBtn.classList.remove(classes.disabled);
            cartBtn.disabled = false;
            var defaultText = cartBtnText.dataset.defaultText;
            cartBtnText.textContent = defaultText;
          } else {
            // Sold out, disable the submit button and change text
            cartBtn.classList.add(classes.disabled);
            cartBtn.disabled = true;
            cartBtnText.textContent = theme.strings.soldOut;
          }
        } else {
          // The variant doesn't exist, disable submit button
          cartBtn.classList.add(classes.disabled);
          cartBtn.disabled = true;
          cartBtnText.textContent = theme.strings.unavailable;
        }
      },
  
      updatePrice: function(evt) {
        var variant = evt.detail.variant;
  
        if (variant) {
          // Regular price
          this.cache.price.innerHTML = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
          this.cache.priceMobile.innerHTML = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
  
          // Sale price, i§f necessary
          if (variant.compare_at_price > variant.price) {
            this.cache.comparePrice.innerHTML = theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat);
            this.cache.priceWrapper.classList.remove(classes.hidden);
            this.cache.price.classList.add(classes.onSale);
            this.cache.comparePriceA11y.setAttribute('aria-hidden', 'false');
            this.cache.priceA11y.setAttribute('aria-hidden', 'false');

            this.cache.comparePriceMobile.innerHTML = theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat);
            this.cache.priceWrapperMobile.classList.remove(classes.hidden);
            this.cache.priceMobile.classList.add(classes.onSale);
            this.cache.comparePriceA11yMobile.setAttribute('aria-hidden', 'false');
            this.cache.priceA11yMobile.setAttribute('aria-hidden', 'false');
  
            var savings = variant.compare_at_price - variant.price;
  
            if (theme.settings.saveType == 'percent') {
              savings = Math.round(((savings) * 100) / variant.compare_at_price) + '%';
            } else {
              savings = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
            }
  
            this.cache.savePrice.classList.remove(classes.hidden);
            this.cache.savePrice.innerHTML = theme.strings.savePrice.replace('[saved_amount]', savings);

            this.cache.savePriceMonile.classList.remove(classes.hidden);
            this.cache.savePriceMobile.innerHTML = theme.strings.savePrice.replace('[saved_amount]', savings);
          } else {
            if (this.cache.priceWrapper) {
              this.cache.priceWrapper.classList.add(classes.hidden);
              this.cache.priceWrapperMobile.classList.add(classes.hidden);
            }
            this.cache.savePrice.classList.add(classes.hidden);
            this.cache.price.classList.remove(classes.onSale);
            this.cache.savePriceMobile.classList.add(classes.hidden);
            this.cache.priceMobile.classList.remove(classes.onSale);
            if (this.cache.comparePriceA11y) {
              this.cache.comparePriceA11y.setAttribute('aria-hidden', 'true');
              this.cache.comparePriceA11yMobile.setAttribute('aria-hidden', 'true');
            }
            this.cache.priceA11y.setAttribute('aria-hidden', 'true');
            this.cache.priceA11yMobile.setAttribute('aria-hidden', 'true');
          }
        }
      },
  
      updateUnitPrice: function(evt) {
        var variant = evt.detail.variant;
  
        if (variant && variant.unit_price) {
          this.container.querySelector(this.selectors.unitPrice).innerHTML = theme.Currency.formatMoney(variant.unit_price, theme.settings.moneyFormat);
          this.container.querySelector(this.selectors.unitPriceBaseUnit).innerHTML = theme.Currency.getBaseUnit(variant);
          this.container.querySelector(this.selectors.unitWrapper).classList.remove(classes.hidden);
        } else {
          this.container.querySelector(this.selectors.unitWrapper).classList.add(classes.hidden);
        }
      },
  
      imageSetArguments: function(variant) {
        var variant = variant ? variant : (this.variants ? this.variants.currentVariant : null);
        if (!variant) return;
  
        var setValue = this.settings.currentImageSet = this.getImageSetName(variant[this.settings.imageSetIndex]);
        var set = this.settings.imageSetName + '_' + setValue;
  
        // Always start on index 0
        this.settings.currentSlideIndex = 0;
  
        // Return object that adds cellSelector to mainSliderArgs
        return {
          cellSelector: '[data-group="'+set+'"]',
          imageSet: set,
          initialIndex: this.settings.currentSlideIndex
        }
      },
  
      updateImageSet: function(evt) {
        // If called directly, use current variant
        var variant = evt ? evt.detail.variant : (this.variants ? this.variants.currentVariant : null);
        if (!variant) {
          return;
        }
  
        var setValue = this.getImageSetName(variant[this.settings.imageSetIndex]);
  
        // Already on the current image group
        if (this.settings.currentImageSet === setValue) {
          return;
        }
  
        this.initProductSlider(variant);
      },
  
      // Show/hide thumbnails based on current image set
      updateImageSetThumbs: function(set) {
        this.cache.thumbSlider.querySelectorAll('.product__thumb-item').forEach(thumb => {
          thumb.classList.toggle(classes.hidden, thumb.dataset.group !== set);
        });
      },
  
      getImageSetName: function(string) {
        return string.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
      },
  
      updateSku: function(evt) {
        var variant = evt.detail.variant;
        var newSku = '';
  
        if (variant) {
          if (variant.sku) {
            newSku = variant.sku;
          }
  
          document.getElementById(this.selectors.sku).textContent = newSku;
        }
      },
  
      updateInventory: function(evt) {
        var variant = evt.detail.variant;
  
        // Hide stock if no inventory management or policy is continue
        if (!variant || !variant.inventory_management || variant.inventory_policy === 'continue') {
          this.toggleInventoryQuantity(false);
          this.toggleIncomingInventory(false);
          return;
        }
  
        if (variant.inventory_management === 'shopify' && window.inventories && window.inventories[this.sectionId]) {
          var variantInventoryObject = window.inventories[this.sectionId][variant.id];
          var quantity = variantInventoryObject.quantity;
          var showInventory = true;
          var showIncomingInventory = false;
  
          if (quantity <= 0 || quantity > theme.settings.inventoryThreshold) {
            showInventory = false;
          }
  
          this.toggleInventoryQuantity(showInventory, quantity);
  
          // Only show incoming inventory when:
          // - inventory notice itself is hidden
          // - have incoming inventory
          // - current quantity is below theme setting threshold
          if (!showInventory && variantInventoryObject.incoming === 'true' && quantity <= theme.settings.inventoryThreshold) {
            showIncomingInventory = true;
          }
  
          this.toggleIncomingInventory(showIncomingInventory, variant.available, variantInventoryObject.next_incoming_date);
        }
      },
  
      updateAvailability: function(evt) {
        var variant = evt.detail.variant;
        if (!variant) {
          return;
        }
  
        this.storeAvailability.updateContent(variant.id);
      },
  
      toggleInventoryQuantity: function(show, qty) {
        if (!this.settings.inventory) {
          show = false;
        }
  
        var el = document.getElementById(this.selectors.inventory);
  
        if (show) {
          el.classList.remove(classes.hidden);
          el.textContent = theme.strings.stockLabel.replace('[count]', qty);
        } else {
          el.classList.add(classes.hidden);
        }
      },
  
      toggleIncomingInventory: function(show, available, date) {
        if (!this.settings.incomingInventory) {
          show = false;
        }
  
        var el = document.getElementById(this.selectors.incomingInventory);
  
        if (!el) {
          return;
        }
  
        if (show) {
          var string = available ?
                       theme.strings.willNotShipUntil.replace('[date]', date) :
                       theme.strings.willBeInStockAfter.replace('[date]', date);
  
          if (!date) {
            string = theme.strings.waitingForStock;
          }
  
          el.classList.remove(classes.hidden);
          el.textContent = string;
        } else {
          el.classList.add(classes.hidden);
        }
      },
  
      /*============================================================================
        Product videos
      ==============================================================================*/
      videoSetup: function() {
        var productVideos = this.cache.mainSlider.querySelectorAll(selectors.productVideo);
  
        if (!productVideos.length) {
          return false;
        }
  
        productVideos.forEach(vid => {
          var type = vid.dataset.videoType;
          if (type === 'youtube') {
            this.initYoutubeVideo(vid);
          } else if (type === 'mp4') {
            this.initMp4Video(vid);
          }
        });
      },
  
      initYoutubeVideo: function(div) {
        videoObjects[div.id] = new theme.YouTube(
          div.id,
          {
            videoId: div.dataset.youtubeId,
            videoParent: selectors.videoParent,
            autoplay: false, // will handle this in callback
            style: div.dataset.videoStyle,
            loop: div.dataset.videoLoop,
            events: {
              onReady: this.youtubePlayerReady.bind(this),
              onStateChange: this.youtubePlayerStateChange.bind(this)
            }
          }
        );
      },
  
      // Comes from YouTube SDK
      // Get iframe ID with evt.target.getIframe().id
      // Then access product video players with videoObjects[id]
      youtubePlayerReady: function(evt) {
        var iframeId = evt.target.getIframe().id;
  
        if (!videoObjects[iframeId]) {
          // No youtube player data
          return;
        }
  
        var obj = videoObjects[iframeId];
        var player = obj.videoPlayer;
  
        if (obj.options.style !== 'sound') {
          player.mute();
        }
  
        obj.parent.classList.remove('loading');
        obj.parent.classList.add('loaded');
  
        // If we have an element, it is in the visible/first slide,
        // and is muted, play it
        if (this._isFirstSlide(iframeId) && obj.options.style !== 'sound') {
          player.playVideo();
        }
      },
  
      _isFirstSlide: function(id) {
        return this.cache.mainSlider.querySelector(selectors.startingSlide + ' ' + '#' + id);
      },
  
      youtubePlayerStateChange: function(evt) {
        var iframeId = evt.target.getIframe().id;
        var obj = videoObjects[iframeId];
  
        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (obj.attemptedToPlay) {
              obj.parent.classList.add('video-interactable');
            }
            break;
          case 0: // ended
            if (obj && obj.options.loop === 'true') {
              obj.videoPlayer.playVideo();
            }
            break;
          case 3: // buffering
            obj.attemptedToPlay = true;
            break;
        }
      },
  
      initMp4Video: function(div) {
        videoObjects[div.id] = {
          id: div.id,
          type: 'mp4'
        };
  
        if (this._isFirstSlide(div.id)) {
          this.playMp4Video(div.id);
        }
      },
  
      stopVideos: function() {
        for (var [id, vid] of Object.entries(videoObjects)) {
          if (vid.videoPlayer) {
            if (typeof vid.videoPlayer.stopVideo === 'function') {
              vid.videoPlayer.stopVideo(); // YouTube player
            }
          } else if (vid.type === 'mp4') {
            this.stopMp4Video(vid.id); // MP4 player
          }
        }
      },
  
      _getVideoType: function(video) {
        return video.getAttribute('data-video-type');
      },
  
      _getVideoDivId: function(video) {
        return video.id;
      },
  
      playMp4Video: function(id) {
        var player = this.container.querySelector('#' + id);
        var playPromise = player.play();
  
        if (playPromise !== undefined) {
          playPromise.then(function() {
            // Playing as expected
          })
          .catch(function(error) {
            // Likely low power mode on iOS, show controls
            player.setAttribute('controls', '');
            player.closest(selectors.videoParent).setAttribute('data-video-style', 'unmuted');
          });
        }
      },
  
      stopMp4Video: function(id) {
        var player = this.container.querySelector('#' + id);
        if (player && typeof player.pause === 'function') {
          player.pause();
        }
      },
  
      /*============================================================================
        Product images
      ==============================================================================*/
      initImageZoom: function() {
        var container = this.container.querySelector(this.selectors.imageContainer);
        if (!container) {
          return;
        }
        var imageZoom = new theme.Photoswipe(container, this.sectionId);
        container.addEventListener('photoswipe:afterChange', function(evt) {
          if (this.flickity) {
            this.flickity.goToSlide(evt.detail.index);
          }
        }.bind(this));
      },
  
      getThumbIndex: function(target) {
        return target.dataset.index;
      },
  
      updateVariantImage: function(evt) {
        var variant = evt.detail.variant;
        var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_media.preview_image.src, this.settings.imageSize);
  
        var newImage = this.container.querySelector('.product__thumb[data-id="' + variant.featured_media.id + '"]');
        var imageIndex = this.getThumbIndex(newImage);
  
        // If there is no index, slider is not initalized
        if (typeof imageIndex === 'undefined') {
          return;
        }
  
        // Go to that variant image's slide
        if (this.flickity) {
          this.flickity.goToSlide(imageIndex);
        }
      },
  
      initProductSlider: function(variant) {
        // Stop if only a single image, but add active class to first slide
        if (this.cache.mainSlider.querySelectorAll(selectors.slide).length <= 1) {
          this.cache.mainSlider.querySelector(selectors.slide).classList.add('is-selected');
          return;
        }
  
        // Destroy slider in preparation of new initialization
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
  
        // If variant argument exists, slideshow is reinitializing because of the
        // image set feature enabled and switching to a new group.
        // currentSlideIndex
        if (!variant) {
          var activeSlide = this.cache.mainSlider.querySelector(selectors.startingSlide);
          this.settings.currentSlideIndex = this._slideIndex(activeSlide);
        }
  
        var mainSliderArgs = {
          adaptiveHeight: true,
          avoidReflow: true,
          initialIndex: this.settings.currentSlideIndex,
          childNav: this.cache.thumbSlider,
          childNavScroller: this.cache.thumbScroller,
          childVertical: this.cache.thumbSlider.dataset.position === 'beside',
          pageDots: true, // mobile only with CSS
          wrapAround: true,
          callbacks: {
            onChange: this.onSlideChange.bind(this)
          }
        };
  
        // Override default settings if image set feature enabled
        if (this.settings.imageSetName) {
          var imageSetArgs = this.imageSetArguments(variant);
          mainSliderArgs = Object.assign({}, mainSliderArgs, imageSetArgs);
          this.updateImageSetThumbs(mainSliderArgs.imageSet);
        }
  
        this.flickity = new theme.Slideshow(this.cache.mainSlider, mainSliderArgs);
      },
  
      onSlideChange: function(index) {
        if (!this.flickity) return;
  
        var allSlides = this.cache.mainSlider.querySelectorAll(selectors.slide);
        var prevSlide = allSlides[this.settings.currentSlideIndex];
        var nextSlide = allSlides[index];
  
        prevSlide.setAttribute('tabindex', '-1');
        nextSlide.setAttribute('tabindex', 0);
  
        // Pause any existing slide video/media
        this.stopMediaOnSlide(prevSlide);
  
        // Prep next slide video/media
        this.prepMediaOnSlide(nextSlide);
  
        // Update current slider index
        this.settings.currentSlideIndex = index;
      },
  
      stopMediaOnSlide(slide) {
        // Stop existing video
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === 'youtube') {
            if (videoObjects[videoId].videoPlayer) {
              videoObjects[videoId].videoPlayer.stopVideo();
              return;
            }
          } else if (videoType === 'mp4') {
            this.stopMp4Video(videoId);
            return;
          }
        }
  
        // Stop existing media
        var currentMedia = slide.querySelector(this.selectors.media);
        if (currentMedia) {
          currentMedia.dispatchEvent(
            new CustomEvent('mediaHidden', {
              bubbles: true,
              cancelable: true
            })
          );
        }
      },
  
      prepMediaOnSlide(slide) {
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === 'youtube') {
            if (videoObjects[videoId].videoPlayer && videoObjects[videoId].options.style !== 'sound') {
              videoObjects[videoId].videoPlayer.playVideo();
              return;
            }
          } else if (videoType === 'mp4') {
            this.playMp4Video(videoId);
          }
        }
  
        var nextMedia = slide.querySelector(this.selectors.media);
        if (nextMedia) {
          nextMedia.dispatchEvent(
            new CustomEvent('mediaVisible', {
              bubbles: true,
              cancelable: true
            })
          );
          slide.querySelector('.shopify-model-viewer-ui__button').setAttribute('tabindex', 0);
          slide.querySelector('.product-single__close-media').setAttribute('tabindex', 0);
        }
      },
  
      _slideIndex: function(el) {
        return el.getAttribute('data-index');
      },
  
      /*============================================================================
        Products when in quick view modal
      ==============================================================================*/
      openModalProduct: function() {
        var initialized = false;
  
        if (!this.settings.modalInit) {
          var formHolder = this.container.querySelector(this.selectors.modalFormHolder);
          var url = formHolder.dataset.url;
          var template = formHolder.dataset.template;
  
          // Use stripped down ajax version for faster loading,
          // unless preorder template is used so we show right button
          if (template !== 'preorder') {
            url = url + '?view=ajax';
          }
  
          fetch(url).then(function(response) {
            return response.text();
          }).then(function(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            this.cache.form = doc.querySelector('#AddToCartForm-' + this.sectionId);
  
            formHolder.innerHTML = '';
            formHolder.append(this.cache.form);
            formHolder.classList.add('product-form-holder--loaded');
  
            this.formSetup();
  
            if (Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
  
            document.dispatchEvent(new CustomEvent('quickview:loaded', {
              detail: {
                productId: this.sectionId
              }
            }));
          }.bind(this));
  
          this.productSetup();
          this.videoSetup();
  
          // Setup product inventory data
          this.updateModalProductInventory();
  
          // Enable product slider in quick view
          // 1. with image sets enabled, make sure we have this.variants before initializing
          // 2. initialize normally, form data not required
          if (this.settings.imageSetName) {
            if (this.variants) {
              this.initProductSlider();
            } else {
              document.addEventListener('quickview:loaded', function(evt) {
                if (evt.detail.productId === this.sectionId) {
                  this.initProductSlider();
                }
              }.bind(this));
            }
          } else {
            this.initProductSlider();
          }
          this.customMediaListners();
          this.addIdToRecentlyViewed();
          this.settings.modalInit = true;
        } else {
          initialized = true;
        }
  
        AOS.refreshHard();
  
        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: {
            initialized: initialized,
            productId: this.sectionId
          }
        }));
      },
  
      // Recommended products load via JS and don't add variant inventory to the
      // global variable that we later check. This function scrapes a data div
      // to get that info and manually add the values.
      updateModalProductInventory: function() {
        window.inventories = window.inventories || {};
        this.container.querySelectorAll('.js-product-inventory-data').forEach(el => {
          var sectionId = el.dataset.sectionId;
          window.inventories[sectionId] = {};
  
          el.querySelectorAll('.js-variant-inventory-data').forEach(el => {
            window.inventories[sectionId][el.dataset.id] = {
              'quantity': el.dataset.quantity,
              'incoming': el.dataset.incoming,
              'next_incoming_date': el.dataset.date
            }
          });
        });
      },
  
      closeModalProduct: function() {
        this.stopVideos();
      },
  
      /*============================================================================
        Product media (3D)
      ==============================================================================*/
      initModelViewerLibraries: function() {
        var modelViewerElements = this.container.querySelectorAll(this.selectors.media);
        if (modelViewerElements.length < 1) return;
  
        theme.ProductMedia.init(modelViewerElements, this.sectionId);
      },
  
      initShopifyXrLaunch: function() {
        document.addEventListener(
          'shopify_xr_launch',
          function() {
            var currentMedia = this.container.querySelector(
              this.selectors.productMediaWrapper +
                ':not(.' +
                self.classes.hidden +
                ')'
            );
            currentMedia.dispatchEvent(
              new CustomEvent('xrLaunch', {
                bubbles: true,
                cancelable: true
              })
            );
          }.bind(this)
        );
      },
  
      customMediaListners: function() {
        document.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.addEventListener('click', function() {
            var slide = this.cache.mainSlider.querySelector(selectors.currentSlide);
            var media = slide.querySelector(this.selectors.media);
            if (media) {
              media.dispatchEvent(
                new CustomEvent('mediaHidden', {
                  bubbles: true,
                  cancelable: true
                })
              );
            }
          }.bind(this))
        });
  
        var modelViewer = this.container.querySelector('model-viewer');
        if (modelViewer) {
          modelViewer.addEventListener('shopify_model_viewer_ui_toggle_play', function(evt) {
            this.mediaLoaded(evt);
          }.bind(this));
  
          modelViewer.addEventListener('shopify_model_viewer_ui_toggle_pause', function(evt) {
            this.mediaUnloaded(evt);
          }.bind(this));
        }
      },
  
      mediaLoaded: function(evt) {
        this.container.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.classList.remove(classes.hidden);
        });
  
        if (this.flickity) {
          this.flickity.setDraggable(false);
        }
      },
  
      mediaUnloaded: function(evt) {
        this.container.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.classList.add(classes.hidden);
        });
  
        if (this.flickity) {
          this.flickity.setDraggable(true);
        }
      },
  
      onUnload: function() {
        theme.ProductMedia.removeSectionModels(this.sectionId);
  
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      }
    });
  
    return Product;
  })();
  
  theme.RecentlyViewed = (function() {
    var init = false;
  
    function RecentlyViewed(container) {
      if (!container) {
        return;
      }
  
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.namespace = '.recently-viewed' + this.sectionId;
      this.gridItemWidth = this.container.getAttribute('data-grid-item-class');
      this.rowOf = this.container.getAttribute('data-row-of');
  
      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    };
  
    RecentlyViewed.prototype = Object.assign({}, RecentlyViewed.prototype, {
      init: function() {
        if (init) {
          return;
        }
  
        init = true;
  
        if (Object.keys(theme.recentlyViewed.recent).length === 0 && theme.recentlyViewed.recent.constructor === Object) {
          // No previous history on page load, so bail
          this.container.classList.add('hide');
          return;
        }
  
        this.outputContainer = document.getElementById('RecentlyViewed-' + this.sectionId);
        this.handle = this.container.getAttribute('data-product-handle');
  
        // Request new product info via JS API
        var promises = [];
        Object.keys(theme.recentlyViewed.recent).forEach(function (handle) {
          if (handle !== 'undefined') {
            promises.push(this.getProductInfo(handle));
          }
        }.bind(this));
  
        Promise.all(promises).then(function(result) {
          this.setupOutput(result);
          this.captureProductDetails(result);
        }.bind(this));
      },
  
      getProductInfo: function(handle) {
        return new Promise(function(resolve, reject) {
          if (theme.recentlyViewed.productInfo.hasOwnProperty(handle)) {
            resolve(theme.recentlyViewed.productInfo[handle]);
          } else {
            fetch('/products/'+ handle +'.js').then(function(response) {
              return response.text();
            }).then(function(product) {
              resolve(product);
            });
          }
        });
      },
  
      setupOutput: function(products) {
        var allProducts = [];
        var data = {};
        var limit = this.container.getAttribute('data-recent-count');
  
        var i = 0;
  
        Object.keys(products).forEach(function (key) {
          if (!products[key]) {
            return;
          }
          var product = JSON.parse(products[key]);
  
          // Ignore current product
          if (product.handle === this.handle) {
            return;
          }
  
          // Ignore undefined key
          if (typeof product.handle == 'undefined') {
            return;
          }
  
          i++;
  
          // New or formatted properties
          product.url = theme.recentlyViewed.recent[product.handle] ? theme.recentlyViewed.recent[product.handle].url : product.url;
          product.image_responsive_url = theme.recentlyViewed.recent[product.handle].featuredImage;
          product.image_aspect_ratio = theme.recentlyViewed.recent[product.handle].aspectRatio;
  
          // Unit pricing checks first variant
          var firstVariant = product.variants[0];
          if (firstVariant && firstVariant.unit_price) {
            var baseUnit = '';
  
            if (firstVariant.unit_price_measurement) {
              if (firstVariant.unit_price_measurement.reference_value != 1) {
                baseUnit += firstVariant.unit_price_measurement.reference_value + ' ';
              }
              baseUnit += firstVariant.unit_price_measurement.reference_unit;
            }
  
            product.unit_price = theme.Currency.formatMoney(firstVariant.unit_price);
            if (baseUnit != '') {
              product.unit_price += '/' + baseUnit;
            }
          }
  
          allProducts.unshift(product);
        }.bind(this));
  
        if (allProducts.length === 0) {
          this.container.classList.add('hide');
          return;
        }
  
        var productMarkup = theme.buildProductGridItem(allProducts.slice(0, limit), this.gridItemWidth, this.rowOf);
  
        this.outputContainer.innerHTML = productMarkup;
  
        if (AOS) {
          AOS.refreshHard();
        }
      },
  
      captureProductDetails: function(products) {
        for (var i = 0; i < products.length; i++) {
          var product = products[i];
          theme.recentlyViewed.productInfo[product.handle] = product;
        }
  
        // Add data to session storage to reduce API requests later
        if (theme.config.hasSessionStorage) {
          sessionStorage.setItem('recent-products', JSON.stringify(theme.recentlyViewed.productInfo));
        }
      },
  
      onUnload: function() {
        init = false;
      }
    });
  
    return RecentlyViewed;
  })();
  
  theme.Testimonials = (function() {
    var defaults = {
      adaptiveHeight: true,
      avoidReflow: true,
      pageDots: true,
      prevNextButtons: false
    };
  
    function Testimonials(container) {
      this.container = container;
      this.timeout;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Testimonials-' + sectionId);
      this.namespace = '.testimonial-' + sectionId;
  
      if (!this.slideshow) { return }
  
      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    }
  
    Testimonials.prototype = Object.assign({}, Testimonials.prototype, {
      init: function() {
        // Do not wrap when only a few blocks
        if (this.slideshow.dataset.count <= 3) {
          defaults.wrapAround = false;
        }
  
        this.flickity = new theme.Slideshow(this.slideshow, defaults);
  
        // Autoscroll to next slide on load to indicate more blocks
        if (this.slideshow.dataset.count > 2) {
          this.timeout = setTimeout(function() {
            this.flickity.goToSlide(1);
          }.bind(this), 1000);
        }
      },
  
      onUnload: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },
  
      onDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },
  
      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.testimonials-slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);
  
        clearTimeout(this.timeout);
  
        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        }
      },
  
      onBlockDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      }
    });
  
    return Testimonials;
  })();
  

  theme.isStorageSupported = function(type) {
    // Return false if we are in an iframe without access to sessionStorage
    if (window.self !== window.top) {
      return false;
    }

    var testKey = 'test';
    var storage;
    if (type === 'session') {
      storage = window.sessionStorage;
    }
    if (type === 'local') {
      storage = window.localStorage;
    }

    try {
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  };

  theme.reinitProductGridItem = function(scope) {
    if (AOS) {AOS.refreshHard()}

    // // theme.initQuickShop();

    // Refresh reviews app
    if (window.SPR) {SPR.initDomEls();SPR.loadBadges()}

    // Re-hook up collapsible box triggers
    theme.collapsibles.init();
  };

  theme.priceEstimate = (function() {
    var tapSinkPrice = 0;    
  /* buttons */
  document.getElementById("upload_btn1").onclick = function (){
    btn_upload();
  }
  document.getElementById("upload_btn2").onclick = function (){
    btn_upload();
  }
  document.getElementById("remove_file").onclick = function (){
    remove_file();
  }
  document.getElementById("btn1").onclick = function (){
    btn_click('next');
  }
  document.getElementById("btn1_next").onclick = function (){
    btn_click('next');
  }
  document.getElementById("btn1_back").onclick = function (){
    btn_click('back');
  }
  document.getElementById("btn2_back").onclick = function (){
    btn_click('back');
  }
  document.getElementById("des_choice_model").onchange = function (){
    design_select();
  }
  document.getElementById("des_choice_color").onchange = function (){
    design_select();
  }
  document.getElementById("des_choice_tap").onchange = function (){
    design_select();
    calculateTapSinkPrice();
  }
  document.getElementById("des_choice_sink").onchange = function (){
    design_select();
    calculateTapSinkPrice();
  }
  document.getElementById("Yes").onchange = function (){
    validate_account_form('yes');
  }
  document.getElementById("No").onchange = function (){
    validate_account_form('no');
  }
  document.getElementById("FirstName").onkeyup = function (){
    validate_account_form()
  }
  document.getElementById("LastName").onkeyup = function (){
    validate_account_form()
  }
  document.getElementById("Email").onkeyup = function (){
    validate_account_form()
  }
  document.getElementById("Phone").onchange = function (){
    validate_account_form()
  }
  document.getElementById("country_choise").onchange = function (){
    validate_account_form()
  }

  document.getElementById("hidden_file_upload").addEventListener("change", handleFiles, false);

  function handleFiles() {
    uploadfile(this.files[0])
  }

  function uploadfile(file){
      document.getElementById("lay_over_for_preloader").style.display = "flex";
      document.getElementById('preloader_uploading').style.display = 'block';
      let uploadFilename = "";
      let url = theme.settings.sasoCustomAppEnpoint + 'plan/upload'
      fetch(url, {
        method: 'GET'
      })
      .then(response => response.json())
      .then(function(response) {
        console.log('Response: ', response)
            uploadFilename = response.file;
            
            return fetch(response.signedUrl, {
              method: 'PUT',
              body: file
            })
      })
      .then(function(response) {
        document.getElementById('hidden_file_upload_drop').value = file.name;
        document.getElementById('hidden_file_upload_path').value = uploadFilename;
        document.getElementById("lay_over_for_preloader").style.display = "none";
        document.getElementById('preloader_uploading').style.display = 'none';
        capture_file(file);
      })
      .catch((error) => { 
        console.log(error);
        document.getElementById("lay_over_for_preloader").style.display = "none";
        document.getElementById('preloader_uploading').style.display = 'none';
       })
  }


function check_progress() {
  var v3 = document.getElementById("view3");
  v3.style.display = "none";
  //save_to_local_storage("1")
  document.getElementById("view1").style.display = "flex";
  document.getElementsByClassName('slideshow-wrapper')[0].style.display = "block";

  /* add scroll link to button */
  var hero_links = document.getElementsByClassName("hero__link");
  var i;
  for (i = 0; i < hero_links.length; i++) {
      var link_btns = hero_links[i].getElementsByTagName("a");
    var x;
    for (x = 0; x < link_btns.length; x++) {
      link_btns[x].onclick = function(event){
        event.preventDefault();
        var scroll = get_slideshow_wrapper_height();
        window.scrollTo(0,scroll);
      };
    }
  }

  /* get saved options from local storage */
  get_saved_options()
  /* init file drop */
  filedrop();
}
window.onload = check_progress;

/* capture dropped file */
function filedrop(){
  var dropArea = document.getElementById('upload_plan_box')
  ;['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
    dropArea.addEventListener(eventName, preventDefaults, false)
  })
  function preventDefaults (e) {
    e.preventDefault()
    e.stopPropagation()
  }
  ;['dragenter', 'dragover'].forEach(eventName => {
    dropArea.addEventListener(eventName, highlight, false)
  })
  ;['dragleave', 'drop'].forEach(eventName => {
    dropArea.addEventListener(eventName, unhighlight, false)
  })
  function highlight(e) {
    dropArea.classList.add('highlight')
  }
  function unhighlight(e) {
    dropArea.classList.remove('highlight')
  }	
  dropArea.addEventListener('drop', handleDrop, false);
  function handleDrop(e) {
    uploadfile(e.dataTransfer.files[0]);
  }
}


/* height used with scroll/anchor link */
function get_slideshow_wrapper_height(){
  var wrapper_elems = document.getElementsByClassName("slideshow-wrapper");
  var elem;
  for (elem = 0; elem < wrapper_elems.length; elem++) {
    var slideshow_wrapper_height = wrapper_elems[elem].clientHeight;
    return slideshow_wrapper_height;
  }
  return 0;
}

/* get saved options from local storage on page load*/
function get_saved_options(){

  if (JSON.parse(window.localStorage.getItem('savedObj'))){
    window.scrollBehviour = 1;
  } else {
    window.scrollBehviour = 0;
    return;
  }

  var saved_in = set_saved_in();//PAOS or Price_Estimate
  var timestamp = set_timestamp();
  if (timestamp) {// latest save in 24 hours
    if (saved_in == "Price_Estimate") {
      var category = "Kitchen";
      var model = set_option("model");
      // re-filter colours for the restored model before restoring the colour
      if (typeof updateColorOptions === 'function') updateColorOptions();
      var color = set_option("color");
      var handle = false;
      var tap = set_option("tap");
      var sink = set_option("sink");
      var stonetop = false;
      var comments = false;
      var height = false;
      var width = false;
      var depth = false;
      var wardrobeType = false;
      if (JSON.parse(window.localStorage.getItem('savedObj')).phase == "2") {
        var return_estimate = set_estimate();
        document.getElementById("lay_over_for_preloader").style.display = "none";
      } else {
        var return_estimate = false;
        document.getElementById("lay_over_for_preloader").style.display = "none";
      }
    } else {
      var category = "Kitchen";
      var model = "";
      var color = "";
      var handle = "";
      var tap = "";
      var sink = "";
      var stonetop = "";
      var comments = "";
      var height = "";
      var width = "";
      var depth = "";
      var wardrobeType = "";
      var return_estimate = false;
    }
  } else {// latest save older than 24 hours
      var category = "Kitchen";
      var model = "";
      var color = "";
      var handle = "";
      var tap = "";
      var sink = "";
      var stonetop = "";
      var comments = "";
      var height = "";
      var width = "";
      var depth = "";
      var wardrobeType = "";
      var return_estimate = false;
  }
}

function set_saved_in(){
  var saved_in_data = JSON.parse(window.localStorage.getItem('savedObj'));
  var saved_in_data_var = saved_in_data["saved_in"];
  return saved_in_data_var;
}

function set_timestamp(){
  var saved_in_data = JSON.parse(window.localStorage.getItem('savedObj'));
  var saved_time = saved_in_data["timestamp"];
  const day= 1000 * 60 * 60 * 24;
  const dayago = Date.now() - day;
  return saved_time > dayago;
}

function set_option(data_var){
  var option_val = JSON.parse(window.localStorage.getItem('savedObj'));
  if (option_val[data_var] != false){
    var elem_id = "des_choice_"+data_var;
    var elem_to_modify = document.getElementById(elem_id);
    if (elem_to_modify){
      elem_to_modify.value = option_val[data_var];
    }
  }
  return false;
}

function set_estimate(){
  var estimate = JSON.parse(window.localStorage.getItem('savedObj')).return_estimate;		
  if (estimate){
    render_estimate(estimate);
    return true;
  } else{
    return false;
  }
}

/* save options to local storage */
function save_to_local_storage(phase) {
  var timestamp = Date.now();
  var saved_in = "Price_Estimate";
  var category = "Kitchen";
  var model = document.getElementById("des_choice_model").value;
  var color = document.getElementById("des_choice_color").value;
  var handle = false;
  var tap = document.getElementById("des_choice_tap").value;
  var sink = document.getElementById("des_choice_sink").value;
  var stonetop = false;
  var plan_file = fetch_fileapath();
  var comments = "";
  var height = "";
  var width = "";
  var depth = "";
  var wardrobeType = "";
  var firstname = document.getElementById("FirstName").value;
  var lastname = document.getElementById("LastName").value;
  var email = document.getElementById("Email").value;
  var phone = document.getElementById("Phone").value;
  var filename = document.getElementById("hidden_file_upload_drop").value;
  var filepath = document.getElementById("hidden_file_upload_path").value;
  var allowMarketing = document.getElementById("Yes").checked;
  if (phase=="2"){
    var return_estimate = calculate_estimate();
  } else {
    var return_estimate = false;
  }

  /* check if disabled button is needed */
  if (plan_file){
    document.getElementById("view_1_stage_2").style.display = "block";
    document.getElementById("view_1_stage_btn_2").style.display = "block";
    if (
        document.getElementById("des_choice_model").value != "0" &&
        document.getElementById("des_choice_color").value != "0" &&
        document.getElementById("des_choice_tap").value != "0" &&
        document.getElementById("des_choice_sink").value != "0"
    ){
      document.getElementById("view_1_stage_3").style.display = "block";
      document.getElementById("view_1_stage_btn_3").style.display = "block";
      // scroll only if no data is detected in local storage on page load
      if (window.scrollBehviour == 0){
        var scroll_3 = window.scrollY + document.querySelector('#view_1_stage_btn_3').getBoundingClientRect().top;
        window.scrollTo({top:scroll_3-50});
      } else {
        var scroll_2 = window.scrollY + document.querySelector('#view_1_stage_btn_2').getBoundingClientRect().top;
        window.scrollTo({top:scroll_2-50});
        window.scrollBehviour = 1;
      }
    } else {
      var scroll_2 = window.scrollY + document.querySelector('#view_1_stage_btn_2').getBoundingClientRect().top;
      window.scrollTo({top:scroll_2-50});
    }
  } else {
    document.getElementById("view_1_stage_2").style.display = "none";
    document.getElementById("view_1_stage_btn_2").style.display = "none";
    document.getElementById("view_1_stage_3").style.display = "none";
    document.getElementById("view_1_stage_btn_3").style.display = "none";
  }

  var savedObj = {
    "timestamp":timestamp,
    "saved_in":saved_in,
    "phase":phase,
    "category": category,
    "model": model,
    "color": color,
    "handle": handle,
    "tap": tap,
    "sink": sink,
    "stonetop": stonetop,
    "plan_file": plan_file,
    "comments": comments,
    "height": height,
    "width": width,
    "depth": depth,
    "wardrobeType": wardrobeType,
    "return_estimate": return_estimate,
    "firstname" : firstname,
    "lastname" : lastname,
    "email" : email,
    "phone": phone,
    "filename": filename,
    "filepath": filepath,
    "tapsinkprice": tapSinkPrice,
    "allowMarketing": allowMarketing
   }
  localStorage.setItem("savedObj", JSON.stringify(savedObj));
}

function calculateTapSinkPrice(){
  const sinkSelect = document.getElementById("des_choice_sink");
  const tapSelect = document.getElementById("des_choice_tap");
  var sinkPrice = Number(sinkSelect[sinkSelect.selectedIndex].getAttribute("data-price"));
  var tapPrice = Number(tapSelect[tapSelect.selectedIndex].getAttribute("data-price"));
  tapSinkPrice = (sinkPrice + tapPrice) / 100;
}

async function calculate_estimate(){
  calculateTapSinkPrice();
  const countrySelect = document.getElementById("country_choise");
  const formBody = {
    "email": document.getElementById("Email").value,
    "phone": document.getElementById("Phone").value,
    "color": document.getElementById("des_choice_color").value,
    "doormodel": document.getElementById("des_choice_model").value,
    "tap": document.getElementById("des_choice_tap").value,
    "sink": document.getElementById("des_choice_sink").value,
    "firstname": document.getElementById("FirstName").value,
    "lastname": document.getElementById("LastName").value,
    "country": countrySelect.options[countrySelect.selectedIndex].value,
    "store": theme.settings.zapierStoreId,
    "tapSinkAmount": tapSinkPrice,
    "filepath": document.getElementById("hidden_file_upload_path").value
  }


  var requestOptions = {
  method: 'POST',
  body: JSON.stringify(formBody),
  redirect: 'follow'
  };

  fetch(theme.settings.sasoCustomAppEnpoint + 'initpriceestimate', requestOptions)
  .then(response => response.json())
  .then(data => {
    const eventId = data.response
    const statusRequestPromise = function(eventId){
        const requestOptions = {
          method: 'POST',
          body: JSON.stringify({ "eventId":eventId})
          };
          
        return fetch(theme.settings.sasoCustomAppEnpoint + 'priceestimatestatus', requestOptions)
        .then(data => data.json())
        .catch(error => console.log('error', error));
      } 
  
      const validateStatus = (statusResponse) => {
        return statusResponse.response.queryStatus > 1;
      }

    pollStatus({
      fn: statusRequestPromise,
      eventId: eventId,
      validate: validateStatus,
      interval: 3000,
      maxAttempts: 70
    })
    .then(data => {
      document.getElementById("lay_over_for_preloader").style.display = "none";
      window.scrollTo(0, 0);
      if (data.response.queryStatus == 3){
        document.getElementById("view2").style.display = "flex";
        var object_for_calculation = {
          title_1: document.getElementById("view2").getAttribute("data-doors-title"),
          value_1: data.response.resultPrice,
          title_2: document.getElementById("view2").getAttribute("data-taps-title"),
          value_2: tapSinkPrice
        };
        render_estimate(object_for_calculation);
        return object_for_calculation;
      } else if (data.response.queryStatus = 2){
        render_error(data.response.errorCode);
        return false;
      } else {
        render_error(0);
      }
    })
    .catch(err => {
      document.getElementById("lay_over_for_preloader").style.display = "none";
      window.scrollTo(0, 0);
      render_error(0);
      console.error(err)
    });
  })
  .catch(error => console.log('error', error));
}

const pollStatus = ({ fn, eventId, validate, interval, maxAttempts }) => {
  //console.log('Start poll...');
  let attempts = 0;

  const executePoll = async (resolve, reject) => {
    //console.log('- poll');
    const result = await fn(eventId);
    attempts++;

    if (validate(result)) {
      return resolve(result);
    } else if (maxAttempts && attempts === maxAttempts) {
      return reject(new Error('Exceeded max attempts'));
    } else {
      setTimeout(executePoll, interval, resolve, reject);
    }
  };

  return new Promise(executePoll);
};


function render_estimate(object_for_calculation){
  document.getElementById("est_title_1").innerHTML = object_for_calculation.title_1;
  document.getElementById("est_val_1").innerHTML =  theme.Currency.formatMoney((object_for_calculation.value_1 * 100), theme.settings.moneyFormat);
  document.getElementById("est_title_2").innerHTML = object_for_calculation.title_2;
  document.getElementById("est_val_2").innerHTML =  theme.Currency.formatMoney((object_for_calculation.value_2 * 100), theme.settings.moneyFormat);
  var total = (Number(object_for_calculation.value_1) + Number(object_for_calculation.value_2)) * 100;
  console.log(total);
  document.getElementById("est_val_total").innerHTML = theme.Currency.formatMoney(total, theme.settings.moneyFormat);
  
}

function render_error(errorcode){
  document.getElementById("view3").style.display = "flex";
  document.getElementById("pe_error_" + errorcode).style.display = "block";
}


function fetch_fileapath(){
  var file_p = document.getElementById("hidden_file_upload").value;
  if (file_p == "" || !file_p){
    var file_p = document.getElementById("hidden_file_upload_drop").value;
  }
  file_p = file_p.split('\\').pop().split('/').pop();
  var file_p_text = document.getElementById("filepath").innerHTML;
  if (file_p){
      if ( (file_p.includes(".pdf")) == false ){
            document.getElementById("filepath").style.display = "none";
            document.getElementById("filepath_error").style.display = "block";
            document.getElementById("upload_plan_box_success").classList.add("no_border");
            document.getElementById("remove_file").style.display = "none";
        return false;
          }
    	  document.getElementById("filepath").innerHTML = file_p;
    	  document.getElementById("upload_btn1").style.display = "none";
          document.getElementById("upload_btn2").style.display = "none";
          document.getElementById("filepath").style.display = "block";
          document.getElementById("filepath_error").style.display = "none";
          document.getElementById("remove_file").style.display = "block";
          document.getElementById("upload_plan_box_success").classList.remove("no_border");
    return file_p;
  }else if (file_p_text != ""){
          document.getElementById("upload_btn1").style.display = "none";
          document.getElementById("upload_btn2").style.display = "none";
    return file_p_text;
  } else {
    return "";
  }
}

function btn_click(direction) {
  var v1 = document.getElementById("view1");
  var v2 = document.getElementById("view2");
  var v3 = document.getElementById("view3");
  var preloader = document.getElementById("lay_over_for_preloader");

  if (direction == "next"){
    if (window.getComputedStyle(v1).display === "flex") {
    var slideshow_wrapper_arr = document.getElementsByClassName("slideshow-wrapper");
    var slideshow_wrapper = slideshow_wrapper_arr[0];
    slideshow_wrapper.style.display = "none";
    v1.style.display = "none";
    preloader.style.display = "flex";
    document.getElementById('preloader_processing').style.display = 'block';
    save_to_local_storage(2);
    } else if (window.getComputedStyle(v2).display === "flex") {
      //alert("Proceed to Payment will be activated later. Currently button resets the application for development purposes.    "+JSON.stringify(window.localStorage.getItem('savedObj')));
      localStorage.removeItem("savedObj");
      var linkTo = document.getElementById('btn1_next').getAttribute('data-link');
      window.location.href = linkTo;
      return
    }
  }
  if (direction == "back"){
    if (window.getComputedStyle(v2).display === "flex" || window.getComputedStyle(v3).display === "flex" ) {
    v1.style.display = "flex";
    v2.style.display = "none";
    v3.style.display = "none";
    save_to_local_storage(1);
    }
  }
  window.scrollTo(0, 0);
}

function btn_upload(){
  document.getElementById('hidden_file_upload').click();
}

function capture_file(file){
  var filename = file.name;
  document.getElementById('hidden_file_upload_drop').value = filename;
  document.getElementById("upload_plan_box").classList.add("file_selected");
  document.getElementById("upload_plan_i_2").classList.add("file_selected2");
  document.getElementById("upload_plan_box_success").style.display = "block";
  save_to_local_storage(1);
}

function remove_file(){
  document.getElementById('hidden_file_upload').value = "";
  document.getElementById('hidden_file_upload_path').value = "";
  document.getElementById('hidden_file_upload_drop').value = "";
  document.getElementById("filepath").innerHTML = "";
  document.getElementById("upload_plan_box_success").style.display = "none";
  document.getElementById("upload_plan_box").classList.remove("file_selected");
  document.getElementById("upload_plan_i_2").classList.remove("file_selected2") ;
  document.getElementById("upload_btn1").style.display = "block";
  document.getElementById("upload_btn2").style.display = "inline";
  save_to_local_storage(1);
}

/* check changes in the design selection */
function design_select(skip_or_not){
  save_to_local_storage(1);
}

/* Validate account form */
function validate_account_form(variable){
  var validations = 0;
  /* FirstName */
  if( document.getElementById("FirstName").value.length <= 2 && document.getElementById("FirstName").value.length != 0  ){
    document.getElementById("FirstName_error").style.display = "inline";
  } else if ( document.getElementById("FirstName").value.length > 2 ){
    document.getElementById("FirstName_error").style.display = "none";
    validations++;
  }
  else {
    document.getElementById("FirstName_error").style.display = "none";
  }
  /* LastName */
  if( document.getElementById("LastName").value.length <= 2 && document.getElementById("LastName").value.length != 0 ){
    document.getElementById("LastName_error").style.display = "inline";
  } else if ( document.getElementById("LastName").value.length > 2 ){
    document.getElementById("LastName_error").style.display = "none";
    validations++;
  } else {
    document.getElementById("LastName_error").style.display = "none";
  }
  /* Email */
  var email = document.getElementById("Email").value;
  if( validateEmail(email) == false && document.getElementById("Email").value.length != 0 ){
    document.getElementById("Email_error").style.display = "inline";
  } else if ( validateEmail(email)){
    document.getElementById("Email_error").style.display = "none";
    validations++;
  } else {
    document.getElementById("Email_error").style.display = "none";
  }
  /* Phone */
  var phone = document.getElementById("Phone").value;
  if( validatePhone(phone) == false && document.getElementById("Phone").value.length != 0 ){
    document.getElementById("Phone_error").style.display = "inline";
  } else if (validatePhone(phone)) {
    document.getElementById("Phone_error").style.display = "none";
    validations++;
  }{
    document.getElementById("Phone_error").style.display = "none";
  }
  /* Consent */
  if (variable == "yes"){document.getElementById("No").checked = 0;}
  else if (variable == "no"){document.getElementById("Yes").checked = 0;}
  var yes = document.getElementById("Yes").checked;
  var No = document.getElementById("No").checked;
  if (yes+No ==1 ){
    validations++;
  }
  /* Country */
  var country_choise = document.getElementById("country_choise").value;
  if (country_choise != 0){
    validations++;
  }
  /* count validated fields */
  if(validations==6){
    document.getElementById("view2_disabled_btn").classList.remove("disabled_btn");
  } else {
    document.getElementById("view2_disabled_btn").classList.add("disabled_btn");
  }
}

function validateEmail(email){
      var re = /\S+@\S+\.\S+/;
      return re.test(email);
  }
function validatePhone(phone) {
  var phoneRe = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
  return phoneRe.test(phone);
}

});

/* Filter colors on model select */
// Object mapping models to their allowed colors
const modelColors = {
  "Ingarö": ["Natural White", "Afternoon White", "Ivory Beige", "Amager Grey", "Feather Grey", "Thermal Grey", "Linen Brown", "Sunday Greige", "Dusty Rose", "Ash Green", "Granite Green", "White Oak", "Natural Oak", "Smoke Oak", "Umber Oak", "Natural Walnut"],
  "Ensiö": ["Natural White", "Afternoon White", "Ivory Beige", "Amager Grey", "Feather Grey", "Thermal Grey", "Linen Brown", "Sunday Greige", "Dusty Rose", "Ash Green", "Granite Green"],
  "Samsö": ["Natural White", "Afternoon White", "Ivory Beige", "Amager Grey", "Feather Grey", "Thermal Grey", "Linen Brown", "Sunday Greige", "Dusty Rose", "Ash Green", "Granite Green", "White Oak", "Natural Oak", "Smoke Oak", "Umber Oak", "Natural Walnut"],
  "Ark": ["Misty Ash", "Clay Ash", "Polar Ash"],
  "Haga": ["Natural White", "Afternoon White", "Ivory Beige", "Amager Grey", "Feather Grey", "Thermal Grey", "Linen Brown", "Sunday Greige", "Dusty Rose", "Ash Green", "Granite Green"],
  "Vass": ["Afternoon White", "Ivory Beige", "Amager Grey", "Sunday Greige", "Dusty Rose", "Ash Green"],
  "Lonna": ["Natural White Oak", "Afternoon White Oak", "Ivory Beige Oak", "Cumulus Grey Oak", "Ash Green Oak", "Gustav Blue Oak", "Chalet Oak", "Pure Oak", "Tobacco Oak"],
  "Brahe": ["Natural White Oak", "Afternoon White Oak", "Ivory Beige Oak", "Cumulus Grey Oak", "Ash Green Oak", "Gustav Blue Oak", "Chalet Oak", "Pure Oak", "Tobacco Oak"]
};

// Function to update the color options based on the selected model
function updateColorOptions() {
  const modelSelect = document.getElementById('des_choice_model');
  const colorSelect = document.getElementById('des_choice_color');
  
  // Get the selected model
  const selectedModel = modelSelect.value;

  // Remember the full option list once, before any option is removed
  // (iOS Safari ignores display:none on <option>, so options are removed and re-added instead of hidden)
  if (!colorSelect._allColorOptions) {
      colorSelect._allColorOptions = Array.from(colorSelect.options);
  }

  // Rebuild the dropdown: "Select" first, then only the selected model's colours
  const allowedColors = modelColors[selectedModel] || [];
  colorSelect.innerHTML = '';
  colorSelect._allColorOptions.forEach(option => {
      if (option.value === "0" || allowedColors.includes(option.value)) {
          colorSelect.appendChild(option);
      }
  });

  // Disable the color dropdown until a model is selected, and reset the selection
  colorSelect.disabled = (selectedModel === "0");
  colorSelect.value = "0";
}

const modelSelector = document.getElementById('des_choice_model');

if (modelSelector) {
  // Attach the updateColorOptions function to the model selector's change event
  modelSelector.addEventListener('change', updateColorOptions);

  // Optionally call the function initially to set up the correct colors if a model is pre-selected
  updateColorOptions();
}



/* ================================================== */
/* ====================== PAOS ====================== */
/* ================================================== */
theme.paos = function () {
  /* button */
  var next_btns = document.getElementsByClassName('next_btn');
  for (var i = 0; next_btns.length > i; i++) {
    next_btns[i].onclick = function () {
      btn_click('next');
    };
  }
  var back_btns = document.getElementsByClassName('go_back');
  for (var i = 0; back_btns.length > i; i++) {
    back_btns[i].onclick = function () {
      btn_click('back');
    };
  }
  var opt_btns = document.getElementsByClassName('opt');
  for (var i = 0; opt_btns.length > i; i++) {
    opt_btns[i].onclick = function () {
      select_opt(this);
    };
  }
  document.getElementById('upload_btn1').onclick = function () {
    btn_upload();
  };
  /* ========= */
  /*
  document.getElementById('hidden_file_upload').onchange = function () {
    uploadFiles(Array.from(this.files));
  };
  */
  /* Uncomment for multiple files */
  /* ========= */

  /* ========= */
  document.getElementById('hidden_file_upload').onchange = function () {
    uploadfile(this.files[0]);
  };
  /* Comment out for multiple files */
  /* ========= */
  
  document.getElementById('remove_file').onclick = function () {
    remove_file();
  };
  document.getElementById('upload_btn2').onclick = function () {
    btn_upload();
  };
  /* wardrobe measurements: re-check the Next button while typing, because the upload no longer forces a save */
  var measurement_inputs = document.getElementsByClassName('wardrobe_measurement');
  for (var i = 0; measurement_inputs.length > i; i++) {
    measurement_inputs[i].oninput = function () {
      save_to_local_storage(4);
    };
  }
  /* wardrobe extras: the box reveals the optional cards; unticking clears any chosen card */
  var extras_toggle = document.getElementById('wardrobe_extras_toggle');
  if (extras_toggle) {
    extras_toggle.onchange = function () {
      var wrapper = document.getElementById('wardrobe_type_wrapper');
      wrapper.style.display = this.checked ? 'flex' : 'none';
      if (!this.checked) {
        var cards = wrapper.getElementsByClassName('data-opt-type');
        for (var i = 0; i < cards.length; i++) {
          cards[i].classList.remove('opt_selected');
        }
      }
      save_to_local_storage(4);
    };
  }

  function check_progress() {
    /* Get saved option from local storage on page load */
    var local_set = JSON.parse(window.localStorage.getItem('savedObj'));

    if (local_set != null) {
      // show previous selection
      var saved_in_var = local_set.saved_in;
      if (saved_in_var == 'PAOS') {
        // data saved previously in POAS
        var current_phase = local_set.phase;
        var phase_var = 'view1';
        // only for dev purposes
        //var phase_var = view"+current_phase;
      } else if (saved_in_var == 'Price_Estimate') {
        // data saved previously in Price Estimate
        var current_phase = local_set.phase;
        if (current_phase == '2' || local_set.plan_file) {
          var phase_var = 'view1'; // changed from view5
        } else {
          var phase_var = 'view1';
        }
        title_model;
      }

      get_saved_options(local_set);
      document.getElementById(phase_var).style.display = 'flex';

      document.getElementById('navigation').style.display = 'flex';
      document.getElementById('stage0').classList.add('active');

      /* add go back links to bullets */
      document.getElementById('stage0').onclick = function () {
        btn_click(1);
      };
      document.getElementById('stage1').onclick = function () {
        btn_click(2);
      };
      document.getElementById('stage2').onclick = function () {
        btn_click(3);
      };
      document.getElementById('stage3').onclick = function () {
        btn_click(4);
      };
      /* class for mobile */
      document.getElementById('navi_inner').classList.add('navi_inner_0');
      //}
    } else {
      // go to view 1
      save_to_local_storage('1');
      //document.getElementById("navigation").style.display = "none";
      document.getElementById('view1').style.display = 'flex';
    }
    /* init file drop */
    filedrop();
  }
  window.onload = check_progress;

  /* ========= */
  /* capture dropped file */
  /*
  function filedrop() {
    var dropArea = document.getElementById('upload_plan_box');

    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach((eventName) => {
      dropArea.addEventListener(eventName, preventDefaults, false);
    });

    function preventDefaults(e) {
      e.preventDefault();
      e.stopPropagation();
    }

    ['dragenter', 'dragover'].forEach((eventName) => {
      dropArea.addEventListener(eventName, highlight, false);
    });

    ['dragleave', 'drop'].forEach((eventName) => {
      dropArea.addEventListener(eventName, unhighlight, false);
    });

    function highlight(e) {
      dropArea.classList.add('highlight');
    }

    function unhighlight(e) {
      dropArea.classList.remove('highlight');
    }

    dropArea.addEventListener('drop', handleDrop, false);

    function handleDrop(e) {
        e.preventDefault();
        e.stopPropagation();
      
        var files = Array.from(e.dataTransfer.files);
        console.log(files.length + ' file(s) dropped');
        uploadFiles(files);
      }
  }

 function uploadFiles(files) {
    document.getElementById('lay_over_for_preloader').style.display = 'flex';
    let uploadPromises = [];
    let uploadedFilesContainer = document.getElementById('filepath-container');
  
    files.forEach((file) => {
      let url = theme.settings.sasoCustomAppEnpoint + 'plan/upload';
      let uploadFilename = '';
  
      uploadPromises.push(
        (function (fileName) {
          return fetch(url, {
            method: 'GET',
          })
            .then((response) => response.json())
            .then(function (response) {
              console.log('Response: ', response);
              uploadFilename = response.file;
              return fetch(response.signedUrl, {
                method: 'PUT',
                body: file,
              });
            })
            .then(function (response) {
              document.getElementById('hidden_file_upload_drop').value = fileName;
              document.getElementById('hidden_file_upload_path').value = uploadFilename;
  
              // Check if a container for the current file already exists
              var existingContainer = uploadedFilesContainer.querySelector('.filename[data-file="' + fileName + '"]');
              
              // If the container doesn't exist, create a new one
              if (!existingContainer) {
                var fileContainer = document.createElement('div');
                fileContainer.classList.add('uploaded-file');
  
                // Create a new element with class "filename"
                var uploadedFileElement = document.createElement('div');
                uploadedFileElement.classList.add('filename');
                uploadedFileElement.setAttribute('data-file', fileName);
                uploadedFileElement.innerHTML = fileName;
  
                // Append the new element within the container
                fileContainer.appendChild(uploadedFileElement);
  
                // Append the new container within the "filepath-container"
                uploadedFilesContainer.appendChild(fileContainer);
              }
            });
        })(file.name)
      );
    });
  
    Promise.all(uploadPromises)
      .then(() => {
        document.getElementById('lay_over_for_preloader').style.display = 'none';
        capture_link();
      })
      .catch((error) => {
        console.log(error);
      });
  }
  */ 
  /* Uncomment for multiple files */
  /* ========= */

  /* ========= */
  /* capture dropped file */
function filedrop(){
    var dropArea = document.getElementById('upload_plan_box')
    ;['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
      dropArea.addEventListener(eventName, preventDefaults, false)
    })
    function preventDefaults (e) {
      e.preventDefault()
      e.stopPropagation()
    }
    ;['dragenter', 'dragover'].forEach(eventName => {
      dropArea.addEventListener(eventName, highlight, false)
    })
    ;['dragleave', 'drop'].forEach(eventName => {
      dropArea.addEventListener(eventName, unhighlight, false)
    })
    function highlight(e) {
      dropArea.classList.add('highlight')
    }
    function unhighlight(e) {
      dropArea.classList.remove('highlight')
    }
    dropArea.addEventListener('drop', handleDrop, false);
    function handleDrop(e) {
      var file = e.dataTransfer.files[0];
      console.log('File dropped');
      uploadfile(file);
    }
}

function uploadfile(file){
    document.getElementById("lay_over_for_preloader").style.display = "flex";
      let url = theme.settings.sasoCustomAppEnpoint + 'plan/upload'
      let uploadFilename = "";
      fetch(url, {
        method: 'GET'
      })
      .then(response => response.json())
      .then(function(response) {
        console.log('Response: ', response)
            uploadFilename = response.file;
            return fetch(response.signedUrl, {
              method: 'PUT',
              body: file
            })
      })
      .then(function(response) {
        document.getElementById('hidden_file_upload_drop').value = file.name;
        document.getElementById('hidden_file_upload_path').value = uploadFilename;
        document.getElementById("lay_over_for_preloader").style.display = "none";
        capture_link();
      })
      .catch((error) => { 
        console.log(error)
       })
} 
  /* Comment out for multiple files */
  /* ========= */

  function get_saved_options(local_set) {
    var saved_in = set_saved_in(); //PAOS or Price_Estimate
    var timestamp = set_timestamp();
    if (!timestamp) {
      // latest save in 24 hours
      return;
    }
    var category = set_option('category');
    var model = set_option('model');
    var color = set_option('color');
    var handle = set_option('handle');
    var tap = set_option('tap');
    var sink = set_option('sink');
    var stonetop = set_option('stonetop');
    //var plan_files = set_filepath() || [];
    // forget plan file on pageload
    //var plan_files = false; /* Uncomment for multiple files */
    var plan_file; /* Comment out for multiple files */
    var comments = set_comments();
    var height = set_height();
    var width = set_width();
    var depth = set_depth();
    set_wardrobe_type();

    /* check if disabled button is needed */
    if (category && model) {
      document.getElementById('view2_disabled_btn').classList.remove('disabled_btn');
    } else {
      document.getElementById('view2_disabled_btn').classList.add('disabled_btn');
    }
    
    /* ========= */
    /* 
    if (plan_files.length > 0) {
      document.getElementById('view4_disabled_btn').classList.remove('disabled_btn');
    }
    */ 
    /* Uncomment for multiple files */
    /* ========= */
    
    /* ========= */
    if (plan_file){
        document.getElementById("view4_disabled_btn").classList.remove("disabled_btn");
    }
    /* Comment out for multiple files */
    /* ========= */

    /* wardrobe: the upload is optional, so restored measurements and type re-enable Next after a reload */
    if (typeof category === 'string' && category.toLocaleLowerCase().includes('wardrobe') && wardrobe_type_complete() &&
        document.getElementById('measurement_height').value && document.getElementById('measurement_width').value && document.getElementById('measurement_depth').value) {
      document.getElementById('view4_disabled_btn').classList.remove('disabled_btn');
    }
    
  }

  function set_timestamp() {
    var saved_in_data = JSON.parse(window.localStorage.getItem('savedObj'));
    var saved_time = saved_in_data['timestamp'];
    const day = 1000 * 60 * 60 * 24;
    const dayago = Date.now() - day;
    return saved_time > dayago;
  }

  function set_saved_in() {
    var saved_in_data = JSON.parse(window.localStorage.getItem('savedObj'));
    var saved_in_data_var = saved_in_data['saved_in'];
    return saved_in_data_var;
  }

  /* ========= */
  /*
  function set_filepath() {
    var file_p = JSON.parse(window.localStorage.getItem('savedObj'));
    var send_paths_to_elem = file_p['plan_files'] || [];

    if (send_paths_to_elem.length > 0) {
      // Assuming you want to display information about the first file in the array
      var firstFilePath = send_paths_to_elem[0];

      document.getElementById('upload_plan_box').classList.add('file_selected');
      document.getElementById('upload_plan_i_2').classList.add('file_selected2');
      document.getElementById('upload_plan_box_success').style.display = 'block';
      document.getElementById('filepath-container').innerHTML = firstFilePath;
      document.getElementById('summary_filepath').innerHTML = firstFilePath;
      document.getElementById('upload_btn1').style.display = 'block';
      document.getElementById('upload_btn2').style.display = 'none';

      return send_paths_to_elem;
    } else {
      return [];
    }
  }
  */ 
  /* Uncomment for multiple files */
  /* ========= */

  /* ========= */
  function set_filepath(){
    var file_p = JSON.parse(window.localStorage.getItem('savedObj'));
    var send_path_to_elem = file_p["plan_file"];
    if (send_path_to_elem != ""){
        document.getElementById("upload_plan_box").classList.add("file_selected");
        document.getElementById("upload_plan_i_2").classList.add("file_selected2");
        document.getElementById("upload_plan_box_success").style.display = "block";
        document.getElementById("filepath").innerHTML = send_path_to_elem;
        document.getElementById("summary_filepath").innerHTML = send_path_to_elem;
        document.getElementById("upload_btn1").style.display = "none";
        document.getElementById("upload_btn2").style.display = "none";
        return true;
    } else{
        return false;
    }
  }
  /* Comment out for multiple files */
  /* ========= */

  function set_comments() {
    var comment_val = JSON.parse(window.localStorage.getItem('savedObj'));
    document.getElementById('comments').value = comment_val['comments'];
    document.getElementById('summary_comments').innerHTML = comment_val['comments'];
  }

  function set_height() {
    var height_val = JSON.parse(window.localStorage.getItem('savedObj'));
    document.getElementById('measurement_height').value = height_val['height'];
    //document.getElementById("summary_comments").innerHTML = comment_val["comments"];
  }

  function set_width() {
    var width_val = JSON.parse(window.localStorage.getItem('savedObj'));
    document.getElementById('measurement_width').value = width_val['width'];
    //document.getElementById("summary_comments").innerHTML = comment_val["comments"];
  }

  function set_depth() {
    var depth_val = JSON.parse(window.localStorage.getItem('savedObj'));
    document.getElementById('measurement_depth').value = depth_val['depth'];
    //document.getElementById("summary_comments").innerHTML = comment_val["comments"];
  }

  function set_option(data_var) {
    var option_val = JSON.parse(window.localStorage.getItem('savedObj'));
    if (option_val[data_var] != false) {
      var elem_id = option_val[data_var];
      var elem_to_modify = document.getElementById(elem_id);
      if (elem_to_modify) {
        /* activate indication on selected */
        elem_to_modify.classList.add('opt_selected');
        /* generate summary view */
        var copy_elem = elem_to_modify.innerHTML;
        var existing_html = document.getElementById('summary_options').innerHTML;
        if (data_var != 'color') {
          var opt_class = ' opt-var';
        } else {
          var opt_class = '';
        }
        var wrap_div = '<div data-opt="' + data_var + '" class="data-opt-' + data_var + opt_class + ' opt">' + copy_elem + '</div>';
        document.getElementById('summary_options').innerHTML = existing_html + wrap_div;
        return true;
      }
    }
    return false;
  }

  function save_to_local_storage(phase) {
    var timestamp = Date.now();
    document.getElementById('summary_options').innerHTML = '';
    var saved_in = 'PAOS';
    var category = fetch_option('category');
    var model = category && !(category.toLocaleLowerCase().includes('other') || category.toLocaleLowerCase().includes('worktop')) ? fetch_option('model') : false;
    var color = fetch_option('color');
    var handle = fetch_option('handle');
    var tap = category && category.toLocaleLowerCase() === 'kitchen' ? fetch_option('tap') : false;
    var sink = category && category.toLocaleLowerCase() === 'kitchen' ? fetch_option('sink') : false;
    var stonetop = fetch_option('stonetop');
    //var plan_files = fetch_filepaths(); /* Uncomment for multiple files */
    var plan_file = fetch_fileapath(); /* Comment out for multiple files */
    var comments = fetch_comments();
    var height = fetch_height();
    var width = fetch_width();
    var depth = fetch_depth();
    var wardrobeType = fetch_wardrobe_type(category);

    document.getElementById('view4_disabled_btn').classList.add('disabled_btn');

    if (category && (model || category.toLocaleLowerCase().includes('other') || category.toLocaleLowerCase().includes('worktop'))) {
      document.getElementById('view2_disabled_btn').classList.remove('disabled_btn');
    } else {
      document.getElementById('view2_disabled_btn').classList.add('disabled_btn');
    }

    if (category && category.toLocaleLowerCase().includes('worktop')) {
      document.getElementById('view4_disabled_btn').classList.remove('disabled_btn');
    }

    /* ========= */
    /*
    if (plan_files.length > 0 && category && category.toLocaleLowerCase() === 'kitchen') {
      document.getElementById('view4_disabled_btn').classList.remove('disabled_btn');
    }

    if (plan_files.length > 0 && height && width && depth && wardrobeType && category && category.toLocaleLowerCase().includes('wardrobe')) {
      document.getElementById('view4_disabled_btn').classList.remove('disabled_btn');
    }
    */ /* Uncomment for multiple files */
    /* ========= */

   /* ========= */
    if (plan_file && (category && category.toLocaleLowerCase().includes("kitchen") ) ){
      document.getElementById("view4_disabled_btn").classList.remove("disabled_btn");
    }

    /* wardrobe: the plan/picture upload is optional; measurements and type are enough */
    if (height && width && depth && wardrobeType && (category && category.toLocaleLowerCase().includes("wardrobe") ) ){
        document.getElementById("view4_disabled_btn").classList.remove("disabled_btn");
    }
    /* Comment out for multiple files */
    /* ========= */

    document.getElementById('stage0').onclick = function () {
      btn_click(1);
    };
    document.getElementById('stage1').onclick = function () {
      btn_click(2);
    };
    document.getElementById('stage2').onclick = function () {
      btn_click(3);
    };
    document.getElementById('stage3').onclick = function () {
      btn_click(4);
    };

    var savedObj = {
      saved_in: saved_in,
      timestamp: timestamp,
      phase: phase,
      category: category,
      model: model,
      color: color,
      handle: handle,
      tap: tap,
      sink: sink,
      stonetop: stonetop,
      //plan_files: plan_files, // Updated property name to indicate multiple files /* Uncomment for multiple files */
      plan_file: plan_file, /* Comment out for multiple files */
      height: height,
      width: width,
      depth: depth,
      comments: comments,
      wardrobeType: wardrobeType,
      store: theme.settings.zapierStoreId,
    };

    localStorage.setItem('savedObj', JSON.stringify(savedObj));
  }

  /* ========= */
  /*
  function fetch_filepaths() {
    var file_names = document.getElementById('hidden_file_upload_drop').value.split(','); // Assuming file names are separated by commas
    var file_paths = document.getElementById('hidden_file_upload_path').value.split(',');
    var validExtensions = ['.pdf', '.png', '.jpeg', '.jpg'];
    var uploadedFilesContainer = document.getElementById('filepath-container');
  
    if (file_paths.length > 0) {
      var validFiles = file_paths.filter((path, index) => {
        var extension = path.substring(path.lastIndexOf('.')).toLowerCase();
        return validExtensions.includes(extension);
      });
  
      // Update other elements as needed
      document.getElementById('summary_filepath').innerHTML = validFiles.join(', ');
  
      if (validFiles.length > 0) {
        document.getElementById('upload_btn1').style.display = 'block';
        document.getElementById('upload_btn2').style.display = 'none';
        uploadedFilesContainer.style.display = 'block';
        document.getElementById('filepath_error').style.display = 'none';
        document.getElementById('remove_file').style.display = 'block';
        document.getElementById('upload_plan_box_success').classList.remove('no_border');
      } else {
        uploadedFilesContainer.style.display = 'none';
        document.getElementById('filepath_error').style.display = 'block';
        document.getElementById('upload_plan_box_success').classList.add('no_border');
        document.getElementById('remove_file').style.display = 'none';
        return false;
      }
  
      return validFiles;
    } else {
      return [];
    }
  }
  */  
  /* Uncomment for multiple files */
  /* ========= */


  /* ========= */
  function fetch_fileapath(){
  var file_name = document.getElementById("hidden_file_upload_drop").value;
  var file_p = document.getElementById("hidden_file_upload_path").value;
  if (file_p){
      if ( (file_p.includes(".pdf")) == false ){
        document.getElementById("filepath").style.display = "none";
        document.getElementById("filepath_error").style.display = "block";
        document.getElementById("upload_plan_box_success").classList.add("no_border");
        document.getElementById("remove_file").style.display = "none";
        return false;
      }
      document.getElementById("filepath").innerHTML = file_name;
      document.getElementById("summary_filepath").innerHTML = file_name;
      document.getElementById("upload_btn1").style.display = "none";
      document.getElementById("upload_btn2").style.display = "none";
      document.getElementById("filepath").style.display = "block";
      document.getElementById("filepath_error").style.display = "none";
      document.getElementById("remove_file").style.display = "block";
      document.getElementById("upload_plan_box_success").classList.remove("no_border");
      return file_p;
    } else {
          return "";
    }
  } 
  /* Comment out for multiple files */
  /* ========= */

  function fetch_comments() {
    var comments_val = document.getElementById('comments').value;
    document.getElementById('summary_comments').innerHTML = document.getElementById('comments').value;
    return comments_val;
  }

  function fetch_height() {
    var height_val = document.getElementById('measurement_height').value;
    document.getElementById('summary_height').innerHTML = document.getElementById('measurement_height').value;
    return height_val;
  }

  function fetch_width() {
    var width_val = document.getElementById('measurement_width').value;
    document.getElementById('summary_width').innerHTML = document.getElementById('measurement_width').value;
    return width_val;
  }

  function fetch_depth() {
    var depth_val = document.getElementById('measurement_depth').value;
    document.getElementById('summary_depth').innerHTML = document.getElementById('measurement_depth').value;
    return depth_val;
  }

  function fetch_option(data_var) {
    var x = document.getElementsByClassName('data-opt-' + data_var);
    let colorOptions = document.getElementsByClassName('data-opt-color');
    var i;
    for (i = 0; i < x.length; i++) {
      if (x[i].classList.contains('opt_selected')) {
        var id = x[i].id;
        /* generate summary view */
        var copy_elem = x[i].innerHTML;
        var existing_html = document.getElementById('summary_options').innerHTML;
        if (data_var != 'color') {
          var opt_class = ' opt-var';
        } else {
          var opt_class = '';
        }
        var wrap_div = '<div data-opt="' + data_var + '" class="data-opt-' + data_var + opt_class + ' opt">' + copy_elem + '</div>';
        document.getElementById('summary_options').innerHTML = existing_html + wrap_div;

        // Hide Tap and Sink select when kitchen is chosen category
        if (data_var == 'category' && id.toLowerCase() == 'kitchen') {
          // hide optional text in file upload
          document.getElementById('optional_sel').style.display = 'none';
          if (document.getElementById('title_sink')) {
            document.getElementById('title_sink').style.display = 'block';
            document.getElementById('options_sink').style.display = 'block';
          }
          if (document.getElementById('title_tap')) {
            document.getElementById('title_tap').style.display = 'block';
            document.getElementById('options_tap').style.display = 'block';
          }
          if (document.getElementById('title_stonetop')) {
            document.getElementById('title_stonetop').style.display = 'block';
            document.getElementById('options_stonetop').style.display = 'block';
          }
          if (document.getElementById('title_handle')) {
            document.getElementById('title_handle').style.display = 'block';
            document.getElementById('options_handle').style.display = 'block';
          }
          if (document.getElementById('title_color')) {
            document.getElementById('title_color').style.display = 'block';
            document.getElementById('options_color').style.display = 'block';
          }
          document.getElementById('wardrobe_details').style.display = 'none';
          document.getElementById('ikea_instructions').innerText = paosStrings.ikeaUploadInstructions;
          document.getElementById('ikea_title').innerText = paosStrings.ikeaUploadTitle;
          document.getElementById('ikea_placeholder').innerText = paosStrings.ikeaUploadText;
          document.getElementById('comments_title').innerText = paosStrings.ikeaCommentText;

          document.getElementById('stage4mainTitleMob').innerText = paosStrings.ikeaTitle;
          document.getElementById('stage4mainTitleDesktop').innerText = paosStrings.ikeaTitle;
          document.getElementById('stage4textMob').innerHTML = paosStrings.ikeaText;
          document.getElementById('stage4textDesktop').innerHTML = paosStrings.ikeaText;

          document.getElementById('paosPrice').innerHTML = paosStrings.ikeaPrice;
          document.getElementById('stage5textMob').innerHTML = paosStrings.ikeaSummaryText;
          document.getElementById('stage5textDesktop').innerHTML = paosStrings.ikeaSummaryText;
          document.getElementById('stage5titleMob').innerText = paosStrings.ikeaSummaryTitle;
          document.getElementById('stage5titleDesktop').innerText = paosStrings.ikeaSummaryTitle;
          document.getElementById('stage5refund').innerText = paosStrings.ikeaSummaryRefund;

          document.getElementById('summary_measurement_wrapper').style.display = 'none';

          var cardVass = document.getElementById('Vass');
          var cardLalax = document.getElementById('Lalax');
          if (cardVass.classList.contains('opt_selected')) cardVass.click();
          if (cardLalax.classList.contains('opt_selected')) cardLalax.click();

          theme.settings.paosVariantId = theme.settings.paosKitchenId;
        } else if (data_var == 'category' && id.toLowerCase() == 'wardrobe') {
          // show optional text in file upload
          document.getElementById('optional_sel').style.display = 'none';
          if (document.getElementById('title_sink')) {
            document.getElementById('title_sink').style.display = 'none';
            document.getElementById('options_sink').style.display = 'none';
          }
          if (document.getElementById('title_tap')) {
            document.getElementById('title_tap').style.display = 'none';
            document.getElementById('options_tap').style.display = 'none';
          }
          if (document.getElementById('title_stonetop')) {
            document.getElementById('title_stonetop').style.display = 'none';
            document.getElementById('options_stonetop').style.display = 'none';
          }
          /*
                if (document.getElementById("title_handle")) {
                  document.getElementById("title_handle").style.display = "block";
                  document.getElementById("options_handle").style.display = "block";
              } */
          if (document.getElementById('title_color')) {
            document.getElementById('title_color').style.display = 'block';
            document.getElementById('options_color').style.display = 'block';
          }
          document.getElementById('wardrobe_details').style.display = 'block';
          document.getElementById('ikea_instructions').innerText = paosStrings.wardrobeUploadInstructions;
          document.getElementById('ikea_title').innerText = paosStrings.wardrobeUploadTitle;
          document.getElementById('ikea_placeholder').innerText = paosStrings.wardrobeUploadText;
          document.getElementById('comments_title').innerText = paosStrings.wardrobeCommentText;

          document.getElementById('stage4mainTitleMob').innerText = paosStrings.wardrobeTitle;
          document.getElementById('stage4mainTitleDesktop').innerText = paosStrings.wardrobeTitle;
          document.getElementById('stage4textMob').innerHTML = paosStrings.wardrobeText;
          document.getElementById('stage4textDesktop').innerHTML = paosStrings.wardrobeText;

          document.getElementById('paosPrice').innerHTML = paosStrings.wardrobePrice;
          document.getElementById('stage5textMob').innerHTML = paosStrings.wardrobeSummaryText;
          document.getElementById('stage5textDesktop').innerHTML = paosStrings.wardrobeSummaryText;
          document.getElementById('stage5titleMob').innerText = paosStrings.wardrobeSummaryTitle;
          document.getElementById('stage5titleDesktop').innerText = paosStrings.wardrobeSummaryTitle;
          document.getElementById('stage5refund').innerText = paosStrings.wardrobeSummaryRefund;

          document.getElementById('summary_measurement_wrapper').style.display = 'block';

          var cardArk = document.getElementById('ARK');
          if (cardArk.classList.contains('opt_selected')) cardArk.click();

          theme.settings.paosVariantId = theme.settings.paosWardrobeId;
        } else if (data_var == 'category' && id.toLowerCase() != 'wardrobe' && id.toLowerCase() != 'kitchen') {
          // show optional text in file upload
          document.getElementById('optional_sel').style.display = 'inline';
          if (document.getElementById('title_sink')) {
            document.getElementById('title_sink').style.display = 'none';
            document.getElementById('options_sink').style.display = 'none';
          }
          if (document.getElementById('title_tap')) {
            document.getElementById('title_tap').style.display = 'none';
            document.getElementById('options_tap').style.display = 'none';
          }
          if (document.getElementById('title_stonetop')) {
            document.getElementById('title_stonetop').style.display = 'block';
            document.getElementById('options_stonetop').style.display = 'block';
          }
          if (document.getElementById('title_handle')) {
            document.getElementById('title_handle').style.display = 'none';
            document.getElementById('options_handle').style.display = 'none';
          }
          if (document.getElementById('title_color')) {
            document.getElementById('title_color').style.display = 'none';
            document.getElementById('options_color').style.display = 'none';
          }

          theme.settings.paosVariantId = theme.settings.paosKitchenId;
        }

        if (data_var == 'category' && id.toLowerCase().includes('kitchen')) {
          document.getElementById('title_model').classList.remove('hideOpt');
          document.getElementById('options_model').classList.remove('hideOpt');
          document.getElementById('ARK').classList.remove('hideOpt');
          document.getElementById('HAGA').classList.remove('hideOpt');
          document.getElementById('LONNA').classList.remove('hideOpt');
          document.getElementById('VASS').classList.remove('hideOpt');
          document.getElementById('BRAHE').classList.remove('hideOpt');
          document.getElementById('Vass').classList.add('hideOpt');
          document.getElementById('Lalax').classList.add('hideOpt');
          document.getElementById('Brahe').classList.add('hideOpt');
          document.getElementById('stage3title').innerHTML = paosStrings.stage4ikeaTitle;
        }

        if (data_var == 'category' && id.toLowerCase().includes('wardrobe')) {
          document.getElementById('title_model').classList.remove('hideOpt');
          document.getElementById('options_model').classList.remove('hideOpt');
          document.getElementById('ARK').classList.add('hideOpt');
          document.getElementById('HAGA').classList.add('hideOpt');
          document.getElementById('LONNA').classList.add('hideOpt');
          document.getElementById('VASS').classList.add('hideOpt');
          document.getElementById('BRAHE').classList.add('hideOpt');
          document.getElementById('Vass').classList.remove('hideOpt');
          document.getElementById('Lalax').classList.remove('hideOpt');
          document.getElementById('Brahe').classList.remove('hideOpt');
          document.getElementById('stage3title').innerText = paosStrings.stage4wardrobeTitle;
        }

        if (data_var == 'category' && !id.toLowerCase()) {
          document.getElementById('title_model').classList.add('hideOpt');
          document.getElementById('options_model').classList.add('hideOpt');
        }

        // Hide Model option on Other category
        if (data_var == 'category' && (id.toLowerCase().includes('other') || id.toLowerCase().includes('worktop'))) {
          document.getElementById('stage3title').innerText = paosStrings.stage4ikeaTitle;
          document.getElementById('wardrobe_details').style.display = 'none';
          document.getElementById('ikea_instructions').innerText = paosStrings.ikeaUploadInstructions;
          document.getElementById('ikea_title').innerText = paosStrings.ikeaUploadTitle;
          document.getElementById('ikea_placeholder').innerText = paosStrings.ikeaUploadText;

          document.getElementById('stage4mainTitleMob').innerText = paosStrings.ikeaTitle;
          document.getElementById('stage4mainTitleDesktop').innerText = paosStrings.ikeaTitle;
          document.getElementById('stage4textMob').innerHTML = paosStrings.ikeaText;
          document.getElementById('stage4textDesktop').innerHTML = paosStrings.ikeaText;

          document.getElementById('paosPrice').innerHTML = paosStrings.ikeaPrice;
          document.getElementById('stage5textMob').innerHTML = paosStrings.ikeaSummaryText;
          document.getElementById('stage5textDesktop').innerHTML = paosStrings.ikeaSummaryText;
          document.getElementById('stage5titleMob').innerText = paosStrings.ikeaSummaryTitle;
          document.getElementById('stage5titleDesktop').innerText = paosStrings.ikeaSummaryTitle;
          document.getElementById('stage5refund').innerText = paosStrings.ikeaSummaryRefund;

          document.getElementById('summary_measurement_wrapper').style.display = 'none';

          if (document.getElementById('title_model')) {
            document.getElementById('title_model').classList.add('hideOpt');
            document.getElementById('options_model').classList.add('hideOpt');
          }
        } else if (data_var == 'category' && (!id.toLowerCase().includes('other') || !id.toLowerCase().includes('worktop'))) {
          if (document.getElementById('title_model')) {
            document.getElementById('title_model').classList.remove('hideOpt');
            document.getElementById('options_model').classList.remove('hideOpt');
          }
        }

        if ((data_var == 'model' && id.toLowerCase().includes('vass')) || id.toLowerCase().includes('lalax')) {
          document.getElementById('title_handle').style.display = 'none';
          document.getElementById('options_handle').style.display = 'none';
        }

        if (data_var == 'model' && id.toLowerCase().includes('ark')) {
          document.getElementById('title_handle').style.display = 'none';
          document.getElementById('options_handle').style.display = 'none';
        }

        if (data_var == 'model' && id.toLowerCase().includes('samsö')) {
          document.getElementById('title_handle').style.display = 'none';
          document.getElementById('options_handle').style.display = 'none';
        }

        if (data_var == 'model' && ( id.toLowerCase().includes('haga') || id.toLowerCase().includes('lonna') || id.toLowerCase().includes('brahe'))) {
          document.getElementById('title_handle').style.display = 'none';
          document.getElementById('options_handle').style.display = 'none';
        }

        if ((data_var == 'model' && id.toLowerCase().includes('ingarö')) || id.toLowerCase().includes('ensiö')) {
          document.getElementById('title_handle').style.display = 'block';
          document.getElementById('options_handle').style.display = 'block';
        }

        // Hide colors for kitchens
        if (data_var == 'category' && (id.toLowerCase().includes('kitchen') || id.toLowerCase().includes('wardrobe'))) {
          for (var i = 0; i < colorOptions.length; i++) {
            var currentId = colorOptions[i].id;

            var element = document.getElementById(currentId);
            if (element) element.style.display = 'block';

            if (currentId.includes('Ash') && currentId != 'Ash Green') {
              if (element) element.style.display = 'none';
            }

            let milieu_colors = ['Valkoiset', 'Harmaat', 'Beiget', 'Keltaiset', 'Siniset', 'Vihreät', 'Punaiset', 'Mustat'];

            if (milieu_colors.some((color) => currentId.includes(color))) {
              if (element) element.style.display = 'none';
            }

            // Discontinued colours: kept in the swatch list (Milieu paint), never offered in the wizard
            let discontinued_colors = ['Petrol Blue'];

            if (discontinued_colors.includes(currentId)) {
              if (element) element.style.display = 'none';
            }
          }
        }

        // Show colors for Ark
        if (data_var == 'model' && id.toLowerCase().includes('ark')) {
          for (var i = 0; i < colorOptions.length; i++) {
            var currentId = colorOptions[i].id;
            var element = document.getElementById(currentId);

            if (element) {
              if (currentId == 'Misty Ash' || currentId == 'Clay Ash' || currentId == 'Polar Ash') {
                element.style.display = 'block';
              } else {
                element.style.display = 'none';
              }
            }
          }
        }

        // Hide colors for Vass
        if (data_var == 'model' && id.toLowerCase().includes('vass')) {
          for (var i = 0; i < colorOptions.length; i++) {
            var currentId = colorOptions[i].id;
            var element = document.getElementById(currentId);

            if (element) {
              if (currentId == 'Afternoon White' || currentId == 'Ivory Beige' || currentId == 'Sunday Greige' || currentId == 'Amager Grey' || currentId == 'Ash Green' || currentId == 'Dusty Rose') {
                element.style.display = 'block';
              } else {
                element.style.display = 'none';
              }
            }
          }
        }

        // Hide colors for Lalax
        if (data_var == 'model' && id.toLowerCase().includes('lalax')) {
          for (var i = 0; i < colorOptions.length; i++) {
            var currentId = colorOptions[i].id;
            var element = document.getElementById(currentId);

            if (element) {
              if (currentId == 'Natural White' || currentId == 'Ivory Beige' || currentId == 'Ash Green' || currentId == 'Feather Grey') {
                element.style.display = 'block';
              } else {
                element.style.display = 'none';
              }
            }
          }
        }

        // Hide colors for Ingaro, Samso and Ensio
        if (data_var == 'model' && ( id.toLowerCase().includes('ingarö') || id.toLowerCase().includes('samsö') || id.toLowerCase().includes('ensiö') )) {
          for (var i = 0; i < colorOptions.length; i++) {
            var currentId = colorOptions[i].id;
            var element = document.getElementById(currentId);

            if (element) {
              if (currentId == 'Cumulus Grey' || currentId == 'Gustav Blue' || currentId == 'Chalet Oak' || currentId == 'Pure Oak' || currentId == 'Tobacco Oak' || currentId == 'Obsidian Oak' || currentId == 'Natural White Oak' || currentId == 'Afternoon White Oak' || currentId == 'Ivory Beige Oak' || currentId == 'Cumulus Grey Oak' || currentId == 'Gustav Blue Oak' ) {
                element.style.display = 'none';
              } 
            }
          }
        }

        // Hide discontinued oak and walnut finishes for Ensiö
        if (data_var == 'model' && id.toLowerCase().includes('ensiö')) {
          for (var i = 0; i < colorOptions.length; i++) {
            var currentId = colorOptions[i].id;
            var element = document.getElementById(currentId);

            if (element) {
              if (currentId == 'Natural Oak' || currentId == 'White Oak' || currentId == 'Smoke Oak' || currentId == 'Umber Oak' || currentId == 'Natural Walnut') {
                element.style.display = 'none';
              }
            }
          }
        }

        // Hide colors for Haga
        if (data_var == 'model' && ( id.toLowerCase().includes('haga') )) {
          for (var i = 0; i < colorOptions.length; i++) {
            var currentId = colorOptions[i].id;
            var element = document.getElementById(currentId);

            if (element) {
              if (currentId == 'Cumulus Grey' || currentId == 'Gustav Blue' || currentId == 'Chalet Oak' || currentId == 'Pure Oak' || currentId == 'Tobacco Oak' || currentId == 'Obsidian Oak' || currentId == 'Natural White Oak' || currentId == 'Afternoon White Oak' || currentId == 'Ivory Beige Oak' || currentId == 'Cumulus Grey Oak' || currentId == 'Gustav Blue Oak' || currentId == 'Natural Oak' || currentId == 'White Oak' || currentId == 'Smoke Oak'  || currentId == 'Umber Oak' || currentId == 'Natural Walnut') {
                element.style.display = 'none';
              } 
            }
          }
        }

        // Show colors LONNA and BRAHE
        if (data_var == 'model' && ( id.toLowerCase().includes('lonna') || id.toLowerCase().includes('brahe') )) {
          for (var i = 0; i < colorOptions.length; i++) {
            var currentId = colorOptions[i].id;
            var element = document.getElementById(currentId);

            if (element) {
              if (currentId == 'Natural White Oak' || currentId == 'Afternoon White Oak' || currentId == 'Ivory Beige Oak' || currentId == 'Cumulus Grey Oak' || currentId == 'Ash Green Oak' || currentId == 'Gustav Blue Oak' || currentId == 'Chalet Oak' || currentId == 'Pure Oak' || currentId == 'Tobacco Oak') {
                element.style.display = 'block';
              } else {
                element.style.display = 'none';
              }
            }
          }
        }

        return id;
      }
    }
    return false;
  }

  /* wardrobe extras: unticked box = no extras (sent as a plain value); ticked = the chosen cards, joined with " + " */
  function fetch_wardrobe_type(category) {
    if (!(category && category.toLocaleLowerCase().includes('wardrobe'))) {
      return false;
    }
    var toggle = document.getElementById('wardrobe_extras_toggle');
    var wrapper = document.getElementById('wardrobe_type_wrapper');
    if (!toggle || !wrapper) {
      return fetch_option('type');
    }
    if (!toggle.checked) {
      return wrapper.dataset.noExtras;
    }
    var cards = wrapper.getElementsByClassName('data-opt-type');
    var selected = [];
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].classList.contains('opt_selected')) {
        selected.push(cards[i].id);
        /* generate summary view */
        document.getElementById('summary_options').innerHTML += '<div data-opt="type" class="data-opt-type opt-var opt">' + cards[i].innerHTML + '</div>';
      }
    }
    return selected.length > 0 ? selected.join(' + ') : false;
  }

  /* wardrobe extras: restore the ticked box and chosen cards after a reload */
  function set_wardrobe_type() {
    var saved = JSON.parse(window.localStorage.getItem('savedObj'));
    var toggle = document.getElementById('wardrobe_extras_toggle');
    var wrapper = document.getElementById('wardrobe_type_wrapper');
    if (!saved['wardrobeType'] || !toggle || !wrapper) {
      return;
    }
    var ids = String(saved['wardrobeType']).split(' + ');
    for (var i = 0; i < ids.length; i++) {
      var card = document.getElementById(ids[i]);
      if (card && wrapper.contains(card)) {
        card.classList.add('opt_selected');
        toggle.checked = true;
        wrapper.style.display = 'flex';
        /* generate summary view */
        document.getElementById('summary_options').innerHTML += '<div data-opt="type" class="data-opt-type opt-var opt">' + card.innerHTML + '</div>';
      }
    }
  }

  /* wardrobe extras: complete when the box is unticked, or ticked with at least one card chosen */
  function wardrobe_type_complete() {
    var toggle = document.getElementById('wardrobe_extras_toggle');
    if (!toggle || !toggle.checked) {
      return true;
    }
    return document.querySelectorAll('#wardrobe_type_wrapper .data-opt-type.opt_selected').length > 0;
  }

  function select_opt(elem) {
    var element = elem.id;
    var type = elem.dataset.opt;
    /* check active stage dynamically */
    var active_views = document.getElementsByClassName('view');
    for (var i = 0; i < active_views.length; i++) {
      if (active_views[i].style.display == 'flex') {
        var active_id = active_views[i].id;
        var active_stage = active_id.replace('view', '');
      }
    }
    // reset all other elements
    var x = document.getElementsByClassName('data-opt-' + type);
    var i;
    for (i = 0; i < x.length; i++) {
      /* wardrobe extras (type) can be combined, so they don't reset each other */
      if (type != 'type' && x[i].classList.contains('opt_selected') && x[i].id != element) {
        x[i].classList.remove('opt_selected');
      }
    }
    // current elem to set
    if (elem.classList.contains('opt_selected')) {
      elem.classList.remove('opt_selected');
      setTimeout(function () {
        save_to_local_storage(active_stage);
      }, 100);
    } else {
      elem.classList.add('opt_selected');
      setTimeout(function () {
        save_to_local_storage(active_stage);
      }, 100);
    }
  }

  async function btn_click(direction) {
    var v1 = document.getElementById('view1');
    var v2 = document.getElementById('view2');
    var v3 = document.getElementById('view3');
    var v4 = document.getElementById('view4');
    var v5 = document.getElementById('view5');
    var all_views = document.getElementsByClassName('view');
    var n1 = document.getElementById('stage1');
    var n2 = document.getElementById('stage2');
    var n3 = document.getElementById('stage3');
    var n4 = document.getElementById('stage4');
    var all_stages = document.getElementsByClassName('stage');
    var navi = document.getElementById('navigation');
    var navi_inner = document.getElementById('navi_inner');

    if (direction == 'next') {
      if (window.getComputedStyle(v1).display === 'flex') {
        v1.style.display = 'none';
        v2.style.display = 'flex';
        n1.classList.add('active');
        navi_inner.classList.add('navi_inner_1');
        navi.style.display = 'flex';
        save_to_local_storage(2);
      } else if (window.getComputedStyle(v2).display === 'flex') {
        v2.style.display = 'none';
        v3.style.display = 'flex';
        n2.classList.add('active');
        navi_inner.classList.remove('navi_inner_1');
        navi_inner.classList.add('navi_inner_2');
        navi.style.display = 'flex';
        save_to_local_storage(3);
      } else if (window.getComputedStyle(v3).display === 'flex') {
        v3.style.display = 'none';
        v4.style.display = 'flex';
        n3.classList.add('active');
        navi_inner.classList.remove('navi_inner_2');
        navi_inner.classList.add('navi_inner_3');
        navi.style.display = 'flex';
        save_to_local_storage(4);
      } else if (window.getComputedStyle(v4).display === 'flex') {
        v4.style.display = 'none';
        v5.style.display = 'flex';
        n4.classList.add('active');
        navi_inner.classList.remove('navi_inner_3');
        navi_inner.classList.add('navi_inner_4');
        navi.style.display = 'flex';
        save_to_local_storage(5);
      } else if (window.getComputedStyle(v5).display === 'flex') {
        document.getElementById('lay_over_for_preloader').style.display = 'flex';

        let formData = {
          quantity: 1,
          id: theme.settings.paosVariantId,
          note: window.localStorage.getItem('savedObj'),
        };

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
          .then((response) => {
            document.getElementById('lay_over_for_preloader').style.display = 'none';
            localStorage.removeItem('savedObj');
            location.href = '/cart';
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      }
    } else if (direction == 'back') {
      if (window.getComputedStyle(v2).display === 'flex') {
        v1.style.display = 'flex';
        v2.style.display = 'none';
        n1.classList.remove('active');
        navi_inner.classList.remove('navi_inner_1');
        navi_inner.classList.add('navi_inner_0');
        navi.style.display = 'flex';
        save_to_local_storage(1);
      } else if (window.getComputedStyle(v3).display === 'flex') {
        v2.style.display = 'flex';
        v3.style.display = 'none';
        n1.classList.add('active');
        n2.classList.remove('active');
        navi_inner.classList.remove('navi_inner_2');
        navi_inner.classList.add('navi_inner_1');
        navi.style.display = 'flex';
        save_to_local_storage(2);
      } else if (window.getComputedStyle(v4).display === 'flex') {
        v3.style.display = 'flex';
        v4.style.display = 'none';
        n2.classList.add('active');
        n3.classList.remove('active');
        navi_inner.classList.remove('navi_inner_3');
        navi_inner.classList.add('navi_inner_2');
        navi.style.display = 'flex';
        save_to_local_storage(3);
      } else if (window.getComputedStyle(v5).display === 'flex') {
        v4.style.display = 'flex';
        v5.style.display = 'none';
        n3.classList.add('active');
        n4.classList.remove('active');
        navi_inner.classList.remove('navi_inner_4');
        navi_inner.classList.add('navi_inner_3');
        navi.style.display = 'flex';
        save_to_local_storage(4);
      }
    } else {
      // for bullet navigation
      if (document.getElementById('stage' + Number(direction - 1)).classList.contains('active')) {
        let active_state = 'active';

        for (var i = 0; i < all_views.length; i++) {
          if (i != direction - 1) {
            all_views[i].style.display = 'none';
          } else {
            all_views[i].style.display = 'flex';
          }
        }
        for (var i = 0; i < all_stages.length; i++) {
          if (i > direction - 1) {
            all_stages[i].classList.remove('active');
          } else {
            all_stages[i].classList.add('active');
          }
        }
        for (var i = 4; i > 0; i--) {
          if (i != direction - 1) {
            var class_to_remove = 'navi_inner_' + i;
            if (navi_inner.classList.contains(class_to_remove)) {
              navi_inner.classList.remove(class_to_remove);
            }
          } else {
            navi_inner.classList.add('navi_inner_' + String(direction - 1));
          }
        }
        if (direction == 1) {
          //navi.style.display = "none";
        } else {
          navi.style.display = 'flex';
        }
        save_to_local_storage(direction);
      }
    }

    window.scrollTo(0, 0);
  }

  function btn_upload() {
    document.getElementById('hidden_file_upload').click();
  }

  function capture_link() {
    document.getElementById('upload_plan_box').classList.add('file_selected');
    document.getElementById('upload_plan_i_2').classList.add('file_selected2');
    document.getElementById('upload_plan_box_success').style.display = 'block';
    save_to_local_storage(4);
  }

  function remove_file() {
    document.getElementById('hidden_file_upload').value = '';
    document.getElementById('hidden_file_upload_drop').value = '';
    document.getElementById('hidden_file_upload_path').value = '';
    //document.getElementById('filepath-container').innerHTML = ''; /* Uncomment for multiple files */
    document.getElementById("filepath").innerHTML = ""; /* Comment out for multiple files */
    document.getElementById('upload_plan_box_success').style.display = 'none';
    document.getElementById('upload_plan_box').classList.remove('file_selected');
    document.getElementById('upload_plan_i_2').classList.remove('file_selected2');
    document.getElementById('upload_btn1').style.display = 'block';
    document.getElementById('upload_btn2').style.display = 'inline';
    document.getElementById('summary_filepath').innerHTML = '';
    save_to_local_storage(4);
  }
};

  
  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/
  theme.config.hasSessionStorage = theme.isStorageSupported('session');
  theme.config.hasLocalStorage = theme.isStorageSupported('local');
  AOS.init({
    easing: 'ease-out-quad',
    once: true,
    offset: 60,
    disableMutationObserver: true
  });

  if (theme.config.hasLocalStorage) {
    theme.recentlyViewed.localStorage = window.localStorage.getItem('theme-recent');

    if (theme.recentlyViewed.localStorage) {
      theme.recentlyViewed.recent = JSON.parse(theme.recentlyViewed.localStorage);
    }
  }

  theme.recentlyViewed.productInfo = theme.config.hasSessionStorage && sessionStorage['recent-products'] ? JSON.parse(sessionStorage['recent-products']) : {};

  // Trigger events when going between breakpoints
  theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches;
  matchMedia(theme.config.mediaQuerySmall).addListener(function(mql) {
    if (mql.matches) {
      theme.config.bpSmall = true;
      document.dispatchEvent(new CustomEvent('matchSmall'));
    }
    else {
      theme.config.bpSmall = false;
      document.dispatchEvent(new CustomEvent('unmatchSmall'));
    }
  });

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  }

  // Load generic JS. Also reinitializes when sections are
  // added, edited, or removed in Shopify's editor
  theme.initGlobals = function() {
    theme.collapsibles.init();
    theme.drilldowns.init();
    theme.videoModal();
    theme.sampleToggle.markSamples();
    theme.sampleToggle.init();
  }

  DOMready(function(){
    theme.sections = new theme.Sections();

    // sections
    theme.sections.register('header', theme.HeaderSection);
    theme.sections.register('product', theme.Product);
    theme.sections.register('blog', theme.Blog);
    theme.sections.register('password-header', theme.PasswordHeader);
    theme.sections.register('photoswipe', theme.Photoswipe);
    theme.sections.register('product-recommendations', theme.Recommendations);
    theme.sections.register('slideshow-section', theme.SlideshowSection);
    theme.sections.register('background-image', theme.BackgroundImage);
    theme.sections.register('testimonials', theme.Testimonials);
    theme.sections.register('video-section', theme.VideoSection);
    theme.sections.register('map', theme.Maps);
    theme.sections.register('footer-section', theme.FooterSection);
    theme.sections.register('store-availability', theme.StoreAvailability);
    theme.sections.register('recently-viewed', theme.RecentlyViewed);
    theme.sections.register('newsletter-popup', theme.NewsletterPopup);
    theme.sections.register('collection-header', theme.CollectionHeader);
    theme.sections.register('collection-sidebar', theme.CollectionSidebar);
    theme.sections.register('collection-template', theme.Collection);
    theme.sections.register('price-estimate', theme.priceEstimate);
    theme.sections.register('paos', theme.paos);

    theme.initGlobals();
    // theme.initQuickShop();
    theme.rteInit();

    if (document.body.classList.contains('template-cart')) {
      var cartPageForm = document.getElementById('CartPageForm');
      if (cartPageForm) {
        new theme.CartForm(cartPageForm);
      }
    }

    if (theme.settings.predictiveSearch) {
      theme.predictiveSearch.init();
    }

    if (theme.settings.isCustomerTemplate) {
      theme.customerTemplates();
    }

    document.dispatchEvent(new CustomEvent('page:loaded'));

    // Menu region link
    var close_nav_open_region_btn = document.getElementById('CloseNavOpenRegion');
    if (close_nav_open_region_btn !== null) {
      close_nav_open_region_btn.onclick = function() {
        theme.NavDrawer.close();
        setTimeout(function(){ theme.RegionDrawer.open()}, 500);
      }
    }
	  
  	// menu class toggle for megamenu
  	var full_megamenu_navgation = document.getElementById('SiteNav');

  	full_megamenu_navgation.onmouseenter = function(){
      document.getElementById('SiteHeader').classList.add('megamenu-hover');
      document.getElementById('MainContent').classList.add('main-content-dimmer-open');
  	};
      
  	full_megamenu_navgation.onmouseleave = function(){
      document.getElementById('MainContent').classList.remove('main-content-dimmer-open');
  		document.getElementById('MainContent').classList.add('main-content-dimmer-closing');
  	};

    // Paints calculator
    var paintsHeight = document.getElementById('PaintsHeight'),
        paintsWidth = document.getElementById('PaintsWidth'),
        paintsLayers = document.getElementById('PaintsLayers'),
        paintsMessage = document.getElementById('PaintsMessage'),
        addPaintsButton = document.getElementById('AddPaintsButton'),
        paintsQuantity = document.getElementById('PaintsQuantity'),
        literCoverage = parseInt(theme.settings.paintsCoverage),
        productCoverage = literCoverage*4;

    document.querySelectorAll('#PaintsCalculator input').forEach(input => {
      input.on('change', function() {
        if (paintsHeight.value > 0 && paintsWidth.value > 0 && paintsLayers.value > 0) {
          var totalArea = parseFloat(paintsHeight.value*paintsWidth.value*paintsLayers.value).toFixed(2),
              neededProducts = Math.ceil(totalArea/productCoverage),
              neededLiters = Math.ceil(totalArea/literCoverage);
          
          addPaintsButton.removeAttribute('disabled');
          paintsMessage.innerHTML = theme.strings.paintsMessageResult.replace('{{ area }}', totalArea).replace('{{ cans }}', neededProducts).replace('{{ liters }}', neededLiters);
          addPaintsButton.innerHTML = theme.strings.paintsButtonEnabled.replace('{{ cans }}', neededProducts);
          paintsQuantity.value = neededProducts;

        } else {
          addPaintsButton.setAttribute('disabled', 'disabled');
          paintsMessage.innerHTML = theme.strings.paintsMessagePlaceholder;
          addPaintsButton.innerHTML = theme.strings.paintsButtonDisabled;
        }
      })
    });
});

})();


// Patch Flickity resize event for iOS15 jank fix
(function() {
  var originalResizeMethod = Flickity.prototype.resize;
  var lastWidth = window.innerWidth;

  Flickity.prototype.resize = function() {
    if (window.innerWidth === lastWidth) {
      return;
    }

    lastWidth = window.innerWidth;
    originalResizeMethod.apply(this, arguments); // Call original method
  }
})();

// Prevent vertical scroll while using flickity sliders
(function() {
  var e = !1;
  var t;

  document.body.addEventListener('touchstart', function(i) {
    if (!i.target.closest('.flickity-slider')) {
      return e = !1;
      void 0;
    }
    e = !0;
    t = {
      x: i.touches[0].pageX,
      y: i.touches[0].pageY
    }
  })

  document.body.addEventListener('touchmove', function(i) {
    if (e && i.cancelable) {
      var n = {
        x: i.touches[0].pageX - t.x,
        y: i.touches[0].pageY - t.y
      };
      Math.abs(n.x) > Flickity.defaults.dragThreshold && i.preventDefault()
    }
  }, { passive: !1 })
})();

// Scroll to anchor
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();

    const targetId = this.getAttribute('href').substring(1);
    const targetElement = document.getElementById(targetId);

    // Check if the target element exists before scrolling
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' });
    } else {
      console.warn(`Element with ID ${targetId} not found`);
    }
  });
});